import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form,  Button, Message, PlaceholderImage} from 'semantic-ui-react'
import _ from 'lodash';

// import SeguroPermite from '../../../components/funcionales/seguropermite'
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';


import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var moment = require('moment');
//dropdown INFORMES
const DetalleNuminfNivel1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.numeroInflab}</option>
  )
};

const ListaNuminf = ({styles, list, numeroInflab, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNuminfNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="numeroInflab" id="miLista" value={numeroInflab} onChange={(ev)=>handleChange(ev)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown INFORMES

//Lista de mecanismos del informe
const DetallePl = ({elemento, handleClickidLista, numeroInflab}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento, numeroInflab)}>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.mecInflab}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.prioridad?elemento.prioridad:'Normal'}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ruta}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numeroOrden}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ordenSAP?elemento.ordenSAP:''}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codEquipo}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrAplicacion}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tipoFrecuencia}</td>
    </tr>
  )
};

const ListaPl = ({list, handleClickidLista, numeroInflab}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetallePl elemento={elemento}
        handleClickidLista={handleClickidLista} numeroInflab={numeroInflab}
        key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

//FIN Lista de mecanismos del informe

//Lista con datos cargados de mecanismos del informe
const DetallePlDet = ({elemento, indice, handleChange}) => {

  let colorCelda='white'
  if(elemento.observaciones && elemento.acciones){
    colorCelda = 'green'
  }else{
    if(elemento.visco40 || elemento.visco100 || elemento.indice || elemento.pq || elemento.agua || 
      elemento.fischer || elemento.codigoPar || elemento.micras4 || elemento.micras6 || 
      elemento.micras14 || elemento.micras21 || elemento.micras25 || elemento.micras38 || elemento.micras70 || elemento.hollin || 
      elemento.nitracion || elemento.sulfatacion || elemento.dilucion || elemento.glicol || elemento.oxidacion 
      || elemento.tan || elemento.tbn || elemento.tanpte || elemento.tbnpte || 
      elemento.hierro || elemento.cobre || elemento.aluminio || elemento.cromo || elemento.plomo || elemento.estano || elemento.niquel || 
      elemento.vanadio || elemento.titanio || elemento.silicio || elemento.sodio || elemento.potasio || elemento.boro || elemento.magnesio || 
      elemento.calcio || elemento.fosforo || elemento.zinc || elemento.molibdeno || elemento.bario || elemento.manganeso || 
      elemento.color || elemento.rulerP || elemento.rulerA || elemento.rulerF || elemento.rulerZ || elemento.rpvot || elemento.barniz || 
      elemento.demulsibilidadA || elemento.demulsibilidadAg || elemento.demulsibilidadE || elemento.demulsibilidadT || 
      elemento.separaA54 || elemento.separaAg54 || elemento.separaE54 || elemento.separaT54 || 
      elemento.separaA82 || elemento.separaAg82 || elemento.separaE82 || elemento.separaT82 || 
      elemento.espumas1_0 || elemento.espumas1_10 || elemento.espumas2_0 || elemento.espumas2_10 || elemento.espumas3_0 || 
      elemento.espumas3_10 || elemento.liberacion || elemento.inflamacion || elemento.corrosion || elemento.ultracentrifuga || 
      elemento.densidad || elemento.apariencia || elemento.olor || elemento.fuego){
      colorCelda = 'yellow'
    }
  }

  let visco40=elemento.visco40
  if(elemento.visco40 && elemento.visco40V){
    visco40=elemento.visco40 + '\n' +  elemento.visco40V
  }
  
  return(
    
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>
        <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSeleccInf" checked={elemento.checkSeleccInf} onChange={(ev)=>handleChange(ev, indice)}/>
      </td>

      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.mecInflab}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaMuestra}</td>
      {elemento.estado==='' &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estado}</td>
      }
      {elemento.estado==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estado}</td>
      }
      {elemento.estado==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estado}</td>
      }      
      {elemento.estado==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estado}</td>
      }
      {elemento.estado==='NO MEDIDO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estado}</td>
      }
      {elemento.estado==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estado}</td>
      }
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tomaMuestra}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ultimoCambio}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.recorrido}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cambioFiltroAc}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cambioFiltroAire}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aceiteRep}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aceiteTotal}</td>
      {(elemento.visco40E===''||elemento.visco40E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{visco40}</td>
      }
      {elemento.visco40E==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{visco40}</td>
      }
      {elemento.visco40E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{visco40}</td>
      }
      {elemento.visco40E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{visco40}</td>
      }     
      {(elemento.visco100E===''||elemento.visco100E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.visco100V?elemento.visco100 + '(' + elemento.visco100V + ')':elemento.visco100}</td>
      }
      {elemento.visco100E==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.visco100V?elemento.visco100 + '(' + elemento.visco100V + ')':elemento.visco100}</td>
      }
      {elemento.visco100E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.visco100V?elemento.visco100 + '(' + elemento.visco100V + ')':elemento.visco100}</td>
      }
      {elemento.visco100E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.visco100V?elemento.visco100 + '(' + elemento.visco100V + ')':elemento.visco100}</td>
      }     
      {(elemento.indiceE===''||elemento.indiceE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.indiceV?elemento.indice + '(' + elemento.indiceV + ')':elemento.indice}</td>
      }
      {elemento.indiceE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.indiceV?elemento.indice + '(' + elemento.indiceV + ')':elemento.indice}</td>
      }
      {elemento.indiceE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.indiceV?elemento.indice + '(' + elemento.indiceV + ')':elemento.indice}</td>
      }
      {elemento.indiceE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.indiceV?elemento.indice + '(' + elemento.indiceV + ')':elemento.indice}</td>
      }
      {(elemento.aguaE===''||elemento.aguaE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aguaV?elemento.agua + '(' + elemento.aguaV + ')':elemento.agua}</td>
      }
      {elemento.aguaE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aguaV?elemento.agua + '(' + elemento.aguaV + ')':elemento.agua}</td>
      }
      {elemento.aguaE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aguaV?elemento.agua + '(' + elemento.aguaV + ')':elemento.agua}</td>
      }
      {elemento.aguaE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aguaV?elemento.agua + '(' + elemento.aguaV + ')':elemento.agua}</td>
      }     
      {(elemento.codigoParE===''||elemento.codigoParE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codigoParV?elemento.codigoPar + '(' + elemento.codigoParV + ')':elemento.codigoPar}</td>
      }
      {elemento.codigoParE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codigoParV?elemento.codigoPar + '(' + elemento.codigoParV + ')':elemento.codigoPar}</td>
      }
      {elemento.codigoParE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codigoParV?elemento.codigoPar + '(' + elemento.codigoParV + ')':elemento.codigoPar}</td>
      }
      {elemento.codigoParE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codigoParV?elemento.codigoPar + '(' + elemento.codigoParV + ')':elemento.codigoPar}</td>
      }     
      {(elemento.micras4E===''||elemento.micras4E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras4V?elemento.micras4 + '(' + elemento.micras4V + ')':elemento.micras4}</td>
      }
      {elemento.micras4E==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras4V?elemento.micras4 + '(' + elemento.micras4V + ')':elemento.micras4}</td>
      }
      {elemento.micras4E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras4V?elemento.micras4 + '(' + elemento.micras4V + ')':elemento.micras4}</td>
      }
      {elemento.micras4E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras4V?elemento.micras4 + '(' + elemento.micras4V + ')':elemento.micras4}</td>
      }     
      {(elemento.micras6E===''||elemento.micras6E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras6V?elemento.micras6 + '(' + elemento.micras6V + ')':elemento.micras6}</td>
      }
      {elemento.micras6E==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras6V?elemento.micras6 + '(' + elemento.micras6V + ')':elemento.micras6}</td>
      }
      {elemento.micras6E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras6V?elemento.micras6 + '(' + elemento.micras6V + ')':elemento.micras6}</td>
      }
      {elemento.micras6E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras6V?elemento.micras6 + '(' + elemento.micras6V + ')':elemento.micras6}</td>
      }     
      {(elemento.micras14E===''||elemento.micras14E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras14V?elemento.micras14 + '(' + elemento.micras14V + ')':elemento.micras14}</td>
      }
      {elemento.micras14E==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras14V?elemento.micras14 + '(' + elemento.micras14V + ')':elemento.micras14}</td>
      }
      {elemento.micras14E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras14V?elemento.micras14 + '(' + elemento.micras14V + ')':elemento.micras14}</td>
      }
      {elemento.micras14E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras14V?elemento.micras14 + '(' + elemento.micras14V + ')':elemento.micras14}</td>
      }     
      {(elemento.micras21E===''||elemento.micras21E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras21V?elemento.micras21 + '(' + elemento.micras21V + ')':elemento.micras21}</td>
      }
      {elemento.micras21E==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras21V?elemento.micras21 + '(' + elemento.micras21V + ')':elemento.micras21}</td>
      }
      {elemento.micras21E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras21V?elemento.micras21 + '(' + elemento.micras21V + ')':elemento.micras21}</td>
      }
      {elemento.micras21E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras21V?elemento.micras21 + '(' + elemento.micras21V + ')':elemento.micras21}</td>
      }     
      {(elemento.micras25E===''||elemento.micras25E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras25V?elemento.micras25 + '(' + elemento.micras25V + ')':elemento.micras25}</td>
      }
      {elemento.micras25E==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras25V?elemento.micras25 + '(' + elemento.micras25V + ')':elemento.micras25}</td>
      }
      {elemento.micras25E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras25V?elemento.micras25 + '(' + elemento.micras25V + ')':elemento.micras25}</td>
      }
      {elemento.micras25E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras25V?elemento.micras25 + '(' + elemento.micras25V + ')':elemento.micras25}</td>
      }     
      {(elemento.micras38E===''||elemento.micras38E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras38V?elemento.micras38 + '(' + elemento.micras38V + ')':elemento.micras38}</td>
      }
      {elemento.micras38E==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras38V?elemento.micras38 + '(' + elemento.micras38V + ')':elemento.micras38}</td>
      }
      {elemento.micras38E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras38V?elemento.micras38 + '(' + elemento.micras38V + ')':elemento.micras38}</td>
      }
      {elemento.micras38E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras38V?elemento.micras38 + '(' + elemento.micras38V + ')':elemento.micras38}</td>
      }     
      {(elemento.micras70E===''||elemento.micras70E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras70V?elemento.micras70 + '(' + elemento.micras70V + ')':elemento.micras70}</td>
      }
      {elemento.micras70E==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras70V?elemento.micras70 + '(' + elemento.micras70V + ')':elemento.micras70}</td>
      }
      {elemento.micras70E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras70V?elemento.micras70 + '(' + elemento.micras70V + ')':elemento.micras70}</td>
      }
      {elemento.micras70E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras70V?elemento.micras70 + '(' + elemento.micras70V + ')':elemento.micras70}</td>
      }     
      {(elemento.hollinE===''||elemento.hollinE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.hollinV?elemento.hollin + '(' + elemento.hollinV + ')':elemento.hollin}</td>
      }
      {elemento.hollinE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.hollinV?elemento.hollin + '(' + elemento.hollinV + ')':elemento.hollin}</td>
      }
      {elemento.hollinE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.hollinV?elemento.hollin + '(' + elemento.hollinV + ')':elemento.hollin}</td>
      }
      {elemento.hollinE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.hollinV?elemento.hollin + '(' + elemento.hollinV + ')':elemento.hollin}</td>
      }     
      {(elemento.nitracionE===''||elemento.nitracionE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nitracionV?elemento.nitracion + '(' + elemento.nitracionV + ')':elemento.nitracion}</td>
      }
      {elemento.nitracionE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nitracionV?elemento.nitracion + '(' + elemento.nitracionV + ')':elemento.nitracion}</td>
      }
      {elemento.nitracionE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nitracionV?elemento.nitracion + '(' + elemento.nitracionV + ')':elemento.nitracion}</td>
      }
      {elemento.nitracionE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nitracionV?elemento.nitracion + '(' + elemento.nitracionV + ')':elemento.nitracion}</td>
      }     
      {(elemento.sulfatacionE===''||elemento.sulfatacionE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.sulfatacionV?elemento.sulfatacion + '(' + elemento.sulfatacionV + ')':elemento.sulfatacion}</td>
      }
      {elemento.sulfatacionE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.sulfatacionV?elemento.sulfatacion + '(' + elemento.sulfatacionV + ')':elemento.sulfatacion}</td>
      }
      {elemento.sulfatacionE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.sulfatacionV?elemento.sulfatacion + '(' + elemento.sulfatacionV + ')':elemento.sulfatacion}</td>
      }
      {elemento.sulfatacionE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.sulfatacionV?elemento.sulfatacion + '(' + elemento.sulfatacionV + ')':elemento.sulfatacion}</td>
      }     
      {(elemento.dilucionE===''||elemento.dilucionE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.dilucionV?elemento.dilucion + '(' + elemento.dilucionV + ')':elemento.dilucion}</td>
      }
      {elemento.dilucionE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.dilucionV?elemento.dilucion + '(' + elemento.dilucionV + ')':elemento.dilucion}</td>
      }
      {elemento.dilucionE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.dilucionV?elemento.dilucion + '(' + elemento.dilucionV + ')':elemento.dilucion}</td>
      }
      {elemento.dilucionE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.dilucionV?elemento.dilucion + '(' + elemento.dilucionV + ')':elemento.dilucion}</td>
      }     
      {(elemento.glicolE===''||elemento.glicolE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.glicolV?elemento.glicol + '(' + elemento.glicolV + ')':elemento.glicol}</td>
      }
      {elemento.glicolE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.glicolV?elemento.glicol + '(' + elemento.glicolV + ')':elemento.glicol}</td>
      }
      {elemento.glicolE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.glicolV?elemento.glicol + '(' + elemento.glicolV + ')':elemento.glicol}</td>
      }
      {elemento.glicolE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.glicolV?elemento.glicol + '(' + elemento.glicolV + ')':elemento.glicol}</td>
      }     
      {(elemento.oxidacionE===''||elemento.oxidacionE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.oxidacionV?elemento.oxidacion + '(' + elemento.oxidacionV + ')':elemento.oxidacion}</td>
      }
      {elemento.oxidacionE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.oxidacionV?elemento.oxidacion + '(' + elemento.oxidacionV + ')':elemento.oxidacion}</td>
      }
      {elemento.oxidacionE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.oxidacionV?elemento.oxidacion + '(' + elemento.oxidacionV + ')':elemento.oxidacion}</td>
      }
      {elemento.oxidacionE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.oxidacionV?elemento.oxidacion + '(' + elemento.oxidacionV + ')':elemento.oxidacion}</td>
      }     
      {(elemento.tanE===''||elemento.tanE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tanV?elemento.tan + '(' + elemento.tanV + ')':elemento.tan}</td>
      }
      {elemento.tanE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tanV?elemento.tan + '(' + elemento.tanV + ')':elemento.tan}</td>
      }
      {elemento.tanE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tanV?elemento.tan + '(' + elemento.tanV + ')':elemento.tan}</td>
      }
      {elemento.tanE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tanV?elemento.tan + '(' + elemento.tanV + ')':elemento.tan}</td>
      }     
      {(elemento.tbnE===''||elemento.tbnE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tbnV?elemento.tbn + '(' + elemento.tbnV + ')':elemento.tbn}</td>
      }
      {elemento.tbnE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tbnV?elemento.tbn + '(' + elemento.tbnV + ')':elemento.tbn}</td>
      }
      {elemento.tbnE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tbnV?elemento.tbn + '(' + elemento.tbnV + ')':elemento.tbn}</td>
      }
      {elemento.tbnE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tbnV?elemento.tbn + '(' + elemento.tbnV + ')':elemento.tbn}</td>
      }     
      {(elemento.hierroE===''||elemento.hierroE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.hierroV?elemento.hierro + '(' + elemento.hierroV + ')':elemento.hierro}</td>
      }
      {elemento.hierroE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.hierroV?elemento.hierro + '(' + elemento.hierroV + ')':elemento.hierro}</td>
      }
      {elemento.hierroE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.hierroV?elemento.hierro + '(' + elemento.hierroV + ')':elemento.hierro}</td>
      }
      {elemento.hierroE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.hierroV?elemento.hierro + '(' + elemento.hierroV + ')':elemento.hierro}</td>
      }     
      {(elemento.cobreE===''||elemento.cobreE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cobreV?elemento.cobre + '(' + elemento.cobreV + ')':elemento.cobre}</td>
      }
      {elemento.cobreE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cobreV?elemento.cobre + '(' + elemento.cobreV + ')':elemento.cobre}</td>
      }
      {elemento.cobreE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cobreV?elemento.cobre + '(' + elemento.cobreV + ')':elemento.cobre}</td>
      }
      {elemento.cobreE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cobreV?elemento.cobre + '(' + elemento.cobreV + ')':elemento.cobre}</td>
      }     
      {(elemento.aluminioE===''||elemento.aluminioE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aluminioV?elemento.aluminio + '(' + elemento.aluminioV + ')':elemento.aluminio}</td>
      }
      {elemento.aluminioE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aluminioV?elemento.aluminio + '(' + elemento.aluminioV + ')':elemento.aluminio}</td>
      }
      {elemento.aluminioE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aluminioV?elemento.aluminio + '(' + elemento.aluminioV + ')':elemento.aluminio}</td>
      }
      {elemento.aluminioE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aluminioV?elemento.aluminio + '(' + elemento.aluminioV + ')':elemento.aluminio}</td>
      }     
      {(elemento.cromoE===''||elemento.cromoE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cromoV?elemento.cromo + '(' + elemento.cromoV + ')':elemento.cromo}</td>
      }
      {elemento.cromoE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cromoV?elemento.cromo + '(' + elemento.cromoV + ')':elemento.cromo}</td>
      }
      {elemento.cromoE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cromoV?elemento.cromo + '(' + elemento.cromoV + ')':elemento.cromo}</td>
      }
      {elemento.cromoE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cromoV?elemento.cromo + '(' + elemento.cromoV + ')':elemento.cromo}</td>
      }     
      {(elemento.plomoE===''||elemento.plomoE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.plomoV?elemento.plomo + '(' + elemento.plomoV + ')':elemento.plomo}</td>
      }
      {elemento.plomoE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.plomoV?elemento.plomo + '(' + elemento.plomoV + ')':elemento.plomo}</td>
      }
      {elemento.plomoE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.plomoV?elemento.plomo + '(' + elemento.plomoV + ')':elemento.plomo}</td>
      }
      {elemento.plomoE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.plomoV?elemento.plomo + '(' + elemento.plomoV + ')':elemento.plomo}</td>
      }     
      {(elemento.estanoE===''||elemento.estanoE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estanoV?elemento.estano + '(' + elemento.estanoV + ')':elemento.estano}</td>
      }
      {elemento.estanoE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estanoV?elemento.estano + '(' + elemento.estanoV + ')':elemento.estano}</td>
      }
      {elemento.estanoE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estanoV?elemento.estano + '(' + elemento.estanoV + ')':elemento.estano}</td>
      }
      {elemento.estanoE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estanoV?elemento.estano + '(' + elemento.estanoV + ')':elemento.estano}</td>
      }     
      {(elemento.niquelE===''||elemento.niquelE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.niquelV?elemento.niquel + '(' + elemento.niquelV + ')':elemento.niquel}</td>
      }
      {elemento.niquelE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.niquelV?elemento.niquel + '(' + elemento.niquelV + ')':elemento.niquel}</td>
      }
      {elemento.niquelE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.niquelV?elemento.niquel + '(' + elemento.niquelV + ')':elemento.niquel}</td>
      }
      {elemento.niquelE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.niquelV?elemento.niquel + '(' + elemento.niquelV + ')':elemento.niquel}</td>
      }     
      {(elemento.vanadioE===''||elemento.vanadioE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.vanadioV?elemento.vanadio + '(' + elemento.vanadioV + ')':elemento.vanadio}</td>
      }
      {elemento.vanadioE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.vanadioV?elemento.vanadio + '(' + elemento.vanadioV + ')':elemento.vanadio}</td>
      }
      {elemento.vanadioE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.vanadioV?elemento.vanadio + '(' + elemento.vanadioV + ')':elemento.vanadio}</td>
      }
      {elemento.vanadioE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.vanadioV?elemento.vanadio + '(' + elemento.vanadioV + ')':elemento.vanadio}</td>
      }     
      {(elemento.titanioE===''||elemento.titanioE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.titanioV?elemento.titanio + '(' + elemento.titanioV + ')':elemento.titanio}</td>
      }
      {elemento.titanioE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.titanioV?elemento.titanio + '(' + elemento.titanioV + ')':elemento.titanio}</td>
      }
      {elemento.titanioE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.titanioV?elemento.titanio + '(' + elemento.titanioV + ')':elemento.titanio}</td>
      }
      {elemento.titanioE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.titanioV?elemento.titanio + '(' + elemento.titanioV + ')':elemento.titanio}</td>
      }
      {(elemento.silicioE===''||elemento.silicioE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.silicioV?elemento.silicio + '(' + elemento.silicioV + ')':elemento.silicio}</td>
      }
      {elemento.silicioE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.silicioV?elemento.silicio + '(' + elemento.silicioV + ')':elemento.silicio}</td>
      }
      {elemento.silicioE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.silicioV?elemento.silicio + '(' + elemento.silicioV + ')':elemento.silicio}</td>
      }
      {elemento.silicioE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.silicioV?elemento.silicio + '(' + elemento.silicioV + ')':elemento.silicio}</td>
      }     
      {(elemento.sodioE===''||elemento.sodioE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.sodioV?elemento.sodio + '(' + elemento.sodioV + ')':elemento.sodio}</td>
      }
      {elemento.sodioE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.sodioV?elemento.sodio + '(' + elemento.sodioV + ')':elemento.sodio}</td>
      }
      {elemento.sodioE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.sodioV?elemento.sodio + '(' + elemento.sodioV + ')':elemento.sodio}</td>
      }
      {elemento.sodioE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.sodioV?elemento.sodio + '(' + elemento.sodioV + ')':elemento.sodio}</td>
      }     
      {(elemento.potasioE===''||elemento.potasioE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.potasioV?elemento.potasio + '(' + elemento.potasioV + ')':elemento.potasio}</td>
      }
      {elemento.potasioE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.potasioV?elemento.potasio + '(' + elemento.potasioV + ')':elemento.potasio}</td>
      }
      {elemento.potasioE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.potasioV?elemento.potasio + '(' + elemento.potasioV + ')':elemento.potasio}</td>
      }
      {elemento.potasioE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.potasioV?elemento.potasio + '(' + elemento.potasioV + ')':elemento.potasio}</td>
      }     
      {(elemento.boroE===''||elemento.boroE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.boroV?elemento.boro + '(' + elemento.boroV + ')':elemento.boro}</td>
      }
      {elemento.boroE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.boroV?elemento.boro + '(' + elemento.boroV + ')':elemento.boro}</td>
      }
      {elemento.boroE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.boroV?elemento.boro + '(' + elemento.boroV + ')':elemento.boro}</td>
      }
      {elemento.boroE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.boroV?elemento.boro + '(' + elemento.boroV + ')':elemento.boro}</td>
      }     
      {(elemento.magnesioE===''||elemento.magnesioE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.magnesioV?elemento.magnesio + '(' + elemento.magnesioV + ')':elemento.magnesio}</td>
      }
      {elemento.magnesioE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.magnesioV?elemento.magnesio + '(' + elemento.magnesioV + ')':elemento.magnesio}</td>
      }
      {elemento.magnesioE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.magnesioV?elemento.magnesio + '(' + elemento.magnesioV + ')':elemento.magnesio}</td>
      }
      {elemento.magnesioE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.magnesioV?elemento.magnesio + '(' + elemento.magnesioV + ')':elemento.magnesio}</td>
      }     
      {(elemento.calcioE===''||elemento.calcioE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.calcioV?elemento.calcio + '(' + elemento.calcioV + ')':elemento.calcio}</td>
      }
      {elemento.calcioE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.calcioV?elemento.calcio + '(' + elemento.calcioV + ')':elemento.calcio}</td>
      }
      {elemento.calcioE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.calcioV?elemento.calcio + '(' + elemento.calcioV + ')':elemento.calcio}</td>
      }
      {elemento.calcioE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.calcioV?elemento.calcio + '(' + elemento.calcioV + ')':elemento.calcio}</td>
      }     
      {(elemento.fosforoE===''||elemento.fosforoE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fosforoV?elemento.fosforo + '(' + elemento.fosforoV + ')':elemento.fosforo}</td>
      }
      {elemento.fosforoE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fosforoV?elemento.fosforo + '(' + elemento.fosforoV + ')':elemento.fosforo}</td>
      }
      {elemento.fosforoE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fosforoV?elemento.fosforo + '(' + elemento.fosforoV + ')':elemento.fosforo}</td>
      }
      {elemento.fosforoE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fosforoV?elemento.fosforo + '(' + elemento.fosforoV + ')':elemento.fosforo}</td>
      }     
      {(elemento.zincE===''||elemento.zincE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.zincV?elemento.zinc + '(' + elemento.zincV + ')':elemento.zinc}</td>
      }
      {elemento.zincE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.zincV?elemento.zinc + '(' + elemento.zincV + ')':elemento.zinc}</td>
      }
      {elemento.zincE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.zincV?elemento.zinc + '(' + elemento.zincV + ')':elemento.zinc}</td>
      }
      {elemento.zincE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.zincV?elemento.zinc + '(' + elemento.zincV + ')':elemento.zinc}</td>
      }     
      {(elemento.molibdenoE===''||elemento.molibdenoE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.molibdenoV?elemento.molibdeno + '(' + elemento.molibdenoV + ')':elemento.molibdeno}</td>
      }
      {elemento.molibdenoE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.molibdenoV?elemento.molibdeno + '(' + elemento.molibdenoV + ')':elemento.molibdeno}</td>
      }
      {elemento.molibdenoE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.molibdenoV?elemento.molibdeno + '(' + elemento.molibdenoV + ')':elemento.molibdeno}</td>
      }
      {elemento.molibdenoE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.molibdenoV?elemento.molibdeno + '(' + elemento.molibdenoV + ')':elemento.molibdeno}</td>
      }     
      {(elemento.barioE===''||elemento.barioE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.barioV?elemento.bario + '(' + elemento.barioV + ')':elemento.bario}</td>
      }
      {elemento.barioE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.barioV?elemento.bario + '(' + elemento.barioV + ')':elemento.bario}</td>
      }
      {elemento.barioE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.barioV?elemento.bario + '(' + elemento.barioV + ')':elemento.bario}</td>
      }
      {elemento.barioE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.barioV?elemento.bario + '(' + elemento.barioV + ')':elemento.bario}</td>
      }     
      {(elemento.manganesoE===''||elemento.manganesoE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.manganesoV?elemento.manganeso + '(' + elemento.manganesoV + ')':elemento.manganeso}</td>
      }
      {elemento.manganesoE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.manganesoV?elemento.manganeso + '(' + elemento.manganesoV + ')':elemento.manganeso}</td>
      }
      {elemento.manganesoE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.manganesoV?elemento.manganeso + '(' + elemento.manganesoV + ')':elemento.manganeso}</td>
      }
      {elemento.manganesoE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.manganesoV?elemento.manganeso + '(' + elemento.manganesoV + ')':elemento.manganeso}</td>
      }     
      {(elemento.colorE===''||elemento.colorE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.colorV?elemento.color + '(' + elemento.colorV + ')':elemento.color}</td>
      }
      {elemento.colorE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.colorV?elemento.color + '(' + elemento.colorV + ')':elemento.color}</td>
      }
      {elemento.colorE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.colorV?elemento.color + '(' + elemento.colorV + ')':elemento.color}</td>
      }
      {elemento.colorE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.colorV?elemento.color + '(' + elemento.colorV + ')':elemento.color}</td>
      }     
      {elemento.colorE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.colorV?elemento.color + '(' + elemento.colorV + ')':elemento.color}</td>
      }     
      {(elemento.rulerPE===''||elemento.rulerPE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerPV?elemento.rulerP + '(' + elemento.rulerPV + ')':elemento.rulerP}</td>
      }
      {elemento.rulerPE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerPV?elemento.rulerP + '(' + elemento.rulerPV + ')':elemento.rulerP}</td>
      }
      {elemento.rulerPE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerPV?elemento.rulerP + '(' + elemento.rulerPV + ')':elemento.rulerP}</td>
      }
      {elemento.rulerPE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerPV?elemento.rulerP + '(' + elemento.rulerPV + ')':elemento.rulerP}</td>
      }     
      {elemento.rulerPE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerPV?elemento.rulerP + '(' + elemento.rulerPV + ')':elemento.rulerP}</td>
      }  
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerAV?elemento.rulerA + '(' + elemento.rulerAV + ')':elemento.rulerA}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerFV?elemento.rulerF + '(' + elemento.rulerFV + ')':elemento.rulerF}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerZV?elemento.rulerZ + '(' + elemento.rulerZV + ')':elemento.rulerZ}</td>
      {(elemento.rpvotE===''||elemento.rpvotE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rpvotV?elemento.rpvot + '(' + elemento.rpvotV + ')':elemento.rpvot}</td>
      }
      {elemento.rpvotE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rpvotV?elemento.rpvot + '(' + elemento.rpvotV + ')':elemento.rpvot}</td>
      }
      {elemento.rpvotE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rpvotV?elemento.rpvot + '(' + elemento.rpvotV + ')':elemento.rpvot}</td>
      }
      {elemento.rpvotE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rpvotV?elemento.rpvot + '(' + elemento.rpvotV + ')':elemento.rpvot}</td>
      }     
      {elemento.rpvotE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rpvotV?elemento.rpvot + '(' + elemento.rpvotV + ')':elemento.rpvot}</td>
      }     
      {(elemento.barnizE===''||elemento.barnizE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.barnizV?elemento.barniz + '(' + elemento.barnizV + ')':elemento.barniz}</td>
      }
      {elemento.barnizE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.barnizV?elemento.barniz + '(' + elemento.barnizV + ')':elemento.barniz}</td>
      }
      {elemento.barnizE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.barnizV?elemento.barniz + '(' + elemento.barnizV + ')':elemento.barniz}</td>
      }
      {elemento.barnizE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.barnizV?elemento.barniz + '(' + elemento.barnizV + ')':elemento.barniz}</td>
      }     
      {elemento.barnizE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.barnizV?elemento.barniz + '(' + elemento.barnizV + ')':elemento.barniz}</td>
      }     
      {(elemento.demulsibilidadAE===''||elemento.demulsibilidadAE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadAV?elemento.demulsibilidadA + '(' + elemento.demulsibilidadAV + ')':elemento.demulsibilidadA}</td>
      }
      {elemento.demulsibilidadAE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadAV?elemento.demulsibilidadA + '(' + elemento.demulsibilidadAV + ')':elemento.demulsibilidadA}</td>
      }
      {elemento.demulsibilidadAE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadAV?elemento.demulsibilidadA + '(' + elemento.demulsibilidadAV + ')':elemento.demulsibilidadA}</td>
      }
      {elemento.demulsibilidadAE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadAV?elemento.demulsibilidadA + '(' + elemento.demulsibilidadAV + ')':elemento.demulsibilidadA}</td>
      }     
      {elemento.demulsibilidadAE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadAV?elemento.demulsibilidadA + '(' + elemento.demulsibilidadAV + ')':elemento.demulsibilidadA}</td>
      }     
      {(elemento.demulsibilidadAgE===''||elemento.demulsibilidadAgE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadAgV?elemento.demulsibilidadAg + '(' + elemento.demulsibilidadAgV + ')':elemento.demulsibilidadAg}</td>
      }
      {elemento.demulsibilidadAgE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadAgV?elemento.demulsibilidadAg + '(' + elemento.demulsibilidadAgV + ')':elemento.demulsibilidadAg}</td>
      }
      {elemento.demulsibilidadAgE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadAgV?elemento.demulsibilidadAg + '(' + elemento.demulsibilidadAgV + ')':elemento.demulsibilidadgAg}</td>
      }
      {elemento.demulsibilidadAgE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadAgV?elemento.demulsibilidadAg + '(' + elemento.demulsibilidadAgV + ')':elemento.demulsibilidadAg}</td>
      }     
      {elemento.demulsibilidadAgE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadAgV?elemento.demulsibilidadAg + '(' + elemento.demulsibilidadAgV + ')':elemento.demulsibilidadAg}</td>
      }     
      {(elemento.demulsibilidadEE===''||elemento.demulsibilidadEE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadEV?elemento.demulsibilidadE + '(' + elemento.demulsibilidadEV + ')':elemento.demulsibilidadE}</td>
      }
      {elemento.demulsibilidadEE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadEV?elemento.demulsibilidadE + '(' + elemento.demulsibilidadEV + ')':elemento.demulsibilidadE}</td>
      }
      {elemento.demulsibilidadEE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadEV?elemento.demulsibilidadE + '(' + elemento.demulsibilidadEV + ')':elemento.demulsibilidadE}</td>
      }
      {elemento.demulsibilidadEE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadEV?elemento.demulsibilidadE + '(' + elemento.demulsibilidadEV + ')':elemento.demulsibilidadE}</td>
      }     
      {elemento.demulsibilidadEE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadEV?elemento.demulsibilidadE + '(' + elemento.demulsibilidadEV + ')':elemento.demulsibilidadE}</td>
      }     
      {(elemento.demulsibilidadTE===''||elemento.demulsibilidadTE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadTV?elemento.demulsibilidadT + '(' + elemento.demulsibilidadTV + ')':elemento.demulsibilidadT}</td>
      }
      {elemento.demulsibilidadTE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadTV?elemento.demulsibilidadT + '(' + elemento.demulsibilidadTV + ')':elemento.demulsibilidadT}</td>
      }
      {elemento.demulsibilidadTE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadTV?elemento.demulsibilidadT + '(' + elemento.demulsibilidadTV + ')':elemento.demulsibilidadT}</td>
      }
      {elemento.demulsibilidadTE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadTV?elemento.demulsibilidadT + '(' + elemento.demulsibilidadTV + ')':elemento.demulsibilidadT}</td>
      }     
      {elemento.demulsibilidadTE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadTV?elemento.demulsibilidadT + '(' + elemento.demulsibilidadTV + ')':elemento.demulsibilidadT}</td>
      }     
      {(elemento.separaA54E===''||elemento.separaA54E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA54V?elemento.separaA54 + '(' + elemento.separaA54V + ')':elemento.separaA54}</td>
      }
      {elemento.separaA54E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA54V?elemento.separaA54 + '(' + elemento.separaA54V + ')':elemento.separaA54}</td>
      }
      {elemento.separaA54E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA54V?elemento.separaA54 + '(' + elemento.separaA54V + ')':elemento.separaA54}</td>
      }
      {elemento.separaA54E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA54V?elemento.separaA54 + '(' + elemento.separaA54V + ')':elemento.separaA54}</td>
      }     
      {elemento.separaA54E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA54V?elemento.separaA54 + '(' + elemento.separaA54V + ')':elemento.separaA54}</td>
      }     
      {(elemento.separaAg54E===''||elemento.separaAg54E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg54V?elemento.separaAg54 + '(' + elemento.separaAg54V + ')':elemento.separaAg54}</td>
      }
      {elemento.separaAg54E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg54V?elemento.separaAg54 + '(' + elemento.separaAg54V + ')':elemento.separaAg54}</td>
      }
      {elemento.separaAg54E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg54V?elemento.separaAg54 + '(' + elemento.separaAg54V + ')':elemento.separaAg54}</td>
      }
      {elemento.separaAg54E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg54V?elemento.separaAg54 + '(' + elemento.separaAg54V + ')':elemento.separaAg54}</td>
      }     
      {elemento.separaAg54E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg54V?elemento.separaAg54 + '(' + elemento.separaAg54V + ')':elemento.separaAg54}</td>
      }     
      {(elemento.separaE54E===''||elemento.separaE54E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE54V?elemento.separaE54 + '(' + elemento.separaE54V + ')':elemento.separaE54}</td>
      }
      {elemento.separaE54E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE54V?elemento.separaE54 + '(' + elemento.separaE54V + ')':elemento.separaE54}</td>
      }
      {elemento.separaE54E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE54V?elemento.separaE54 + '(' + elemento.separaE54V + ')':elemento.separaE54}</td>
      }
      {elemento.separaE54E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE54V?elemento.separaE54 + '(' + elemento.separaE54V + ')':elemento.separaE54}</td>
      }     
      {elemento.separaE54E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE54V?elemento.separaE54 + '(' + elemento.separaE54V + ')':elemento.separaE54}</td>
      }     
      {(elemento.separaT54E===''||elemento.separaT54E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT54V?elemento.separaT54 + '(' + elemento.separaT54V + ')':elemento.separaT54}</td>
      }
      {elemento.separaT54E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT54V?elemento.separaT54 + '(' + elemento.separaT54V + ')':elemento.separaT54}</td>
      }
      {elemento.separaT54E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT54V?elemento.separaT54 + '(' + elemento.separaT54V + ')':elemento.separaT54}</td>
      }
      {elemento.separaT54E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT54V?elemento.separaT54 + '(' + elemento.separaT54V + ')':elemento.separaT54}</td>
      }     
      {elemento.separaT54E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT54V?elemento.separaT54 + '(' + elemento.separaT54V + ')':elemento.separaT54}</td>
      }     
      {(elemento.separaA82E===''||elemento.separaA82E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA82V?elemento.separaA82 + '(' + elemento.separaA82V + ')':elemento.separaA82}</td>
      }
      {elemento.separaA82E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA82V?elemento.separaA82 + '(' + elemento.separaA82V + ')':elemento.separaA82}</td>
      }
      {elemento.separaA82E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA82V?elemento.separaA82 + '(' + elemento.separaA82V + ')':elemento.separaA82}</td>
      }
      {elemento.separaA82E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA82V?elemento.separaA82 + '(' + elemento.separaA82V + ')':elemento.separaA82}</td>
      }     
      {elemento.separaA82E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA82V?elemento.separaA82 + '(' + elemento.separaA82V + ')':elemento.separaA82}</td>
      }     
      {(elemento.separaAg82E===''||elemento.separaAg82E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg82V?elemento.separaAg82 + '(' + elemento.separaAg82V + ')':elemento.separaAg82}</td>
      }
      {elemento.separaAg82E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg82V?elemento.separaAg82 + '(' + elemento.separaAg82V + ')':elemento.separaAg82}</td>
      }
      {elemento.separaAg82E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg82V?elemento.separaAg82 + '(' + elemento.separaAg82V + ')':elemento.separaAg82}</td>
      }
      {elemento.separaAg82E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg82V?elemento.separaAg82 + '(' + elemento.separaAg82V + ')':elemento.separaAg82}</td>
      }     
      {elemento.separaAg82E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg82V?elemento.separaAg82 + '(' + elemento.separaAg82V + ')':elemento.separaAg82}</td>
      }     
      {(elemento.separaE82E===''||elemento.separaE82E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE82V?elemento.separaE82 + '(' + elemento.separaE82V + ')':elemento.separaE82}</td>
      }
      {elemento.separaE82E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE82V?elemento.separaE82 + '(' + elemento.separaE82V + ')':elemento.separaE82}</td>
      }
      {elemento.separaE82E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE82V?elemento.separaE82 + '(' + elemento.separaE82V + ')':elemento.separaE82}</td>
      }
      {elemento.separaE82E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE82V?elemento.separaE82 + '(' + elemento.separaE82V + ')':elemento.separaE82}</td>
      }     
      {elemento.separaE82E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE82V?elemento.separaE82 + '(' + elemento.separaE82V + ')':elemento.separaE82}</td>
      }     
      {(elemento.separaT82E===''||elemento.separaT82E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT82V?elemento.separaT82 + '(' + elemento.separaT82V + ')':elemento.separaT82}</td>
      }
      {elemento.separaT82E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT82V?elemento.separaT82 + '(' + elemento.separaT82V + ')':elemento.separaT82}</td>
      }
      {elemento.separaT82E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT82V?elemento.separaT82 + '(' + elemento.separaT82V + ')':elemento.separaT82}</td>
      }
      {elemento.separaT82E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT82V?elemento.separaT82 + '(' + elemento.separaT82V + ')':elemento.separaT82}</td>
      }     
      {elemento.separaT82E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT82V?elemento.separaT82 + '(' + elemento.separaT82V + ')':elemento.separaT82}</td>
      }     
      {(elemento.espumas1_0E===''||elemento.espumas1_0E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_0V?elemento.espumas1_0 + '(' + elemento.espumas1_0V + ')':elemento.espumas1_0}</td>
      }
      {elemento.espumas1_0E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_0V?elemento.espumas1_0 + '(' + elemento.espumas1_0V + ')':elemento.espumas1_0}</td>
      }
      {elemento.espumas1_0E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_0V?elemento.espumas1_0 + '(' + elemento.espumas1_0V + ')':elemento.espumas1_0}</td>
      }
      {elemento.espumas1_0E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_0V?elemento.espumas1_0 + '(' + elemento.espumas1_0V + ')':elemento.espumas1_0}</td>
      }     
      {elemento.espumas1_0E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_0V?elemento.espumas1_0 + '(' + elemento.espumas1_0V + ')':elemento.espumas1_0}</td>
      }     
      {(elemento.espumas1_10E===''||elemento.espumas1_10E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_10V?elemento.espumas1_10 + '(' + elemento.espumas1_10V + ')':elemento.espumas1_10}</td>
      }
      {elemento.espumas1_10E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_10V?elemento.espumas1_10 + '(' + elemento.espumas1_10V + ')':elemento.espumas1_10}</td>
      }
      {elemento.espumas1_10E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_10V?elemento.espumas1_10 + '(' + elemento.espumas1_10V + ')':elemento.espumas1_10}</td>
      }
      {elemento.espumas1_10E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_10V?elemento.espumas1_10 + '(' + elemento.espumas1_10V + ')':elemento.espumas1_10}</td>
      }     
      {elemento.espumas1_10E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_10V?elemento.espumas1_10 + '(' + elemento.espumas1_10V + ')':elemento.espumas1_10}</td>
      }     
      {(elemento.espumas2_0E===''||elemento.espumas2_0E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_0V?elemento.espumas2_0 + '(' + elemento.espumas2_0V + ')':elemento.espumas2_0}</td>
      }
      {elemento.espumas2_0E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_0V?elemento.espumas2_0 + '(' + elemento.espumas2_0V + ')':elemento.espumas2_0}</td>
      }
      {elemento.espumas2_0E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_0V?elemento.espumas2_0 + '(' + elemento.espumas2_0V + ')':elemento.espumas2_0}</td>
      }
      {elemento.espumas2_0E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_0V?elemento.espumas2_0 + '(' + elemento.espumas2_0V + ')':elemento.espumas2_0}</td>
      }     
      {elemento.espumas2_0E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_0V?elemento.espumas2_0 + '(' + elemento.espumas2_0V + ')':elemento.espumas2_0}</td>
      }     
      {(elemento.espumas2_10E===''||elemento.espumas2_10E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_10V?elemento.espumas2_10 + '(' + elemento.espumas2_10V + ')':elemento.espumas2_10}</td>
      }
      {elemento.espumas2_10E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_10V?elemento.espumas2_10 + '(' + elemento.espumas2_10V + ')':elemento.espumas2_10}</td>
      }
      {elemento.espumas2_10E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_10V?elemento.espumas2_10 + '(' + elemento.espumas2_10V + ')':elemento.espumas2_10}</td>
      }
      {elemento.espumas2_10E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_10V?elemento.espumas2_10 + '(' + elemento.espumas2_10V + ')':elemento.espumas2_10}</td>
      }     
      {elemento.espumas2_10E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_10V?elemento.espumas2_10 + '(' + elemento.espumas2_10V + ')':elemento.espumas2_10}</td>
      }     
      {(elemento.espumas3_0E===''||elemento.espumas3_0E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_0V?elemento.espumas3_0 + '(' + elemento.espumas3_0V + ')':elemento.espumas3_0}</td>
      }
      {elemento.espumas3_0E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_0V?elemento.espumas3_0 + '(' + elemento.espumas3_0V + ')':elemento.espumas3_0}</td>
      }
      {elemento.espumas3_0E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_0V?elemento.espumas3_0 + '(' + elemento.espumas3_0V + ')':elemento.espumas3_0}</td>
      }
      {elemento.espumas3_0E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_0V?elemento.espumas3_0 + '(' + elemento.espumas3_0V + ')':elemento.espumas3_0}</td>
      }     
      {elemento.espumas3_0E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_0V?elemento.espumas3_0 + '(' + elemento.espumas3_0V + ')':elemento.espumas3_0}</td>
      }     
      {(elemento.espumas3_10E===''||elemento.espumas3_10E===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_10V?elemento.espumas3_10 + '(' + elemento.espumas3_10V + ')':elemento.espumas3_10}</td>
      }
      {elemento.espumas3_10E==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_10V?elemento.espumas3_10 + '(' + elemento.espumas3_10V + ')':elemento.espumas3_10}</td>
      }
      {elemento.espumas3_10E==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_10V?elemento.espumas3_10 + '(' + elemento.espumas3_10V + ')':elemento.espumas3_10}</td>
      }
      {elemento.espumas3_10E==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_10V?elemento.espumas3_10 + '(' + elemento.espumas3_10V + ')':elemento.espumas3_10}</td>
      }     
      {elemento.espumas3_10E==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_10V?elemento.espumas3_10 + '(' + elemento.espumas3_10V + ')':elemento.espumas3_10}</td>
      }           
      {(elemento.liberacionE===''||elemento.liberacionE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.liberacionV?elemento.liberacion + '(' + elemento.liberacionV + ')':elemento.liberacion}</td>
      }
      {elemento.liberacionE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.liberacionV?elemento.liberacion + '(' + elemento.liberacionV + ')':elemento.liberacion}</td>
      }
      {elemento.liberacionE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.liberacionV?elemento.liberacion + '(' + elemento.liberacionV + ')':elemento.liberacion}</td>
      }
      {elemento.liberacionE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.liberacionV?elemento.liberacion + '(' + elemento.liberacionV + ')':elemento.liberacion}</td>
      }     
      {elemento.liberacionE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.liberacionV?elemento.liberacion + '(' + elemento.liberacionV + ')':elemento.liberacion}</td>
      }     
      {(elemento.inflamacionE===''||elemento.inflamacionE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.inflamacionV?elemento.inflamacion + '(' + elemento.inflamacionV + ')':elemento.inflamacion}</td>
      }
      {elemento.inflamacionE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.inflamacionV?elemento.inflamacion + '(' + elemento.inflamacionV + ')':elemento.inflamacion}</td>
      }
      {elemento.inflamacionE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.inflamacionV?elemento.inflamacion + '(' + elemento.inflamacionV + ')':elemento.inflamacion}</td>
      }
      {elemento.inflamacionE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.inflamacionV?elemento.inflamacion + '(' + elemento.inflamacionV + ')':elemento.inflamacion}</td>
      }     
      {elemento.inflamacionE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.inflamacionV?elemento.inflamacion + '(' + elemento.inflamacionV + ')':elemento.inflamacion}</td>
      }     
      {(elemento.corrosionE===''||elemento.corrosionE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.corrosionV?elemento.corrosion + '(' + elemento.corrosionV + ')':elemento.corrosion}</td>
      }
      {elemento.corrosionE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.corrosionV?elemento.corrosion + '(' + elemento.corrosionV + ')':elemento.corrosion}</td>
      }
      {elemento.corrosionE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.corrosionV?elemento.corrosion + '(' + elemento.corrosionV + ')':elemento.corrosion}</td>
      }
      {elemento.corrosionE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.corrosionV?elemento.corrosion + '(' + elemento.corrosionV + ')':elemento.corrosion}</td>
      }     
      {elemento.corrosionE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.corrosionV?elemento.corrosion + '(' + elemento.corrosionV + ')':elemento.corrosion}</td>
      }     
      {(elemento.ultracentrifugaE===''||elemento.ultracentrifugaE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ultracentrifugaV?elemento.ultracentrifuga + '(' + elemento.ultracentrifugaV + ')':elemento.ultracentrifuga}</td>
      }
      {elemento.ultracentrifugaE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ultracentrifugaV?elemento.ultracentrifuga + '(' + elemento.ultracentrifugaV + ')':elemento.ultracentrifuga}</td>
      }
      {elemento.ultracentrifugaE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ultracentrifugaV?elemento.ultracentrifuga + '(' + elemento.ultracentrifugaV + ')':elemento.ultracentrifuga}</td>
      }
      {elemento.ultracentrifugaE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ultracentrifugaV?elemento.ultracentrifuga + '(' + elemento.ultracentrifugaV + ')':elemento.ultracentrifuga}</td>
      }     
      {elemento.ultracentrifugaE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ultracentrifugaV?elemento.ultracentrifuga + '(' + elemento.ultracentrifugaV + ')':elemento.ultracentrifuga}</td>
      }
      {(elemento.densidadE===''||elemento.densidadE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.densidadV?elemento.densidad + '(' + elemento.densidadV + ')':elemento.densidad}</td>
      }
      {elemento.densidadE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.densidadV?elemento.densidad + '(' + elemento.densidadV + ')':elemento.densidad}</td>
      }
      {elemento.densidadE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.densidadV?elemento.densidad + '(' + elemento.densidadV + ')':elemento.densidad}</td>
      }
      {elemento.densidadE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.densidadV?elemento.densidad + '(' + elemento.densidadV + ')':elemento.densidad}</td>
      }     
      {elemento.densidadE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.densidadV?elemento.densidad + '(' + elemento.densidadV + ')':elemento.densidad}</td>
      }
      {(elemento.aparienciaE===''||elemento.aparienciaE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aparienciaV?elemento.apariencia + '(' + elemento.aparienciaV + ')':elemento.apariencia}</td>
      }
      {elemento.aparienciaE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aparienciaV?elemento.apariencia + '(' + elemento.aparienciaV + ')':elemento.apariencia}</td>
      }
      {elemento.aparienciaE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aparienciaV?elemento.apariencia + '(' + elemento.aparienciaV + ')':elemento.apariencia}</td>
      }
      {elemento.aparienciaE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aparienciaV?elemento.apariencia + '(' + elemento.aparienciaV + ')':elemento.apariencia}</td>
      }     
      {elemento.aparienciaE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aparienciaV?elemento.apariencia + '(' + elemento.aparienciaV + ')':elemento.apariencia}</td>
      }
      {(elemento.olorE===''||elemento.olorE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.olorV?elemento.olor + '(' + elemento.olorV + ')':elemento.olor}</td>
      }
      {elemento.olorE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.olorV?elemento.olor + '(' + elemento.olorV + ')':elemento.olor}</td>
      }
      {elemento.olorE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.olorV?elemento.olor + '(' + elemento.olorV + ')':elemento.olor}</td>
      }
      {elemento.olorE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.olorV?elemento.olor + '(' + elemento.olorV + ')':elemento.olor}</td>
      }     
      {elemento.olorE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.olorV?elemento.olor + '(' + elemento.olorV + ')':elemento.olor}</td>
      }
      {(elemento.fuegoE===''||elemento.fuegoE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fuegoV?elemento.fuego + '(' + elemento.fuegoV + ')':elemento.fuego}</td>
      }
      {elemento.fuegoE==='ALARMA' &&
        <td className='' style={{color: 'black', background: '#ff681f', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fuegoV?elemento.fuego + '(' + elemento.fuegoV + ')':elemento.fuego}</td>
      }
      {elemento.fuegoE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fuegoV?elemento.fuego + '(' + elemento.fuegoV + ')':elemento.fuego}</td>
      }
      {elemento.fuegoE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fuegoV?elemento.fuego + '(' + elemento.fuegoV + ')':elemento.fuego}</td>
      }     
      {elemento.fuegoE==='PRECAUCION' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fuegoV?elemento.fuego + '(' + elemento.fuegoV + ')':elemento.fuego}</td>
      }
      {(elemento.pqE===''||elemento.pqE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.pqV?elemento.pq + '(' + elemento.pqV + ')':elemento.pq}</td>
      }
      {elemento.pqE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.pqV?elemento.pq + '(' + elemento.pqV + ')':elemento.pq}</td>
      }
      {elemento.pqE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.pqV?elemento.pq + '(' + elemento.pqV + ')':elemento.pq}</td>
      }
      {elemento.pqE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.pqV?elemento.pq + '(' + elemento.pqV + ')':elemento.pq}</td>
      }     
      {(elemento.fischerE===''||elemento.fischerE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fischerV?elemento.fischer + '(' + elemento.fischerV + ')':elemento.fischer}</td>
      }
      {elemento.fischerE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fischerV?elemento.fischer + '(' + elemento.fischerV + ')':elemento.fischer}</td>
      }
      {elemento.fischerE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fischerV?elemento.fischer + '(' + elemento.fischerV + ')':elemento.fischer}</td>
      }
      {elemento.fischerE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fischerV?elemento.fischer + '(' + elemento.fischerV + ')':elemento.fischer}</td>
      }     
      {(elemento.tanpteE===''||elemento.tanpteE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tanpteV?elemento.tanpte + '(' + elemento.tanpteV + ')':elemento.tanpte}</td>
      }
      {elemento.tanpteE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tanpteV?elemento.tanpte + '(' + elemento.tanpteV + ')':elemento.tanpte}</td>
      }
      {elemento.tanpteE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tanpteV?elemento.tanpte + '(' + elemento.tanpteV + ')':elemento.tanpte}</td>
      }
      {elemento.tanpteE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tanpteV?elemento.tanpte + '(' + elemento.tanpteV + ')':elemento.tanpte}</td>
      }     
      {(elemento.tbnpteE===''||elemento.tbnpteE===null) &&
        <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tbnpteV?elemento.tbnpte + '(' + elemento.tbnpteV + ')':elemento.tbnpte}</td>
      }
      {elemento.tbnpteE==='ALARMA' &&
        <td className='' style={{color: 'black', background: 'yellow', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tbnpteV?elemento.tbnpte + '(' + elemento.tbnpteV + ')':elemento.tbnpte}</td>
      }
      {elemento.tbnpteE==='PELIGRO' &&
        <td className='' style={{color: 'black', background: 'red', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tbnpteV?elemento.tbnpte + '(' + elemento.tbnpteV + ')':elemento.tbnpte}</td>
      }
      {elemento.tbnpteE==='CONFIABLE' &&
        <td className='' style={{color: 'black', background: 'green', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tbnpteV?elemento.tbnpte + '(' + elemento.tbnpteV + ')':elemento.tbnpte}</td>
      }     
    </tr>
  )
};

const ListaPlDet = ({list, handleChange}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePlDet elemento={elemento} key={i} indice={i}
    handleChange={handleChange}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};
//FIN Lista con datos cargados de mecanismos del informe

class LabGenrte2 extends React.Component {
  
  state={list: 
    this.props.allInflabRtes2.allInflabRtes?this.props.allInflabRtes2.allInflabRtes.map((elemento, i) => ({
      ...elemento, checkSeleccInf: true
    })):[], 
    checkSeleccInfAll: true,
    argsDocum: {numeroInflab: 0}, procBtn: 0, permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, 
    confirmaAct: false, open: false, errors: [], numeroInflab: this.props.numeroInflab,
    iso4406: [{iso:0, valor1:0, valor2:1},
      {iso:1, valor1:1, valor2:2}, 
      {iso:2, valor1:2, valor2:4}, 
      {iso:3, valor1:4, valor2:8}, 
      {iso:4, valor1:8, valor2:16}, 
      {iso:5, valor1:16, valor2:32}, 
      {iso:6, valor1:32, valor2:64}, 
      {iso:7, valor1:64, valor2:130}, 
      {iso:8, valor1:130, valor2:250}, 
      {iso:9, valor1:250, valor2:500}, 
      {iso:10, valor1:500, valor2:1000}, 
      {iso:11, valor1:1000, valor2:2000}, 
      {iso:12, valor1:2000, valor2:4000}, 
      {iso:13, valor1:4000, valor2:8000}, 
      {iso:14, valor1:8000, valor2:16000}, 
      {iso:15, valor1:16000, valor2:32000}, 
      {iso:16, valor1:32000, valor2:64000}, 
      {iso:17, valor1:64000, valor2:130000}, 
      {iso:18, valor1:130000, valor2:250000}, 
      {iso:19, valor1:250000, valor2:500000}, 
      {iso:20, valor1:500000, valor2:1000000}, 
      {iso:21, valor1:1000000, valor2:2000000}, 
      {iso:22, valor1:2000000, valor2:4000000}, 
      {iso:23, valor1:4000000, valor2:8000000}, 
      {iso:24, valor1:8000000, valor2:16000000}, 
      {iso:25, valor1:16000000, valor2:32000000}, 
      {iso:26, valor1:32000000, valor2:64000000}, 
      {iso:27, valor1:64000000, valor2:130000000}, 
      {iso:28, valor1:130000000, valor2:250000000},
      {iso:29, valor1:250000000, valor2:100000000000}],
      lineaPru: [
        {pru:'visco40', linea:28}, 
        {pru:'visco100', linea:29}, 
        {pru:'indice', linea:30}, 
        {pru:'tan', linea:31}, 
        {pru:'tbn', linea:32}, 
        {pru:'agua', linea:33}, 
        {pru:'codigoPar', linea:34}, 
        {pru:'micras4', linea:35}, 
        {pru:'micras6', linea:36}, 
        {pru:'micras14', linea:37}, 
        {pru:'micras21', linea:38}, 
        {pru:'micras25', linea:39}, 
        {pru:'micras38', linea:40}, 
        {pru:'micras70', linea:41}, 
        {pru:'hollin', linea:42}, 
        {pru:'nitracion', linea:43}, 
        {pru:'sulfatacion', linea:44}, 
        {pru:'dilucion', linea:45}, 
        {pru:'glicol', linea:46}, 
        {pru:'oxidacion', linea:47}, 
        {pru:'hierro', linea:48}, 
        {pru:'cobre', linea:49}, 
        {pru:'aluminio', linea:50}, 
        {pru:'cromo', linea:51}, 
        {pru:'plomo', linea:52}, 
        {pru:'estano', linea:53}, 
        {pru:'niquel', linea:54},
        {pru:'titanio', linea:55}, 
        {pru:'vanadio', linea:56}, 
        {pru:'silicio', linea:57}, 
        {pru:'sodio', linea:58}, 
        {pru:'potasio', linea:59}, 
        {pru:'boro', linea:60}, 
        {pru:'magnesio', linea:61}, 
        {pru:'calcio', linea:62}, 
        {pru:'fosforo', linea:63}, 
        {pru:'zinc', linea:64}, 
        {pru:'molibdeno', linea:65}, 
        {pru:'bario', linea:66}, 
        {pru:'manganeso', linea:67},
        {pru:'color', linea:28},         
        {pru:'rulerP', linea:29},         
        {pru:'rulerA', linea:30},         
        {pru:'rulerF', linea:31},         
        {pru:'rulerZ', linea:32},         
        {pru:'rpvot', linea:33},         
        {pru:'barniz', linea:34},  
        {pru:'demulsibilidad', linea:35},         
        {pru:'demulsibilidadA', linea:36},         
        {pru:'demulsibilidadAg', linea:37},         
        {pru:'demulsibilidadE', linea:38},         
        {pru:'demulsibilidadT', linea:39},  
        {pru:'separa54', linea:35},         
        {pru:'separaA54', linea:36},         
        {pru:'separaAg54', linea:37},         
        {pru:'separaE54', linea:38},         
        {pru:'separaT54', linea:39},
        {pru:'separa82', linea:35},         
        {pru:'separaA82', linea:36},         
        {pru:'separaAg82', linea:37},         
        {pru:'separaE82', linea:38},         
        {pru:'separaT82', linea:39},
        {pru:'liberacion', linea:40},         
        {pru:'inflamacion', linea:41},         
        {pru:'corrosion', linea:42},
        {pru:'espumas1_0', linea:43},         
        {pru:'espumas1_10', linea:44},         
        {pru:'espumas2_0', linea:45},         
        {pru:'espumas2_10', linea:46},         
        {pru:'espumas3_0', linea:47},         
        {pru:'espumas3_10', linea:48},         
        {pru:'ultracentrifuga', linea:49}, 
        {pru:'densidad', linea:50}, 
        {pru:'apariencia', linea:52},         
        {pru:'olor', linea:53}, 
        {pru:'fuego', linea:51},
        {pru:'pq', linea:54}, 
        {pru:'fischer', linea:55}, 
        {pru:'tanpte', linea:56}, 
        {pru:'tbnpte', linea:57}, 
      ],  
      argsQuery2: `{"$unwind": "$pruebaslab"},
      {$project: {_id: { $concat: [ '$descrEmpresa', '$descrPlanta', '$descrSeccion', '$descrEquipo', 
      '$descrComponente', '$descrMecanismo', '$descrAplicacion', '$pruebaslab.descrPrueba' ] }, 
      descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, 
      descrEquipo: 1, descrComponente: 1, descrMecanismo: 1, descrAplicacion: 1, 
      tipoPrueba: '$pruebaslab.tipoPrueba',
      descrPrueba: '$pruebaslab.descrPrueba',
      validacion: '$pruebaslab.validacion', 
      valor1Alarma: '$pruebaslab.valor1Alarma', 
      valor2Alarma: '$pruebaslab.valor2Alarma', 
      valor3Alarma: '$pruebaslab.valor3Alarma', 
      valor1Corte: '$pruebaslab.valor1Corte', 
      valor2Corte: '$pruebaslab.valor2Corte', 
      valor3Corte: '$pruebaslab.valor3Corte'}}`
  }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  // valor3=iso[0].iso
  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

//ACTUALIZAR BD
crudBDRep = async (operacionCRUD, args, i)=>{
  if(args.ctrlCampo === 'CRUD'){
    const {data} = await operacionCRUD({
      variables: args
    });

//Se utiliza para traer el _id del documento creado
    if(args.ctrl_id === 'SI_ID'){
      if(Object.values(data)[0]._id){
        return Object.values(data)[0]._id
      }else{
        return 0
      }
    }
  }else{
    if(args.ctrlCampo === "MANY"){
      const {data} = await operacionCRUD({
        variables: args
      });
    }
  }
}

//ENVIO PARA ACTUALIZAR BD
updColeccRep = async (crudColecc, argsCrud, totDocCRUD)=>{
  let codigo = 0
  if(argsCrud[0].ctrl_id === 'SI_ID'){
    codigo = await this.crudBDRep(crudColecc[0], argsCrud[0], 0)
  }else{
    await this.crudBDRep(crudColecc[0], argsCrud[0], 0)
  }
  if(codigo!==0){
    for(let i=1; i<totDocCRUD; i++){
      argsCrud[i]._id = codigo
    }
  }
  for(let i=1; i<totDocCRUD; i++){
    await this.crudBDRep(crudColecc[i], argsCrud[i], i)
  }
}


  handleChange = (ev, indice) => {
    
    if(ev.target.name === "checkSeleccInfAll"){
      const list = this.state.list
      let checkSeleccInfAll = this.state.checkSeleccInfAll
      if(checkSeleccInfAll){
        checkSeleccInfAll = false
      }else{
        checkSeleccInfAll = true
      }
      for(let i=0; i<list.length; i++){
        list[i].checkSeleccInf = checkSeleccInfAll
      }
      this.setState({checkSeleccInfAll});
      this.setState({list});
    }

    if(ev.target.name === "checkSeleccInf"){
      const list = this.state.list
      let checkSeleccInfAll = this.state.checkSeleccInfAll
      list[indice].checkSeleccInf = ev.target.checked
      checkSeleccInfAll = false
      this.setState({checkSeleccInfAll});
      this.setState({list});
    }

    if(ev.target.name==="numeroInflab"){
      const argsDocum = this.state.argsDocum
      let argsBuscar=""
      argsBuscar += `'estadoInflab': '${this.props.opcion}', 'numeroInflab': ${ev.target.value}`
      let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
      this.props.allInflabRtes2.refetch(argsBuscarIl)
  
      argsDocum[ev.target.name] = ev.target.value

      this.setState({numeroInflab:ev.target.value})
      this.setState({argsDocum});
    }
  }


  handleGenRte = async (ev, list1)=>{
    let list = await list1.filter(elemento => elemento.checkSeleccInf === true)
    for (let ii=0;ii<list.length;ii++){
      if(list[ii].checkSeleccInf){
        let elemento=list[ii]
        //Archivo Excel
        let xlsString = []
        let xlsString1 = []
        let xlsStringE = []
        let xlsString1E = []

        let listRtes=elemento.reportes
        listRtes = listRtes.filter(reporte => reporte.columna25 !== 'Pruebas especiales' && 
        reporte.columna4 !== 'INFORME DE LABORATORIO DE ACEITES - PRUEBAS ESPECIALES')
        listRtes = _.orderBy(listRtes, ['columna26'], ['asc'])      
        let listRtesE=elemento.reportes
        listRtesE = listRtesE.filter(reporte => (reporte.columna1 !== 'Demulsibilidad Aceite' && reporte.columna1 !== 'Demulsibilidad Agua' && reporte.columna1 !== 'Demulsibilidad Emulsión' && reporte.columna1 !== 'Demulsibilidad Tiempo' &&
          reporte.columna1 !== 'Separabilidad Aceite a 54ºC' && reporte.columna1 !== 'Separabilidad Agua a 54ºC' && reporte.columna1 !== 'Separabilidad Emulsión a 54ºC' &&  reporte.columna1 !== 'Separabilidad Tiempo a 54ºC' &&
          reporte.columna1 !== 'Separabilidad Aceite a 82ºC' && reporte.columna1 !== 'Separabilidad Agua a 82ºC' && reporte.columna1 !== 'Separabilidad Emulsión a 82ºC' &&  reporte.columna1 !== 'Separabilidad Tiempo a 82ºC') 
        && ((reporte.columna4 === 'INFORME DE LABORATORIO DE ACEITES - PRUEBAS ESPECIALES') || 
        (reporte.columna26 === 2 || reporte.columna26 === 8) || 
        (reporte.columna26 > 2 && reporte.columna26 < 8 && reporte.columna25 === 'Pruebas especiales') ||
        (reporte.columna26 > 8 && reporte.columna26 < 27 && reporte.columna25 === 'Pruebas especiales') ||
        (reporte.columna26 > 26 && reporte.columna25 === 'Pruebas especiales' && reporte.columna25 !== 'PROPIEDADES FISICO' && 
        reporte.columna25 !== 'CONTAMINACION' && reporte.columna25 !== 'INFRA-ROJO (abs / mm)' && 
        reporte.columna25 !== 'PROPIEDADES QUIMICAS' && reporte.columna25 !== 'DESGASTE DE METALES(ppm)' && 
        reporte.columna25 !== 'CONTAMINANTES EXTERNOS, ppm (mg/kg)' && reporte.columna25 !== 'ADITIVOS DEL ACEITE, ppm (mg/kg)' && 
        reporte.columna1.substring(0, 9) !== 'ANALISIS:'))) 
        listRtesE = _.orderBy(listRtesE, ['columna26'], ['asc'])      
        if(listRtes.length>22 || listRtesE.length>22){
          var wb = XLSX.utils.book_new();
          if(listRtes.length>22){
            for(let i=0; i<listRtes.length; i++){
              xlsString1 = [listRtes[i].columna1, listRtes[i].columna2, listRtes[i].columna3,
                listRtes[i].columna4, listRtes[i].columna5, listRtes[i].columna6, listRtes[i].columna7,
                listRtes[i].columna8, listRtes[i].columna9, listRtes[i].columna10, listRtes[i].columna11,
                listRtes[i].columna12, listRtes[i].columna13, listRtes[i].columna14, listRtes[i].columna15, 
                listRtes[i].columna16, listRtes[i].columna17, listRtes[i].columna18,
                listRtes[i].columna19, listRtes[i].columna20, listRtes[i].columna21, listRtes[i].columna22,
                listRtes[i].columna23, listRtes[i].columna24, listRtes[i].columna25, listRtes[i].columna26,
                listRtes[i].columna27, listRtes[i].columna28, listRtes[i].columna29, listRtes[i].columna30]

              xlsString.push(xlsString1) 
            }
            
            wb.SheetNames.push("BASICAS");
            wb.SheetNames.push("ANEXOS_BASICAS");
            let ws_data = xlsString;
            let ws = XLSX.utils.aoa_to_sheet(ws_data);
            wb.Sheets["BASICAS"] = ws;
            wb.Sheets["ANEXOS_BASICAS"] = ws;
          }

          if(listRtesE.length>22){
            for(let i=0; i<listRtesE.length; i++){
              xlsString1E = [listRtesE[i].columna1, listRtesE[i].columna2, listRtesE[i].columna3,
                listRtesE[i].columna4, listRtesE[i].columna5, listRtesE[i].columna6, listRtesE[i].columna7,
                listRtesE[i].columna8, listRtesE[i].columna9, listRtesE[i].columna10, listRtesE[i].columna11,
                listRtesE[i].columna12, listRtesE[i].columna13, listRtesE[i].columna14, listRtesE[i].columna15, 
                listRtesE[i].columna16, listRtesE[i].columna17, listRtesE[i].columna18,
                listRtesE[i].columna19, listRtesE[i].columna20, listRtesE[i].columna21, listRtesE[i].columna22,
                listRtesE[i].columna23, listRtesE[i].columna24, listRtesE[i].columna25, listRtesE[i].columna26,
                listRtesE[i].columna27, listRtesE[i].columna28, listRtesE[i].columna29, listRtesE[i].columna30]
  
              xlsStringE.push(xlsString1E) 
            }
            wb.SheetNames.push("ESPECIALES");
            wb.SheetNames.push("ANEXOS_ESPECIALES");
            let wsE_data = xlsStringE;
            let wsE = XLSX.utils.aoa_to_sheet(wsE_data);
            wb.Sheets["ESPECIALES"] = wsE;
            wb.Sheets["ANEXOS_ESPECIALES"] = wsE;
          }

          wb.Props = {
            Title: "SheetJS Tutorial",
            Subject: "Test",
            Author: "Red Stapler",
            CreatedDate: new Date(2017,12,19)
          };

          let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
          function s2ab(s) { 
            let buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
            let view = new Uint8Array(buf);  //create uint8array as viewer
            for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
            return buf;    
          }
          let nomArch = ''
          nomArch = elemento.numeroInflab+'-'+elemento.mecInflab+'.xlsx'
          nomArch = nomArch.replace(/[#$%&/¿()ñÑ@'"|= \?]/gi,'_')

          saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), nomArch);

          //FIN Exportar a XLS
        }

      }
    }
  }

procesarPrueba = async (elemento, prueba, numLinea, histPru, regExisteVR, VA1, VA2, VA3, VC1,VC2, VC3)=>{
  let col8='', col9=''
  let col10=''
  let col11=''
  let col27=''
  let col28=''
  let col29=''
  let estadoPrueba=''
  let alarma=''
  let corte=''
  let precaucion=''
  let confiable=''
  let alarmaTxt=''
  let corteTxt=''
  let precaucionTxt=''
  let valor1RefAlarma=0
  let valor1RefCorte=0
  let valor2RefAlarma=0
  let valor2RefCorte=0
  let valor1RefPrecaucion=0
  let valor2RefPrecaucion=0
  let valor1RefConfiable=0
  let valor2RefConfiable=0
  let resultado=''
  let resultado2=''
  let resultado3=''
  let resultado4=''
  let desviacion = 'N/A'
  let aceiteNuevo=''
  let alarma1=-9999
  let alarma2=-9999
  let alarma3=-9999
  let corte1=-9999
  let corte2=-9999
  let corte3=-9999
  let numHist=1
  let tipoCompara=''
  let tipoComparaDemul='Demul'
  let aceiteNuevoDemul='40/40/0 (30)'
  let precaucionTxtDemul='30/30/20 (>0 y <=20)'              
  let alarmaTxtDemul='20/20/40 (>20 y <=40)'
  let corteTxtDemul='0/0/80 (>60 y <=80)'
  let confiableDemul='40/40/0 (=0)'

  let tipoComparaSepara54='Demul'
  let aceiteNuevoSepara54='40/40/0 (18)'
  let precaucionTxtSepara54='30/30/20 (>=18 y <24)'              
  let alarmaTxtSepara54='20/20/40 (>=24 y <=30)'
  let corteTxtSepara54='0/0/80 (>30)'
  let confiableSepara54='40/40/0 (<18)'
  let tipoComparaSepara82='Demul'
  let aceiteNuevoSepara82='40/40/0 (36)'
  let precaucionTxtSepara82='30/30/20 (>=36 y <48)'              
  let alarmaTxtSepara82='20/20/40 (>=48 y <=60)'
  let corteTxtSepara82='0/0/80 (>60)'
  let confiableSepara82='40/40/0 (<36)'
  let rango1=''
  let rango2=''
  let rango3=''
  let rango4=''
  let indexPruLab= -1
  let analisis = ''
  let recomendaciones = ''
  
  if(histPru.length>0){
    let numReg=histPru.length
    if(histPru.length>3){
      numReg=3
    }
    for(let ii=0; ii<numReg; ii++){
      histPru[ii].reportes.forEach((pruebaSel, i) => {
        if(pruebaSel.columna2===prueba.descrPrueba){  
          if((histPru[ii].numeroInflab>2155 && histPru[ii].numeroInflab!==2184 && histPru[ii].numeroInflab!==2170) || histPru[ii].numeroInflab===2060){
            if(ii===0){
              col10=pruebaSel.columna11
              col29=pruebaSel.columna30
              if(pruebaSel.columna11!==null && pruebaSel.columna11!==''){
                numHist+=1
                col10=col10.replace(",", ".")
              }
            }
            if(ii===1){
              col9=pruebaSel.columna11
              col28=pruebaSel.columna30
              if(pruebaSel.columna11!==null && pruebaSel.columna11!==''){
                numHist+=1
                col9=col9.replace(",", ".")
              }
            }
            if(ii===2){
              col8=pruebaSel.columna11
              col27=pruebaSel.columna30
              if(pruebaSel.columna11!==null && pruebaSel.columna11!==''){
                numHist+=1
                col8=col8.replace(",", ".")
              }
            }
          }else{
            if(ii===0){
              col10=pruebaSel.columna12
              col29=pruebaSel.columna30
              if(pruebaSel.columna12!==null && pruebaSel.columna12!==''){
                numHist+=1
                col10=col10.replace(",", ".")
              }
            }
            if(ii===1){
              col9=pruebaSel.columna12
              col28=pruebaSel.columna30
              if(pruebaSel.columna12!==null && pruebaSel.columna12!==''){
                numHist+=1
                col9=col9.replace(",", ".")
              }
            }
            if(ii===2){
              col8=pruebaSel.columna12
              col27=pruebaSel.columna30
              if(pruebaSel.columna12!==null && pruebaSel.columna12!==''){
                numHist+=1
                col8=col8.replace(",", ".")
              }
            }
          }
        }else{  
          if(pruebaSel.columna1===prueba.descrPrueba){ 
            if(ii===0){
              col11=pruebaSel.columna13
              col29=pruebaSel.columna30
              if(pruebaSel.columna13!==null && pruebaSel.columna13!==''){
                numHist+=1
                col11=col11.replace(",", ".")
              }
            }
            if(ii===1){
              col10=pruebaSel.columna13
              col28=pruebaSel.columna30
              if(pruebaSel.columna13!==null && pruebaSel.columna13!==''){
                numHist+=1
              }
            }
            if(ii===2){
              col9=pruebaSel.columna13
              col27=pruebaSel.columna30
              if(pruebaSel.columna13!==null && pruebaSel.columna13!==''){
                numHist+=1
              }
            }
          }
        }
      });
    }
  }

  if((elemento[prueba.campoBD]===0) || (elemento[prueba.campoBD] && elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || (prueba.descrPrueba==='Código de partículas')){
    if (prueba.validacion==='No se compara'){
      tipoCompara='No'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante==elemento.descrLubricante){
          if(lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            aceiteNuevo=lubricante[prueba.campoBD]
          }
        }
      })      

      if(elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!==''){
        if(prueba.descrPrueba==='Índice de Viscosidad IV' && (elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0')){
          estadoPrueba='PELIGRO'
        }else{
          estadoPrueba='CONFIABLE'
        }
        resultado=elemento[prueba.campoBD]
      }else{  
        estadoPrueba='CONFIABLE'
      }  
    }    

    if(prueba.validacion==='Mayor que valor único de referencia'){
      tipoCompara='Mayor'

      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      })      
      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
      }else{
        estadoPrueba='CONFIABLE'
      } 
      if ((elemento.descrEmpresa==='UNIBAN'|| elemento.descrEmpresa==='UNIBAN ANT') && elemento.descrAplicacion==='MOTORES COMBUSTION INTERNA DIESEL' &&
        ((prueba.tipoPrueba!=='CONTAMINACION') || (prueba.tipoPrueba==='CONTAMINACION' && prueba.descrPrueba==='Agua'))){

        switch (prueba.descrPrueba) {
          case 'Agua':
            alarma = 0.1
            corte = 0.3
            break;
          case 'Agua por Karl Fischer':
            alarma = 0.1
            corte = 0.3
            break;
          case 'Hollín':
            alarma = 15
            corte = 20
            break;
          case 'Dilución por Combustible':
            alarma = 10
            corte = 12
            break;
          case 'Glicol':
            alarma = 9
            corte = 15
            break;
          case 'TAN':
            alarma = -1
            corte = -1
            break;
          case 'TAN con PTE':
            alarma = -1
            corte = -1
            break;
          case 'Hierro (Fe)':
            alarma = 100
            corte = 120
            break;
          case 'Cobre (Cu)':
            alarma = 40
            corte = 50
            break;
          case 'Aluminio (Al)':
            alarma = 20
            corte = 40
            break;
          case 'Cromo (Cr)':
            alarma = 40
            corte = 60
            break;
          case 'Plomo (Pb)':
            alarma = 50
            corte = 70
            break;
          case 'Estaño (Sn)':
            alarma = 20
            corte = 30
            break;              
          case 'Níquel (Ni)':
            alarma = 15
            corte = 20
            break;                  
          case 'Vanadio (V)':
            alarma = 20
            corte = 30
            break;
          case 'Titanio (Ti)':
            alarma = 20
            corte = 30
            break;
          case 'Silicio (Si)':
            alarma = 20
            corte = 50
            break;
          case 'Sodio (Na)':
            alarma = 30
            corte = 40
            break;              
          case 'Potasio (K)':
            alarma = 30
            corte = 40
            break;                  
                        
          default:
            alarma = -1
            corte = -1
            break;
        }
        if(elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='' && alarma!==-1 && corte!==-1){
          if (resultado>corte){
            estadoPrueba='PELIGRO'
          }else{
            if (resultado>alarma){
              estadoPrueba='ALARMA'
            }else{
              estadoPrueba='CONFIABLE'
            }
          }
        }else{  
          estadoPrueba='CONFIABLE'        
        }
      }else{
        if(regExisteVR===1){
          if(VA1!==null && VC1!==''){
            if((prueba.descrPrueba==='TAN' || prueba.descrPrueba==='TAN con PTE') && (elemento.descrAplicacion==='ACEITE PARA COMPRESORES' || (elemento.descrAplicacion==='COMPRESORES' && elemento.descrEmpresa!=='GECELCA S.A.S. E.S.P.') || elemento.descrAplicacion==='ACEITE PARA TURBINAS DE GAS' || elemento.descrAplicacion==='TURBINAS DE GAS' || elemento.descrAplicacion==='ACEITE PARA TURBINAS DE VAPOR' || elemento.descrAplicacion==='TURBINAS DE VAPOR' || elemento.descrAplicacion==='ACEITE PARA TURBINAS HIDRAULICAS' || elemento.descrAplicacion==='TURBINAS HIDRAULICAS')){
              alarma=parseFloat(aceiteNuevo+VA1).toFixed(2)
              corte=parseFloat(aceiteNuevo+VC1).toFixed(2)          
            }else{  
              alarma=parseFloat(VA1).toFixed(2)
              corte=parseFloat(VC1).toFixed(2)           
              console.log(prueba.descrPrueba, alarma, corte)
            }          
            alarma=Math.round(alarma * 100) / 100
            corte=Math.round(corte * 100) / 100   
            if(elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!==''){

              if (resultado>corte){
                estadoPrueba='PELIGRO'
              }else{
                if (resultado>alarma){
                  estadoPrueba='ALARMA'
                }else{
                  estadoPrueba='CONFIABLE'
                }
              }
            }else{  
              estadoPrueba='CONFIABLE'        
            }
          }else{
            estadoPrueba='CONFIABLE'        
          }    
        }else{
          indexPruLab = prueba.pruebaslab.findIndex( prulab => prulab.descrAplicacion===elemento.descrAplicacion)
          if (indexPruLab!==-1){
            if(prueba.pruebaslab[indexPruLab].valor1Alarma!==null && prueba.pruebaslab[indexPruLab].valor1Corte!==''){
              if((prueba.descrPrueba==='TAN' || prueba.descrPrueba==='TAN con PTE') && (elemento.descrAplicacion==='ACEITE PARA COMPRESORES' || elemento.descrAplicacion==='COMPRESORES' || elemento.descrAplicacion==='ACEITE PARA TURBINAS DE GAS' || elemento.descrAplicacion==='TURBINAS DE GAS' || elemento.descrAplicacion==='ACEITE PARA TURBINAS DE VAPOR' || elemento.descrAplicacion==='TURBINAS DE VAPOR' || elemento.descrAplicacion==='ACEITE PARA TURBINAS HIDRAULICAS' || elemento.descrAplicacion==='TURBINAS HIDRAULICAS')){
                alarma=parseFloat(aceiteNuevo+prueba.pruebaslab[indexPruLab].valor1Alarma).toFixed(2)
                corte=parseFloat(aceiteNuevo+prueba.pruebaslab[indexPruLab].valor1Corte).toFixed(2)          
              }else{  
                alarma=parseFloat(prueba.pruebaslab[indexPruLab].valor1Alarma).toFixed(2)
                corte=parseFloat(prueba.pruebaslab[indexPruLab].valor1Corte).toFixed(2)           
              }          
              alarma=Math.round(alarma * 100) / 100
              corte=Math.round(corte * 100) / 100           
              if(elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!==''){
                if (resultado>corte){
                  estadoPrueba='PELIGRO'
                }else{
                  if (resultado>alarma){
                    estadoPrueba='ALARMA'
                  }else{
                    estadoPrueba='CONFIABLE'
                  }
                }
              }else{  
                estadoPrueba='CONFIABLE'        
              }
            }else{
              estadoPrueba='CONFIABLE'        
            }            
          }
        }
      }
      if(!alarma){
        estadoPrueba='CONFIABLE'
      }        
      if(prueba.descrPrueba.substring(0, 10)==='Partículas' && (elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0')){
        estadoPrueba='PELIGRO'
      }
      if(prueba.descrPrueba==='Indice PQ' || prueba.descrPrueba==='TAN con PTE' || prueba.descrPrueba==='Agua por Karl Fischer'){
        confiable='<='+alarma
        precaucion=''              
        alarma=alarma
        corte=corte
        precaucionTxt=''              
        alarmaTxt='>'+alarma+ 'y <='+corte
        corteTxt='>'+corte
      }
    }

    if(prueba.validacion==='Mayor que % de referencia en Aceite nuevo'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]==0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }          
          }      
        }
      })    
      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
      }      
      if ((elemento.descrEmpresa==='UNIBAN'|| elemento.descrEmpresa==='UNIBAN ANT') && elemento.descrAplicacion==='MOTORES COMBUSTION INTERNA DIESEL'){
        regExisteVR=1
      }
      if ((elemento.descrEmpresa==='Zonagen S.A.S' && elemento.descrAplicacion==='MOTORES A GAS') && (prueba.descrPrueba==='Sulfatación' || prueba.descrPrueba==='Nitración')){
        valor1RefAlarma=12.5
        valor1RefCorte=25
        alarma=valor1RefAlarma
        corte=valor1RefCorte  
        alarma=Math.round(alarma * 100) / 100
        corte=Math.round(corte * 100) / 100
        if(elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!==''){
          resultado=elemento[prueba.campoBD]
          if (resultado>valor1RefCorte){
            estadoPrueba='PELIGRO'
          }else{
            if (resultado>valor1RefAlarma){
              estadoPrueba='ALARMA'
            }else{
              estadoPrueba='CONFIABLE'
            }
          }
        }else{  
          estadoPrueba='CONFIABLE'
        }
      }else{
        if(regExisteVR===1){
          if ((elemento.descrEmpresa==='UNIBAN'|| elemento.descrEmpresa==='UNIBAN ANT') && elemento.descrAplicacion==='MOTORES COMBUSTION INTERNA DIESEL' && (prueba.descrPrueba==='Nitración' || prueba.descrPrueba==='Oxidación')){
            if(prueba.descrPrueba==='Oxidación'){
              valor1RefAlarma=12
              valor1RefCorte=14
              alarma=valor1RefAlarma
              corte=valor1RefCorte  
            }else{  
              valor1RefAlarma=13
              valor1RefCorte=15
              alarma=valor1RefAlarma
              corte=valor1RefCorte                            
            }
            if(elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!==''){
              resultado=elemento[prueba.campoBD]
              if (resultado>valor1RefCorte){
                estadoPrueba='PELIGRO'
              }else{
                if (resultado>valor1RefAlarma){
                  estadoPrueba='ALARMA'
                }else{
                  estadoPrueba='CONFIABLE'
                }
              }
            }else{  
              estadoPrueba='CONFIABLE'
            }
          }else{
            if(VA1!==null && VC1!==''){
              alarma1=VA1
              corte1=VC1
              if(aceiteNuevo!==null && aceiteNuevo!==''){
                if(prueba.descrPrueba==='Oxidación'){
                  valor1RefAlarma=25
                  valor1RefCorte=75
                  alarma=valor1RefAlarma
                  corte=valor1RefCorte  
                  alarma=Math.round(alarma * 100) / 100
                  corte=Math.round(corte * 100) / 100                
                }else{  
                  valor1RefAlarma=parseFloat(aceiteNuevo*(1+(alarma1/100))).toFixed(2)
                  valor1RefCorte=parseFloat(aceiteNuevo*(1+(corte1/100))).toFixed(2)       
                  alarma=valor1RefAlarma
                  corte=valor1RefCorte  
                  alarma=Math.round(alarma * 100) / 100
                  corte=Math.round(corte * 100) / 100                            
                }

                if(elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!==''){
                  resultado=elemento[prueba.campoBD]
                  if (resultado>valor1RefCorte){
                    estadoPrueba='PELIGRO'
                  }else{
                    if (resultado>valor1RefAlarma){
                      estadoPrueba='ALARMA'
                    }else{
                      estadoPrueba='CONFIABLE'
                    }
                  }
                }else{  
                  estadoPrueba='CONFIABLE'
                }     
              }else{
                alarma=25
                corte=75
              }
            }else{
              estadoPrueba='CONFIABLE'
            }
          }    
        }else{
          indexPruLab = prueba.pruebaslab.findIndex( prulab => prulab.descrAplicacion===elemento.descrAplicacion)
          if (indexPruLab!==-1){

          // prueba.pruebaslab.forEach((valRef, _id) => {
          //   if(valRef.descrAplicacion==elemento.descrAplicacion){
            if(prueba.pruebaslab[indexPruLab].valor1Alarma!==null && prueba.pruebaslab[indexPruLab].valor1Corte!==''){
              // if(valRef.valor1Alarma!==null && valRef.valor1Corte!==''){
                alarma1=prueba.pruebaslab[indexPruLab].valor1Alarma
                corte1=prueba.pruebaslab[indexPruLab].valor1Corte
                if(aceiteNuevo!==null && aceiteNuevo!==''){
                  if(prueba.descrPrueba==='Oxidación'){
                    valor1RefAlarma=25
                    valor1RefCorte=75
                    alarma=valor1RefAlarma
                    corte=valor1RefCorte  
                    alarma=Math.round(alarma * 100) / 100
                    corte=Math.round(corte * 100) / 100                
                  }else{  
                    valor1RefAlarma=parseFloat(aceiteNuevo*(1+(alarma1/100))).toFixed(2)
                    valor1RefCorte=parseFloat(aceiteNuevo*(1+(corte1/100))).toFixed(2)       
                    alarma=valor1RefAlarma
                    corte=valor1RefCorte  
                    alarma=Math.round(alarma * 100) / 100
                    corte=Math.round(corte * 100) / 100                            
                  }

                  if(elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!==''){
                    resultado=elemento[prueba.campoBD]
                    if (resultado>valor1RefCorte){
                      estadoPrueba='PELIGRO'
                    }else{
                      if (resultado>valor1RefAlarma){
                        estadoPrueba='ALARMA'
                      }else{
                        estadoPrueba='CONFIABLE'
                      }
                    }
                  }else{  
                    estadoPrueba='CONFIABLE'
                  }     
                }else{
                  alarma=25
                  corte=75
                }
              }else{
                estadoPrueba='CONFIABLE'
              }
            }
          // })
        }  
        if(aceiteNuevo==''){
          estadoPrueba='CONFIABLE'
          // aceiteNuevo=''
        }
      }  
    }

    if(prueba.validacion==='Menor que % de referencia en Aceite nuevo'){
      tipoCompara='Menor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante==elemento.descrLubricante){
          if(lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]==0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }          }      
        }
      })   
      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
      }
      if ((elemento.descrEmpresa==='UNIBAN'|| elemento.descrEmpresa==='UNIBAN ANT') && elemento.descrAplicacion==='MOTORES COMBUSTION INTERNA DIESEL'){
        regExisteVR=1
      }

      if(regExisteVR===1){
        if ((elemento.descrEmpresa==='UNIBAN'|| elemento.descrEmpresa==='UNIBAN ANT') && elemento.descrAplicacion==='MOTORES COMBUSTION INTERNA DIESEL'){
          if (prueba.descrPrueba==='TBN' || prueba.descrPrueba==='TBN con PTE'){
            VA1 = 50
            VC1 = 30
          }
          if (prueba.tipoPrueba==='ADITIVOS DEL ACEITE, ppm (mg/kg)'){
            VA1 = 15
            VC1 = 10
          }
        }
        if(VA1!==null && VC1!==''){
          alarma1=VA1
          corte1=VC1
          if(aceiteNuevo!==''){
            if((elemento.descrEmpresa!=='UNIBAN'|| elemento.descrEmpresa==='UNIBAN ANT') && (prueba.descrPrueba==='TBN' || prueba.descrPrueba==='TBN con PTE') && (elemento.descrAplicacion==='MOTORES COMBUSTION INTERNA DIESEL' || elemento.descrAplicacion==='MOTORES COMBUSTION INTERNA GASOLINA' || elemento.descrAplicacion==='MOTORES A GAS')){
              valor1RefAlarma=parseFloat(aceiteNuevo*(alarma1/100))
              valor1RefCorte=parseFloat(aceiteNuevo*(corte1/100))          
            }else{  
              valor1RefAlarma=aceiteNuevo*(alarma1/100)
              valor1RefCorte=aceiteNuevo*(corte1/100)
            }          
            alarma=Math.round(valor1RefAlarma * 100) / 100
            corte=Math.round(valor1RefCorte * 100) / 100          
            if(resultado!==null && resultado!==''){
              if (resultado<corte){
                estadoPrueba='PELIGRO'
              }else{
                if (resultado<alarma){
                  estadoPrueba='ALARMA'
                }else{
                  estadoPrueba='CONFIABLE'
                }
              }
            }else{  
              estadoPrueba='CONFIABLE'
            }     
          }
        }else{
          estadoPrueba='CONFIABLE'
        }    
      }else{  
        indexPruLab = prueba.pruebaslab.findIndex( prulab => prulab.descrAplicacion===elemento.descrAplicacion)
        if (indexPruLab!==-1){

        // prueba.pruebaslab.forEach((valRef, _id) => {
        //   if(valRef.descrAplicacion==elemento.descrAplicacion){
        //     if(valRef.valor1Alarma!==null && valRef.valor1Corte!==''){
            if(prueba.pruebaslab[indexPruLab].valor1Alarma!==null && prueba.pruebaslab[indexPruLab].valor1Corte!==''){  
              alarma1=prueba.pruebaslab[indexPruLab].valor1Alarma
              corte1=prueba.pruebaslab[indexPruLab].valor1Corte
              if(aceiteNuevo!==''){
                if((prueba.descrPrueba==='TBN' || prueba.descrPrueba==='TBN con PTE') && (elemento.descrAplicacion==='MOTORES COMBUSTION INTERNA DIESEL' || elemento.descrAplicacion==='MOTORES COMBUSTION INTERNA GASOLINA' || elemento.descrAplicacion==='MOTORES A GAS')){
                  valor1RefAlarma=parseFloat(aceiteNuevo*(alarma1/100))
                  valor1RefCorte=corte1          
                }else{  
                  valor1RefAlarma=aceiteNuevo*(alarma1/100)
                  valor1RefCorte=aceiteNuevo*(corte1/100)
                }          
                // alarma=valor1RefAlarma
                // corte=valor1RefCorte  
                alarma=Math.round(valor1RefAlarma * 100) / 100
                corte=Math.round(valor1RefCorte * 100) / 100          
                if(resultado!==null && resultado!==''){
                  // resultado=elemento[prueba.campoBD]
                  if (resultado<corte){
                    estadoPrueba='PELIGRO'
                  }else{
                    if (resultado<alarma){
                      estadoPrueba='ALARMA'
                    }else{
                      estadoPrueba='CONFIABLE'
                    }
                  }
                }else{  
                  estadoPrueba='CONFIABLE'
                }     
              }
            }else{
              estadoPrueba='CONFIABLE'
            }
          }
        // })  
      }
      if(aceiteNuevo==''){
        estadoPrueba='CONFIABLE'
        // aceiteNuevo=''
      }  
      if(prueba.descrPrueba==='TBN con PTE'){
        confiable='>='+alarma
        precaucion=''              
        alarma=alarma
        corte=corte
        precaucionTxt=''              
        alarmaTxt='<'+alarma+' y >='+corte
        corteTxt='<'+corte
      }
    }

    if(prueba.validacion==='Rango de % en Aceite nuevo'){
      tipoCompara='Rango'
      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
      }else{
        estadoPrueba='CONFIABLE'      
      }  
      if ((elemento.descrEmpresa==='UNIBAN'|| elemento.descrEmpresa==='UNIBAN ANT') && elemento.descrAplicacion==='MOTORES COMBUSTION INTERNA DIESEL'){
        regExisteVR=1
      }
      if(regExisteVR===1){
        if ((elemento.descrEmpresa==='UNIBAN'|| elemento.descrEmpresa==='UNIBAN ANT') && elemento.descrAplicacion==='MOTORES COMBUSTION INTERNA DIESEL'){
          alarma1=10
          corte1=20
          alarma2=-10
          corte2=-20
        }else{
          alarma1=VA1
          corte1=VC1
          alarma2=VA2
          corte2=VC2  
        }
        this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
          if(lubricante.descrLubricante===elemento.descrLubricante){
            if(lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
              aceiteNuevo=lubricante[prueba.campoBD]
            }            
            valor1RefAlarma=parseFloat(aceiteNuevo*(1+(alarma1/100))).toFixed(2)
            valor1RefCorte=parseFloat(aceiteNuevo*(1+(corte1/100))).toFixed(2)
            valor2RefAlarma=parseFloat(aceiteNuevo*(1+(alarma2/100))).toFixed(2)
            valor2RefCorte=parseFloat(aceiteNuevo*(1+(corte2/100))).toFixed(2)    
            rango2=valor1RefAlarma
            rango1=valor1RefCorte
            rango3=valor2RefAlarma
            rango4=valor2RefCorte 
            if(elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!==''){
              if (resultado>valor1RefCorte || resultado<valor2RefCorte){
                estadoPrueba='PELIGRO'
              }else{
                if (resultado>valor1RefAlarma || resultado<valor2RefAlarma){
                  estadoPrueba='ALARMA'
                }else{
                  estadoPrueba='CONFIABLE'
                }
              }              
            }                 
          }
        })
        if(aceiteNuevo!==''){
          valor1RefAlarma=valor1RefAlarma.replace(".", ",")
          valor2RefAlarma=valor2RefAlarma.replace(".", ",")
          valor1RefCorte=valor1RefCorte.replace(".", ",")
          valor2RefCorte=valor2RefCorte.replace(".", ",")
          alarma=valor1RefAlarma + ' / ' + valor2RefAlarma
          corte=valor1RefCorte + ' / ' + valor2RefCorte
        }else{
          estadoPrueba='CONFIABLE'
        } 
      }else{ 
        indexPruLab = prueba.pruebaslab.findIndex( prulab => prulab.descrAplicacion===elemento.descrAplicacion)
        if (indexPruLab!==-1){
          if(prueba.pruebaslab[indexPruLab].descrAplicacion===elemento.descrAplicacion){  
            alarma1=prueba.pruebaslab[indexPruLab].valor1Alarma
            corte1=prueba.pruebaslab[indexPruLab].valor1Corte
            alarma2=prueba.pruebaslab[indexPruLab].valor2Alarma
            corte2=prueba.pruebaslab[indexPruLab].valor2Corte  
            this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
              if(lubricante.descrLubricante===elemento.descrLubricante){
                if(lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
                  aceiteNuevo=lubricante[prueba.campoBD]
                }            
                valor1RefAlarma=parseFloat(aceiteNuevo*(1+(alarma1/100))).toFixed(2)
                // 10.8*1.08=11.664
                valor1RefCorte=parseFloat(aceiteNuevo*(1+(corte1/100))).toFixed(2)
                valor2RefAlarma=parseFloat(aceiteNuevo*(1+(alarma2/100))).toFixed(2)
                // 10.8*1.15=12.42
                valor2RefCorte=parseFloat(aceiteNuevo*(1+(corte2/100))).toFixed(2)    
                rango2=valor1RefAlarma
                rango1=valor1RefCorte
                rango3=valor2RefAlarma
                rango4=valor2RefCorte  
                if(elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!==''){
                  if (resultado>valor1RefCorte || resultado<valor2RefCorte){
                    estadoPrueba='PELIGRO'
                  }else{
                    if (resultado>valor1RefAlarma || resultado<valor2RefAlarma){
                      estadoPrueba='ALARMA'
                    }else{
                      estadoPrueba='CONFIABLE'
                    }
                  }              
                }                 
              }
            })
          }  

          if(aceiteNuevo!==''){
            valor1RefAlarma=valor1RefAlarma.replace(".", ",")
            valor2RefAlarma=valor2RefAlarma.replace(".", ",")
            valor1RefCorte=valor1RefCorte.replace(".", ",")
            valor2RefCorte=valor2RefCorte.replace(".", ",")
            alarma=valor1RefAlarma + ' / ' + valor2RefAlarma
            corte=valor1RefCorte + ' / ' + valor2RefCorte
          }else{
            estadoPrueba='CONFIABLE'
          } 
        } 
      }
      if(prueba.descrPrueba.substring(1, 11)==='Viscosidad' && (elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0')){
        estadoPrueba='PELIGRO'
      }
    }

    if(prueba.validacion==='Mayor que 3 valores de referencia'){
      tipoCompara='Mayor3'
      if (regExisteVR===1){
        this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
          if(lubricante.descrLubricante===elemento.descrLubricante){
            if(lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
              aceiteNuevo=lubricante[prueba.campoBD]
            }     
          }
        })    
        alarma1=VA1
        corte1=VC1
        alarma2=VA2
        corte2=VC2 
        alarma3=VA3
        corte3=VC3
        if(elemento.micras4==='' || elemento.micras4===null || elemento.micras6==='' || elemento.micras6===null || elemento.micras14==='' || elemento.micras14===null){
          resultado=''
        }else{
          let indexMicras = this.state.iso4406.findIndex( isoFind => elemento.micras4>=isoFind.valor1 && elemento.micras4<isoFind.valor2 )
          let micras4=-1
          if (indexMicras!==-1){
            micras4=this.state.iso4406[indexMicras].iso
            console.log(micras4)
          }
          indexMicras = this.state.iso4406.findIndex( isoFind => elemento.micras6>=isoFind.valor1 && elemento.micras6<isoFind.valor2 )
          let micras6=-1
          if (indexMicras!==-1){
            micras6=this.state.iso4406[indexMicras].iso
          }    
          indexMicras = this.state.iso4406.findIndex( isoFind => elemento.micras14>=isoFind.valor1 && elemento.micras14<isoFind.valor2 )
          let micras14=-1
          if (indexMicras!==-1){
            micras14=this.state.iso4406[indexMicras].iso
          }
          if(micras4!==-1 && micras6!==-1 && micras14!==-1){
            console.log(micras4, corte1, corte2, corte3)
            if (micras4>corte1 && micras6>corte2 && micras14>corte3){
              estadoPrueba='PELIGRO'
            
            }else{
              if (micras4<=alarma1 && micras6<=alarma2 && micras14<=alarma3){
                estadoPrueba='CONFIABLE'
              }else{
                estadoPrueba='ALARMA'
              }
            }
            resultado=micras4 + '/' + micras6 + '/' + micras14
            console.log(resultado)
          }else{
            resultado=''
          }  
        }  
        alarma=alarma1 + '/' + alarma2 + '/' + alarma3
        corte=corte1 + '/' + corte2 + '/' + corte3
        console.log(alarma, corte)
      }else{
        indexPruLab = prueba.pruebaslab.findIndex( prulab => prulab.descrAplicacion===elemento.descrAplicacion)
        if (indexPruLab!==-1){
          if(prueba.pruebaslab[indexPruLab].descrAplicacion===elemento.descrAplicacion){
            this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
              if(lubricante.descrLubricante===elemento.descrLubricante){
                if(lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
                  aceiteNuevo=lubricante[prueba.campoBD]
                }     
              }
            })    
            alarma1=prueba.pruebaslab[indexPruLab].valor1Alarma
            corte1=prueba.pruebaslab[indexPruLab].valor1Corte
            alarma2=prueba.pruebaslab[indexPruLab].valor2Alarma
            corte2=prueba.pruebaslab[indexPruLab].valor2Corte   
            alarma3=prueba.pruebaslab[indexPruLab].valor3Alarma
            corte3=prueba.pruebaslab[indexPruLab].valor3Corte  
            if(elemento.micras4==='' || elemento.micras4===null || elemento.micras6==='' || elemento.micras6===null || elemento.micras14==='' || elemento.micras14===null){
              resultado=''
            }else{
              let indexMicras = this.state.iso4406.findIndex( isoFind => elemento.micras4>=isoFind.valor1 && elemento.micras4<isoFind.valor2 )
              let micras4=-1
              if (indexMicras!==-1){
                micras4=this.state.iso4406[indexMicras].iso
              }
              indexMicras = this.state.iso4406.findIndex( isoFind => elemento.micras6>=isoFind.valor1 && elemento.micras6<isoFind.valor2 )
              let micras6=-1
              if (indexMicras!==-1){
                micras6=this.state.iso4406[indexMicras].iso
              }    
              indexMicras = this.state.iso4406.findIndex( isoFind => elemento.micras14>=isoFind.valor1 && elemento.micras14<isoFind.valor2 )
              let micras14=-1
              if (indexMicras!==-1){
                micras14=this.state.iso4406[indexMicras].iso
              }
              if(micras4!==-1 && micras6!==-1 && micras14!==-1){
                if (micras4>corte1 && micras6>corte2 && micras14>corte3){
                  estadoPrueba='PELIGRO'
                }else{
                  if (micras4<=alarma1 && micras6<=alarma2 && micras14<=alarma3){
                    estadoPrueba='CONFIABLE'
                  }else{
                    estadoPrueba='ALARMA'
                  }
                }
                resultado=micras4 + '/' + micras6 + '/' + micras14
              }else{
                resultado=''
              }  
            }  
            alarma=alarma1 + '/' + alarma2 + '/' + alarma3
            corte=corte1 + '/' + corte2 + '/' + corte3              
          }
        // })  
        }
      }
    }




    if(prueba.descrPrueba==='Color'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 
      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (resultado>6){
          estadoPrueba='PELIGRO'
        }else{
          if (resultado>4 && resultado<=6){
            estadoPrueba='ALARMA'
          }else{
            if (resultado>2 && resultado<=4){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          }
        } 
      }
      confiable='<=2'
      precaucion='2'              
      alarma='4'
      corte='6'
      precaucionTxt='>2 y <=4'              
      alarmaTxt='>4 y <=6'
      corteTxt='>6'              
    }

    if(prueba.campoBD==='rulerP' || prueba.campoBD==='rulerA' || prueba.campoBD==='rulerF' || prueba.campoBD==='rulerZ'){
      tipoCompara='Menor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 
      aceiteNuevo='100'
      
      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if(prueba.campoBD==='rulerP'){
          if (resultado<=25){
            estadoPrueba='PELIGRO'
          }else{
            if (resultado>25 && resultado<=50){
              estadoPrueba='ALARMA'
            }else{
              if (resultado>50 && resultado<=75){
                estadoPrueba='PRECAUCION'
              }else{
                estadoPrueba='CONFIABLE'
              }          }
          } 
        }
      }
      resultado=resultado
      confiable='>75'
      precaucion='75'              
      alarma='50'
      corte='25'
      precaucionTxt='>50 y <=75'              
      alarmaTxt='>25 y <=50'
      corteTxt='<=25'              
    }

    if(prueba.campoBD==='rpvot'){
      tipoCompara='Menor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 
      if(aceiteNuevo && aceiteNuevo!==null && aceiteNuevo!==''){
        valor1RefConfiable=parseFloat(aceiteNuevo*(75/100)).toFixed(2)
        valor1RefPrecaucion=parseFloat(aceiteNuevo*(50/100)).toFixed(2)
        valor1RefAlarma=parseFloat(aceiteNuevo*(25/100)).toFixed(2)
        if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
          resultado=elemento[prueba.campoBD]
          if (resultado<=valor1RefAlarma){
            estadoPrueba='PELIGRO'
          }else{
            if (resultado>valor1RefAlarma && resultado<=valor1RefPrecaucion){
              estadoPrueba='ALARMA'
            }else{
              if (resultado>valor1RefPrecaucion && resultado<=valor1RefConfiable){
                estadoPrueba='PRECAUCION'
              }else{
                estadoPrueba='CONFIABLE'
              }          
            }
          } 
        }
        if (valor1RefConfiable!==null && valor1RefConfiable!=='' && valor1RefConfiable!==-9999) {
          valor1RefConfiable= valor1RefConfiable.toString()
          valor1RefConfiable=valor1RefConfiable.replace(".", ",")
        }
        if (valor1RefAlarma!==null && valor1RefAlarma!=='' && valor1RefAlarma!==-9999) {
          valor1RefAlarma= valor1RefAlarma.toString()
          valor1RefAlarma=valor1RefAlarma.replace(".", ",")
        }
        if (valor1RefPrecaucion!==null && valor1RefPrecaucion!=='' && valor1RefPrecaucion!==-9999) {
          valor1RefPrecaucion = valor1RefPrecaucion.toString()
          valor1RefPrecaucion = valor1RefPrecaucion.replace(".", ",")
        }
        confiable='>' + valor1RefConfiable
        precaucion=valor1RefConfiable           
        alarma=valor1RefPrecaucion
        corte=valor1RefAlarma
        precaucionTxt='>' + valor1RefPrecaucion + ' y <=' + valor1RefConfiable              
        alarmaTxt='>' + valor1RefAlarma + ' y <=' + valor1RefPrecaucion
        corteTxt='<=' + valor1RefAlarma
      }
    }

    if(prueba.campoBD==='barniz'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 
      aceiteNuevo='0'
      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (resultado>40){
          estadoPrueba='PELIGRO'
        }else{
          if (resultado>30 && resultado<=40){
            estadoPrueba='ALARMA'
          }else{
            if (resultado>15 && resultado<=30){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          }
        } 
      }
      confiable='<15'
      precaucion='15'              
      alarma='30'
      corte='40'  
      precaucionTxt='ΔE >15 y <=30'              
      alarmaTxt='ΔE >30 y <=40'
      corteTxt='ΔE >40'            
    }

    if(prueba.campoBD==='demulsibilidadA' || prueba.campoBD==='demulsibilidadAg'){
      tipoCompara='Menor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 

      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (resultado<24){
          estadoPrueba='PELIGRO'
        }else{
          if (resultado>=24 && resultado<32){
            estadoPrueba='ALARMA'
          }else{
            if (resultado>=32 && resultado<40){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          
          }
        } 
      }
      confiable='=40'
      precaucion='40'              
      alarma='32'
      corte='24' 
      precaucionTxt='<40 y >=32'              
      alarmaTxt='<32 y >=24'
      corteTxt='<24'   
    }

    if(prueba.campoBD==='demulsibilidadE'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 

      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (parseInt(resultado)>12){
          estadoPrueba='PELIGRO'
        }else{
          if (parseInt(resultado)>8 && parseInt(resultado)<=12){
            estadoPrueba='ALARMA'
          }else{
            if (parseInt(resultado)>0 && parseInt(resultado)<=8){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          }
        } 
      }
      confiable='=0'
      precaucion='0'              
      alarma='8'
      corte='12' 
      precaucionTxt='>0 y <=8'              
      alarmaTxt='>8 y <=12'
      corteTxt='>12'   
    }

    if(prueba.campoBD==='demulsibilidadT'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 

      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (resultado>42){
          estadoPrueba='PELIGRO'
        }else{
          if (resultado>36 && resultado<=42){
            estadoPrueba='ALARMA'
          }else{
            if (resultado>30 && resultado<=36){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          }
        } 
      }
      confiable='<=30'
      precaucion='30'              
      alarma='36'
      corte='42'
      precaucionTxt='>30 y <=36'              
      alarmaTxt='>36 y <=42'
      corteTxt='>42'
    }




    if(prueba.campoBD==='separaA54' || prueba.campoBD==='separaAg54'){
      tipoCompara='Menor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 

      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (resultado<24){
          estadoPrueba='PELIGRO'
        }else{
          if (resultado>=24 && resultado<32){
            estadoPrueba='ALARMA'
          }else{
            if (resultado>=32 && resultado<40){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          
          }
        } 
      }
      confiable='=40'
      precaucion='40'              
      alarma='32'
      corte='24' 
      precaucionTxt='<40 y >=32'              
      alarmaTxt='<32 y >=24'
      corteTxt='<24'   
    }

    if(prueba.campoBD==='separaE54'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 

      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (parseInt(resultado)>12){
          estadoPrueba='PELIGRO'
        }else{
          if (parseInt(resultado)>8 && parseInt(resultado)<=12){
            estadoPrueba='ALARMA'
          }else{
            if (parseInt(resultado)>0 && parseInt(resultado)<=8){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          }
        } 
      }
      confiable='=0'
      precaucion='0'              
      alarma='8'
      corte='12' 
      precaucionTxt='>0 y <=8'              
      alarmaTxt='>8 y <=12'
      corteTxt='>12'   
    }

    if(prueba.campoBD==='separaT54'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 

      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (resultado>30){
          estadoPrueba='PELIGRO'
        }else{
          if (resultado>=24 && resultado<=30){
            estadoPrueba='ALARMA'
          }else{
            if (resultado>=18 && resultado<24){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          
          }
        } 
      }
      confiable='<18'
      precaucion='18'              
      alarma='24'
      corte='30' 
      precaucionTxt='>=18 y <24'              
      alarmaTxt='>=24 y <=30'
      corteTxt='>30'   
    }

    if(prueba.campoBD==='separaA82' || prueba.campoBD==='separaAg82'){
      tipoCompara='Menor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 

      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (resultado<24){
          estadoPrueba='PELIGRO'
        }else{
          if (resultado>=24 && resultado<32){
            estadoPrueba='ALARMA'
          }else{
            if (resultado>=32 && resultado<40){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          
          }
        } 
      }
      confiable='=40'
      precaucion='40'              
      alarma='32'
      corte='24' 
      precaucionTxt='<40 y >=32'              
      alarmaTxt='<32 y >=24'
      corteTxt='<24'   
    }

    if(prueba.campoBD==='separaE82'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 

      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (parseInt(resultado)>12){
          estadoPrueba='PELIGRO'
        }else{
          if (parseInt(resultado)>8 && parseInt(resultado)<=12){
            estadoPrueba='ALARMA'
          }else{
            if (parseInt(resultado)>0 && parseInt(resultado)<=8){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          }
        } 
      }
      confiable='=0'
      precaucion='0'              
      alarma='8'
      corte='12' 
      precaucionTxt='>0 y <=8'              
      alarmaTxt='>8 y <=12'
      corteTxt='>12'   
    }

    if(prueba.campoBD==='separaT82'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 

      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (resultado>60){
          estadoPrueba='PELIGRO'
        }else{
          if (resultado>=48 && resultado<=60){
            estadoPrueba='ALARMA'
          }else{
            if (resultado>=36 && resultado<48){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          
          }
        } 
      }
      confiable='<36'
      precaucion='36'              
      alarma='48'
      corte='60' 
      precaucionTxt='>=36 y <48'              
      alarmaTxt='>=48 y <=60'
      corteTxt='>60'   
    }

    if(prueba.campoBD==='espumas1_0' || prueba.campoBD==='espumas2_0' || prueba.campoBD==='espumas3_0'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(prueba.campoBD==='espumas1_0'){
            if(lubricante['secuencia1'] && lubricante['secuencia1']!==null && lubricante['secuencia1']!==''){
              if(lubricante['secuencia1']===0 || lubricante['secuencia1']=='0'){
                aceiteNuevo='0'
              }else{
                aceiteNuevo=lubricante['secuencia1']
              }  
            }
          }
          if(prueba.campoBD==='espumas2_0'){
            if(lubricante['secuencia2'] && lubricante['secuencia2']!==null && lubricante['secuencia2']!==''){
              if(lubricante['secuencia2']===0 || lubricante['secuencia2']=='0'){
                aceiteNuevo='0'
              }else{
                aceiteNuevo=lubricante['secuencia2']
              }  
            }
          }
          if(prueba.campoBD==='espumas3_0'){
            if(lubricante['secuencia3'] && lubricante['secuencia3']!==null && lubricante['secuencia3']!==''){
              if(lubricante['secuencia3']===0 || lubricante['secuencia3']=='0'){
                aceiteNuevo='0'
              }else{
                aceiteNuevo=lubricante['secuencia3']
              }  
            }
          }
        }
      }) 

      if(prueba.campoBD==='espumas1_0' || prueba.campoBD==='espumas3_0'){
        if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
          resultado=elemento[prueba.campoBD]
          if (resultado>450){
            estadoPrueba='PELIGRO'
          }else{
            if (resultado>360 && resultado<=450){
              estadoPrueba='ALARMA'
            }else{
              if (resultado>300 && resultado<=360){
                estadoPrueba='PRECAUCION'
              }else{
                estadoPrueba='CONFIABLE'
              }          }
          } 
        }
        confiable='<=300'
        precaucion='300'              
        alarma='360'
        corte='450'
        precaucionTxt='>300 y <=360'              
        alarmaTxt='>360 y <=450'
        corteTxt='>450'
      }else{
        if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
          resultado=elemento[prueba.campoBD]
          if (resultado>500){
            estadoPrueba='PELIGRO'
          }else{
            if (resultado>450 && resultado<=500){
              estadoPrueba='ALARMA'
            }else{
              if (resultado>400 && resultado<=450){
                estadoPrueba='PRECAUCION'
              }else{
                estadoPrueba='CONFIABLE'
              }          }
          } 
        }
        confiable='<=400'
        precaucion='400'              
        alarma='450'
        corte='500'
        precaucionTxt='>400 y <=450'              
        alarmaTxt='>450 y <=500'
        corteTxt='>500'
      }
    }

    if(prueba.campoBD==='espumas1_10' || prueba.campoBD==='espumas2_10' || prueba.campoBD==='espumas3_10'){
      tipoCompara='Mayor'
      aceiteNuevo='0'
      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (parseInt(resultado)>10){
          estadoPrueba='PELIGRO'
        }else{
          if (parseInt(resultado)>6 && parseInt(resultado)<=10){
            estadoPrueba='ALARMA'
          }else{
            if (parseInt(resultado)>0 && parseInt(resultado)<=6){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          
          }
        } 
      }
      confiable='<=0'
      precaucion='0'              
      alarma='6'
      corte='10' 
      precaucionTxt='>0 y <=6'              
      alarmaTxt='>6 y <=10'
      corteTxt='>10'   
    }

    if(prueba.campoBD==='liberacion'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante['aeroemulsion'] && lubricante['aeroemulsion']!==null && lubricante['aeroemulsion']!==''){
            if(lubricante['aeroemulsion']===0 || lubricante['aeroemulsion']=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante['aeroemulsion']
            }  
          }
        }
      }) 

      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (resultado>30){
          estadoPrueba='PELIGRO'
        }else{
          if (resultado>20 && resultado<=30){
            estadoPrueba='ALARMA'
          }else{
            if (resultado>10 && resultado<=20){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'
            }          }
        } 
      }
      confiable='<=10'
      precaucion='10'              
      alarma='20'
      corte='30'
      precaucionTxt='>10 y <=20'              
      alarmaTxt='>20 y <=30'
      corteTxt='>30'
    }

    if(prueba.campoBD==='inflamacion' || prueba.campoBD==='fuego'){
      tipoCompara='Rango'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 
      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
      }
      if(aceiteNuevo && aceiteNuevo!==null && aceiteNuevo!==''){
        valor1RefAlarma=parseFloat(aceiteNuevo*(1+(15/100))).toFixed(2)
        valor1RefCorte=parseFloat(aceiteNuevo*(1+(20/100))).toFixed(2)
        valor2RefAlarma=parseFloat(aceiteNuevo*(1+(-15/100))).toFixed(2)
        valor2RefCorte=parseFloat(aceiteNuevo*(1+(-20/100))).toFixed(2)    
        rango2=valor1RefAlarma 
        rango1=valor1RefCorte 
        rango3=valor2RefAlarma 
        rango4=valor2RefCorte      

        if (resultado>valor1RefCorte || resultado<valor2RefCorte){
          estadoPrueba='PELIGRO'
        }else{
          if (resultado>valor1RefAlarma || resultado<valor2RefAlarma){
            estadoPrueba='ALARMA'
          }else{
            estadoPrueba='CONFIABLE'
          }
        }              

        confiable='<' + valor1RefAlarma + '/>' + valor2RefAlarma
        alarma='<=' + valor1RefCorte + ' y >=' + valor1RefAlarma + '/<=' + valor2RefAlarma + ' y >=' + valor2RefCorte
        corte='> +-' + valor1RefCorte + '/<' + valor2RefCorte
        precaucionTxt = ''
        alarmaTxt='<=' + valor1RefCorte + ' y >=' + valor1RefAlarma + '/<=' + valor2RefAlarma + ' y >=' + valor2RefCorte
        corteTxt='> +-' + valor1RefCorte + '/<' + valor2RefCorte
      }  
    }

    if(prueba.campoBD==='corrosion'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 
      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (resultado==='0'||resultado==='1a'||resultado==='1b'||resultado==='2a'||resultado==='2b'||resultado==='2c'||resultado==='2d'||resultado==='2e'){
          estadoPrueba='CONFIABLE'
        }else{
          if (resultado==='3a'||resultado==='3b'){
            estadoPrueba='ALARMA'
          }else{
            if (resultado==='4a'||resultado==='4b'||resultado==='4c'){
              estadoPrueba='PELIGRO'
            }         
          }
        } 
      }
      confiable='(0-1a-1b-2a-2b-2c-2d-2e)'
      alarma='(3a-3b)'
      corte='(4a-4b-4c)'
      precaucionTxt = ''
      alarmaTxt='(3a-3b)'
      corteTxt='(4a-4b-4c)'
    }

    if(prueba.campoBD==='ultracentrifuga'){
      tipoCompara='Mayor'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante===elemento.descrLubricante){
          if(lubricante[prueba.campoBD] && lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            if(lubricante[prueba.campoBD]===0 || lubricante[prueba.campoBD]=='0'){
              aceiteNuevo='0'
            }else{
              aceiteNuevo=lubricante[prueba.campoBD]
            }  
          }
        }
      }) 
      if((elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!=='') || elemento[prueba.campoBD]===0 || elemento[prueba.campoBD]==='0'){
        resultado=elemento[prueba.campoBD]
        if (parseInt(resultado)>8){
          estadoPrueba='PELIGRO'
        }else{
          if (parseInt(resultado)>6){
            estadoPrueba='ALARMA'
          }else{
            if (parseInt(resultado)>4){
              estadoPrueba='PRECAUCION'
            }else{
              estadoPrueba='CONFIABLE'          
            }          
          }
        } 
      }
      confiable='<=4'
      precaucion='4'              
      alarma='6'
      corte='8' 
      precaucionTxt='>4 y <=6'              
      alarmaTxt='>6 y <=8'
      corteTxt='>8'   
    }

    if(prueba.campoBD==='densidad' || prueba.campoBD==='apariencia' || prueba.campoBD==='olor'){
      tipoCompara='No'
      this.props.allLubricante.allLubricante.forEach((lubricante, _id) => {
        if(lubricante.descrLubricante==elemento.descrLubricante){
          if(lubricante[prueba.campoBD]!==null && lubricante[prueba.campoBD]!==''){
            aceiteNuevo=lubricante[prueba.campoBD]
          }
        }
      })      

      if(elemento[prueba.campoBD]!==null && elemento[prueba.campoBD]!==''){
        estadoPrueba='CONFIABLE'
        resultado=elemento[prueba.campoBD]
      }else{  
        estadoPrueba='CONFIABLE'
      }
      confiable=''
      precaucion=''              
      alarma=''
      corte='' 
      precaucionTxt=''              
      alarmaTxt=''
      corteTxt=''   
    }


    if(prueba.tipoPrueba==='Pruebas especiales'){
      if(estadoPrueba==='CONFIABLE' && prueba.analisisCon && prueba.analisisCon!=='' && prueba.analisisCon!==null){
        analisis = prueba.analisisCon
      }
      if(estadoPrueba==='CONFIABLE' && prueba.recomenCon && prueba.recomenCon!=='' && prueba.recomenCon!==null){
        recomendaciones = prueba.recomenCon
      }
      if(estadoPrueba==='PRECAUCION' && prueba.analisisPre && prueba.analisisPre!=='' && prueba.analisisPre!==null){
        analisis = prueba.analisisPre
      }
      if(estadoPrueba==='PRECAUCION' && prueba.recomenPre && prueba.recomenPre!=='' && prueba.recomenPre!==null){
        recomendaciones = prueba.recomenPre
      }
      if(estadoPrueba==='ALARMA' && prueba.analisisAla && prueba.analisisAla!=='' && prueba.analisisAla!==null){
        analisis = prueba.analisisAla
      }
      if(estadoPrueba==='ALARMA' && prueba.recomenAla && prueba.recomenAla!=='' && prueba.recomenAla!==null){
        recomendaciones = prueba.recomenAla
      }
      if(estadoPrueba==='PELIGRO' && prueba.analisisPel && prueba.analisisPel!=='' && prueba.analisisPel!==null){
        analisis = prueba.analisisPel
      }
      if(estadoPrueba==='PELIGRO' && prueba.recomenPel && prueba.recomenPel!=='' && prueba.recomenPel!==null){
        recomendaciones = prueba.recomenPel
      }

      if((analisis!=='') && (prueba.campoBD==='barniz' || prueba.campoBD==='liberacion' || prueba.campoBD==='inflamacion' || prueba.campoBD==='corrosion' || prueba.campoBD==='ultracentrifuga')){
        if(resultado!=='' && resultado!==null){
          analisis = analisis.replace('VARIABLE1', resultado)
        }else{
          analisis = analisis.replace('VARIABLE1', '')
        }
      }
      if((analisis!=='') && (prueba.campoBD==='rpvot')){
        let resulR1=0
        let resulR2=0
        let resulR3=0
        if(resultado!=='' && resultado!==null && parseInt(resultado)>0){
          resulR1=resultado
          analisis = analisis.replace('VARIABLE3', resultado)
          if(aceiteNuevo!=='' && aceiteNuevo!==null && parseInt(aceiteNuevo)>0){
            resulR3=parseFloat((100 * resulR1)/aceiteNuevo).toFixed(2)
            resulR2=parseFloat(100 - resulR3).toFixed(2)
            analisis = analisis.replace('VARIABLE1', resulR2)
            analisis = analisis.replace('VARIABLE2', resulR3)
          }else{
            analisis = analisis.replace('VARIABLE1', 'X')
            analisis = analisis.replace('VARIABLE2', 'X')
          }
        }else{
          analisis = analisis.replace('VARIABLE1', 'X')
          analisis = analisis.replace('VARIABLE2', 'X')
          analisis = analisis.replace('VARIABLE3', 'X')
        }
      }

    }

    if(prueba.campoBD==='corrosion'){
      if(estadoPrueba!==null && estadoPrueba!=='' && col29!==null && col29!=='N/A' && col29!==''){
        if(estadoPrueba===col29){
          desviacion = '='
        }else{
          if(estadoPrueba==='CONFIABLE'){
            desviacion = '\u2191'
          }else{
            if(estadoPrueba==='PELIGRO'){
              desviacion = '\u2193'
            }else{
              if(col29==='PELIGRO'){
                desviacion = '\u2191'
              }else{
                desviacion = '\u2193'
              }
            }
          }
        }
      }
    }else{
      if(resultado!==null && resultado!=='' && col11!==null && col11!=='N/A' && col11!==''){
        desviacion = parseFloat(parseFloat(resultado) - parseFloat(col11)).toFixed(2)
        if(resultado!=='0' && col11!=='0'){
          desviacion = parseFloat((Math.abs(desviacion)*100)/parseFloat(col11)).toFixed(2)
          if(desviacion>0){
            if(parseFloat(resultado)>parseFloat(col11)){
              desviacion = '\u2191' + ' ' + desviacion.toString() + ' %'
            }else{
              if(parseFloat(resultado)<parseFloat(col11)){
                desviacion = '\u2193' + ' ' + desviacion.toString() + ' %'
              }else{
                desviacion = '='
              }
            }
          }
        }
      }else{
        if(resultado!==null && resultado!=='' && aceiteNuevo!==null && aceiteNuevo!==''){
          desviacion = parseFloat(parseFloat(resultado) - parseFloat(aceiteNuevo)).toFixed(2)
          if(resultado!=='0' && aceiteNuevo!=='0'){
            desviacion = parseFloat((Math.abs(desviacion)*100)/parseFloat(aceiteNuevo)).toFixed(2)
            if(desviacion>0){
              if(parseFloat(resultado)>parseFloat(aceiteNuevo)){
                desviacion = '\u2191' + ' ' + desviacion.toString() + ' %'
              }else{
                if(parseFloat(resultado)<parseFloat(aceiteNuevo)){
                  desviacion = '\u2193' + ' ' + desviacion.toString() + ' %'
                }else{
                  desviacion = '='
                }
              }
            }
          }
        }
      }
      desviacion=desviacion.toString()
      desviacion=desviacion.replace(".", ",")
    }
    
    if(!aceiteNuevo || aceiteNuevo===null || aceiteNuevo===''){
      aceiteNuevo=''
    }else{
      if(aceiteNuevo===0 || aceiteNuevo==='0'){
        aceiteNuevo='0'
      }else{
        aceiteNuevo=aceiteNuevo.toString()
        aceiteNuevo=aceiteNuevo.replace(".", ",")
      }
    }
    if (precaucion!==null && precaucion!=='' && precaucion!==-9999) {
      precaucion= precaucion.toString()
      precaucion=precaucion.replace(".", ",")
    }else{
      precaucion= ''
    }
    if (alarma!==null && alarma!=='' && alarma!==-9999 && alarma!==-1) {
      alarma= alarma.toString()
      alarma=alarma.replace(".", ",")
    }else{
      alarma= ''
    }
    if (corte!==null && corte!=='' && corte!==-9999 && corte!==-1) {
      corte= corte.toString()
      corte=corte.replace(".", ",")
    }else{
      corte= ''
    }
    if(col9===null || col9===''){
      col9=''
    }else{
      if(col9===0 || col9==='0'){
        col9='0'
      }else{
        col9=col9.toString()
        col9=col9.replace(".", ",")
      }
    }  
    if(col10===null || col10===''){
      col10=''
    }else{
      if(col10===0 || col10==='0'){
        col10='0'
      }else{
        col10=col10.toString()
        col10=col10.replace(".", ",")
      }
    }  
    if(col11===null || col11===''){
      col11=''
    }else{
      if(col11===0 || col11==='0'){
        col11='0'
      }else{
        col11=col11.toString()
        col11=col11.replace(".", ",")
      }
    }   
    if(prueba.descrPrueba==='Hierro (Fe)'){

    }

    if(resultado===null || resultado===''){
      resultado=''
      estadoPrueba=''
    }else{
      if(resultado===0 || resultado==='0'){
        resultado='0'
      }else{
        if(!resultado){

        }else{
          resultado=resultado.toString()
          resultado=resultado.replace(".", ",")
        }
      }
    }
    if (rango1!==null && rango1!=='') {
      rango1= rango1.toString()
      rango1=rango1.replace(".", ",")
    }else{
      rango1= ''
    }
    if (rango2!==null && rango2!=='') {
      rango2= rango2.toString()
      rango2=rango2.replace(".", ",")
    }else{
      rango2= ''
    }
    if (rango3!==null && rango3!=='') {
      rango3= rango3.toString()
      rango3=rango3.replace(".", ",")
    }else{
      rango3= ''
    }
    if (rango4!==null && rango4!=='') {
      rango4= rango4.toString()
      rango4=rango4.replace(".", ",")
    }else{
      rango4= ''
    }
    let argsRte={}
    let argsRteDemul={}
    let argsRteSepara54={}
    let argsRteSepara82={}

    if(prueba.descrPrueba==='Hierro (Fe)'){

    }
    
    if(prueba.tipoPrueba!=='Pruebas especiales'){
      argsRte={
        columna1: prueba.tipoPrueba,
        columna2: prueba.descrPrueba,
        columna3: '',
        columna4: prueba.codNorma,
        columna5: aceiteNuevo,
        columna6: alarma,
        columna7: corte,
        columna8: col8,
        columna9: col9,
        columna10: col10,
        columna11: resultado,
        columna12: desviacion,
        columna13: '',
        columna14: '',
        columna15: '',
        columna16: '',
        columna17: '',
        columna18: '',
        columna19: rango1,
        columna20: rango2,
        columna21: rango3,
        columna22: rango4,
        columna23: tipoCompara,
        columna24: numHist,
        columna25: prueba.tipoPrueba,
        columna26: numLinea,
        columna27: col27,
        columna28: col28,
        columna29: col29,
        columna30: estadoPrueba,
      }
    }else{
        argsRte={
        columna1: prueba.descrPrueba,
        columna2: precaucionTxt,
        columna3: prueba.unidad,
        columna4: prueba.codNorma,
        columna5: confiable,
        columna6: precaucion,
        columna7: alarma,
        columna8: corte,
        columna9: aceiteNuevo,
        columna10: col9,
        columna11: col10,
        columna12: col11,
        columna13: resultado,
        columna14: desviacion,
        columna15: analisis,
        columna16: recomendaciones,
        columna17: alarmaTxt,
        columna18: corteTxt,
        columna19: rango1,
        columna20: rango2,
        columna21: rango3,
        columna22: rango4,
        columna23: tipoCompara,
        columna24: numHist,
        columna25: prueba.tipoPrueba,
        columna26: numLinea,
        columna27: col27,
        columna28: col28,
        columna29: col29,
        columna30: estadoPrueba,
      }   
      if(prueba.campoBD==='demulsibilidadA' && resultado!==''){
        argsRteDemul={
          columna1: 'Demulsibilidad (Aceite/Agua/Emulsión (Tiempo))',
          columna2: precaucionTxtDemul,
          columna3: 'ml/ml/ml (min)',
          columna4: 'ASTM D 1401',
          columna5: '',
          columna6: '',
          columna7: '',
          columna8: '',
          columna9: aceiteNuevoDemul,
          columna10: col9,
          columna11: col10,
          columna12: col11,
          columna13: '',
          columna14: 'N/A',
          columna15: '',
          columna16: '',
          columna17: alarmaTxtDemul,
          columna18: corteTxtDemul,
          columna19: rango1,
          columna20: rango2,
          columna21: rango3,
          columna22: rango4,
          columna23: tipoComparaDemul,
          columna24: numHist,
          columna25: prueba.tipoPrueba,
          columna26: numLinea-1,
          columna27: col27,
          columna28: col28,
          columna29: col29,
          columna30: '',
        }
      }
      if(prueba.campoBD==='separaA54' && resultado!==''){
        argsRteSepara54={
          columna1: 'Separabilidad a 54ºC (Aceite/Agua/Emulsión (Tiempo))',
          columna2: precaucionTxtSepara54,
          columna3: 'ml/ml/ml (min)',
          columna4: 'ASTM D 1401-21',
          columna5: '',
          columna6: '',
          columna7: '',
          columna8: '',
          columna9: aceiteNuevoSepara54,
          columna10: col9,
          columna11: col10,
          columna12: col11,
          columna13: '',
          columna14: 'N/A',
          columna15: '',
          columna16: '',
          columna17: alarmaTxtSepara54,
          columna18: corteTxtSepara54,
          columna19: rango1,
          columna20: rango2,
          columna21: rango3,
          columna22: rango4,
          columna23: tipoComparaSepara54,
          columna24: numHist,
          columna25: prueba.tipoPrueba,
          columna26: numLinea-1,
          columna27: col27,
          columna28: col28,
          columna29: col29,
          columna30: '',
        }
      } 
      if(prueba.campoBD==='separaA82' && resultado!==''){
        argsRteSepara82={
          columna1: 'Separabilidad a 82ºC (Aceite/Agua/Emulsión (Tiempo))',
          columna2: precaucionTxtSepara82,
          columna3: 'ml/ml/ml (min)',
          columna4: 'ASTM D 1401-21',
          columna5: '',
          columna6: '',
          columna7: '',
          columna8: '',
          columna9: aceiteNuevoSepara82,
          columna10: col9,
          columna11: col10,
          columna12: col11,
          columna13: '',
          columna14: 'N/A',
          columna15: '',
          columna16: '',
          columna17: alarmaTxtSepara82,
          columna18: corteTxtSepara82,
          columna19: rango1,
          columna20: rango2,
          columna21: rango3,
          columna22: rango4,
          columna23: tipoComparaSepara82,
          columna24: numHist,
          columna25: prueba.tipoPrueba,
          columna26: numLinea-1,
          columna27: col27,
          columna28: col28,
          columna29: col29,
          columna30: '',
        }
      }
    }
    let argsReturn={argsRte, argsRteDemul, argsRteSepara54, argsRteSepara82}
    return argsReturn
  }else{
    let argsReturn=[]
    return argsReturn
  }  
}

crearLinea = (col1, col2, col3, col4, col5, col6, col7, col8, col9, col10, 
              col11, col12, col13, col14, col15, col16, col17, col18, col19, col20, 
              col21, col22, col23, col24, col25, col26, col27, col28, col29, col30)=>{
  let lineaReturn={
    columna1: col1,
    columna2: col2,
    columna3: col3,
    columna4: col4,
    columna5: col5,
    columna6: col6,
    columna7: col7,
    columna8: col8,
    columna9: col9  ,
    columna10: col10,
    columna11: col11,
    columna12: col12,
    columna13: col13,
    columna14: col14,
    columna15: col15,
    columna16: col16,
    columna17: col17,
    columna18: col18,
    columna19: col19,
    columna20: col20,
    columna21: col21,
    columna22: col22,
    columna23: col23,
    columna24: col24,
    columna25: col25,
    columna26: col26,
    columna27: col27,
    columna28: col28,
    columna29: col29,
    columna30: col30
  }
  return lineaReturn
}




handleProcRes = async(ev, list1)=>{

// console.time(5)

  let control='S'
  let list = await list1.filter(elemento => elemento.checkSeleccInf === true)
  if(list.length>0){
    for (let j=0;j<list.length;j++){
      if(list[j].estadoInflab==='GENERADO' && (!list[j].estadoEnvio || list[j].estadoEnvio!=='Recibida')){
        control='N'
      }
    }
  }
// console.timeEnd(5)

  if(control==='S'){
    document.body.style.cursor = 'wait'

    let mecvalref = []
    let argsBuscValRef = {tipoqry: `[{$match: {descrEmpresa: '${list[0].descrEmpresa}'}}, ${this.state.argsQuery2}]`}
// console.time(6)
    let {data} = await this.props.allMecValRefRtes.refetch(argsBuscValRef)
    mecvalref = await data.allMecValRefRtes
// console.timeEnd(6)

// console.time(7)
    let allPrueba = this.props.allPrueba.allPrueba
    let allPruebaE = this.props.allPruebaRtesE.allPruebaRtes
    let allProducto = this.props.allProducto.allProducto
    let allEmpresa = this.props.allEmpresa.allEmpresa
// console.timeEnd(7)

    for (let iiii=0;iiii<list.length;iiii++){
      if(list[iiii].checkSeleccInf){
        let reportes=[]
        let estadoLub=''
        let estado4mic=''
        let estado6mic=''
        let estado14mic=''
        let estadoIso=''
        let resultadoIso=''
        let numPruebas=0
        let numPruebasE=0
        let contacto=''
        let mail=''
        let telefono=''
        let logo=''
        let reco=''
        let filtroAc=''
        let filtroAire=''
        let aceiteR=''
        let aceiteT=''
        let codPar=''
        let diasEnt='', diasLog=''

        let argsBuscarHis = {tipoqry: `[
          {$match: {mecInflab: {$ne: ${list[iiii].mecInflab}}, fechaMuestra: {$lt: '${list[iiii].fechaMuestra}'},
            estadoInflab: 'FINALIZADO', descrPlanta: '${list[iiii].descrPlanta}',
            descrSeccion: '${list[iiii].descrSeccion}', descrEquipo: '${list[iiii].descrEquipo}',
            descrComponente: '${list[iiii].descrComponente}', descrMecanismo: '${list[iiii].descrMecanismo}'}},
            {$sort: {fechaMuestra: -1, numeroInflab: -1, mecInflab: -1}}
        ]`}
console.time(1)
        await this.props.allInflabRtes4.refetch(argsBuscarHis)
console.timeEnd(1)
        let inf1 = "", inf2 = "", inf3 = ""
        let est1 = "", est2 = "", est3 = "", fab1 = "", fab2 = "", fab3 = "", lub1 = "", lub2 = "", lub3 = ""
        let gra1 = "", gra2 = "", gra3 = "", mue1 = "", mue2 = "", mue3 = "", ult1 = "", ult2 = "", ult3 = ""
        let rec1 = "", rec2 = "", rec3 = "", fil1 = "", fil2 = "", fil3 = "", aire1 = "", aire2 = "", aire3 = ""
        let rep1 = "", rep2 = "", rep3 = "", tot1 = "", tot2 = "", tot3 = "", fec1 = "", fec2 = "", fec3 = ""
        let fecEnv1 = "", fecEnv2 = "", fecEnv3 = "", fecRec1 = "", fecRec2 = "", fecRec3 = "", fecCli1 = "", fecCli2 = "", fecCli3 = ""
        let diasEnt1 = "", diasEnt2 = "", diasEnt3 = "", diasLog1 = "", diasLog2 = "", diasLog3 = ""
        // let fecha1 = new Date(), fecha2 = new Date()

        if(this.props.allInflabRtes4.allInflabRtes.length>0){
          console.time(2)
          for(let ii=0; ii<this.props.allInflabRtes4.allInflabRtes.length; ii++){
            let fecEnvio = '', fecRecibe = '', fecCliente = ''
            if(ii===0){
              inf3 = this.props.allInflabRtes4.allInflabRtes[ii].numeroInflab + "-" + this.props.allInflabRtes4.allInflabRtes[ii].mecInflab
              est3 = this.props.allInflabRtes4.allInflabRtes[ii].estado
              fab3 = this.props.allInflabRtes4.allInflabRtes[ii].descrFabricante
              lub3 = this.props.allInflabRtes4.allInflabRtes[ii].descrLubricante
              gra3 = this.props.allInflabRtes4.allInflabRtes[ii].tipoGrado + " " + this.props.allInflabRtes4.allInflabRtes[ii].descrGrado
              mue3 = this.props.allInflabRtes4.allInflabRtes[ii].tomaMuestra?this.props.allInflabRtes4.allInflabRtes[ii].tomaMuestra:""
              ult3 = this.props.allInflabRtes4.allInflabRtes[ii].ultimoCambio?this.props.allInflabRtes4.allInflabRtes[ii].ultimoCambio:""
              rec3 = this.props.allInflabRtes4.allInflabRtes[ii].recorrido?this.props.allInflabRtes4.allInflabRtes[ii].recorrido:""
              fil3 = this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAc?this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAc:""
              aire3 = this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAire?this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAire:""
              rep3 = this.props.allInflabRtes4.allInflabRtes[ii].aceiteRep?this.props.allInflabRtes4.allInflabRtes[ii].aceiteRep:""
              tot3 = this.props.allInflabRtes4.allInflabRtes[ii].aceiteTotal?this.props.allInflabRtes4.allInflabRtes[ii].aceiteTotal:""
              fec3 = this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra?this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra:""
              
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioLab){
                let fecha1 = moment(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioLab).format('YYYY-MM-DD')
                fecEnvio = fecha1
              }
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab){
                let fecha2 = moment(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab).format('YYYY-MM-DD')
                fecRecibe = fecha2
              }
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente){
                let fecha3 = moment(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente).format('YYYY-MM-DD')
                fecCliente = fecha3
              }
              fecEnv3 = fecEnvio
              fecRec3 = fecRecibe
              fecCli3 = fecCliente
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente && this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab){
                let fecha1 = new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente)
                fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
                fecha1=moment(fecha1)
                let fecha2 = new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab)
                fecha2 = (fecha2.getFullYear()) + '-' + ((fecha2.getMonth()+1)<10?'0'+(fecha2.getMonth()+1):(fecha2.getMonth()+1)) + '-' + (fecha2.getUTCDate()<10?'0'+fecha2.getUTCDate():fecha2.getUTCDate())
                fecha2=moment(fecha2)
                let numDias= fecha1.diff(fecha2, 'days')
                diasEnt3 = numDias
              }
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra && this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab){
                let fecha1 = new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab)
                fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
                fecha1=moment(fecha1)
                let fecha2=new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra)
                let numDias= fecha1.diff(fecha2, 'days')
                diasLog3 = numDias
              }
            }
            if(ii===1){
              inf2 = this.props.allInflabRtes4.allInflabRtes[ii].numeroInflab + "-" + this.props.allInflabRtes4.allInflabRtes[ii].mecInflab
              est2 = this.props.allInflabRtes4.allInflabRtes[ii].estado
              fab2 = this.props.allInflabRtes4.allInflabRtes[ii].descrFabricante
              lub2 = this.props.allInflabRtes4.allInflabRtes[ii].descrLubricante
              gra2 = this.props.allInflabRtes4.allInflabRtes[ii].tipoGrado + " " + this.props.allInflabRtes4.allInflabRtes[ii].descrGrado
              mue2 = this.props.allInflabRtes4.allInflabRtes[ii].tomaMuestra?this.props.allInflabRtes4.allInflabRtes[ii].tomaMuestra:""
              ult2 = this.props.allInflabRtes4.allInflabRtes[ii].ultimoCambio?this.props.allInflabRtes4.allInflabRtes[ii].ultimoCambio:""
              rec2 = this.props.allInflabRtes4.allInflabRtes[ii].recorrido?this.props.allInflabRtes4.allInflabRtes[ii].recorrido:""
              fil2 = this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAc?this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAc:""
              aire2 = this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAire?this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAire:""
              rep2 = this.props.allInflabRtes4.allInflabRtes[ii].aceiteRep?this.props.allInflabRtes4.allInflabRtes[ii].aceiteRep:""
              tot2 = this.props.allInflabRtes4.allInflabRtes[ii].aceiteTotal?this.props.allInflabRtes4.allInflabRtes[ii].aceiteTotal:""
              fec2 = this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra?this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra:""
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioLab){
                let fecha1 = moment(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioLab).format('YYYY-MM-DD')
                fecEnvio = fecha1
              }
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab){
                let fecha2 = moment(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab).format('YYYY-MM-DD')
                fecRecibe = fecha2
              }
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente){
                let fecha3 = moment(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente).format('YYYY-MM-DD')
                fecCliente = fecha3
              }
              fecEnv2 = fecEnvio
              fecRec2 = fecRecibe
              fecCli2 = fecCliente
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente && this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab){
                let fecha1 = new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente)
                fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
                fecha1=moment(fecha1)
                let fecha2 = new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab)
                fecha2 = (fecha2.getFullYear()) + '-' + ((fecha2.getMonth()+1)<10?'0'+(fecha2.getMonth()+1):(fecha2.getMonth()+1)) + '-' + (fecha2.getUTCDate()<10?'0'+fecha2.getUTCDate():fecha2.getUTCDate())
                fecha2=moment(fecha2)
                let numDias= fecha1.diff(fecha2, 'days')
                diasEnt2 = numDias
              }
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra && this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab){
                let fecha1 = new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab)
                fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
                fecha1=moment(fecha1)
                let fecha2=new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra)
                let numDias= fecha1.diff(fecha2, 'days')
                diasLog2 = numDias
              }
            }
            if(ii===2){
              inf1 = this.props.allInflabRtes4.allInflabRtes[ii].numeroInflab + "-" + this.props.allInflabRtes4.allInflabRtes[ii].mecInflab
              est1 = this.props.allInflabRtes4.allInflabRtes[ii].estado
              fab1 = this.props.allInflabRtes4.allInflabRtes[ii].descrFabricante
              lub1 = this.props.allInflabRtes4.allInflabRtes[ii].descrLubricante
              gra1 = this.props.allInflabRtes4.allInflabRtes[ii].tipoGrado + " " + this.props.allInflabRtes4.allInflabRtes[ii].descrGrado
              mue1 = this.props.allInflabRtes4.allInflabRtes[ii].tomaMuestra?this.props.allInflabRtes4.allInflabRtes[ii].tomaMuestra:""
              ult1 = this.props.allInflabRtes4.allInflabRtes[ii].ultimoCambio?this.props.allInflabRtes4.allInflabRtes[ii].ultimoCambio:""
              rec1 = this.props.allInflabRtes4.allInflabRtes[ii].recorrido?this.props.allInflabRtes4.allInflabRtes[ii].recorrido:""
              fil1 = this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAc?this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAc:""
              aire1 = this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAire?this.props.allInflabRtes4.allInflabRtes[ii].cambioFiltroAire:""
              rep1 = this.props.allInflabRtes4.allInflabRtes[ii].aceiteRep?this.props.allInflabRtes4.allInflabRtes[ii].aceiteRep:""
              tot1 = this.props.allInflabRtes4.allInflabRtes[ii].aceiteTotal?this.props.allInflabRtes4.allInflabRtes[ii].aceiteTotal:""
              fec1 = this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra?this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra:""
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioLab){
                let fecha1 = moment(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioLab).format('YYYY-MM-DD')
                fecEnvio = fecha1
              }
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab){
                let fecha2 = moment(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab).format('YYYY-MM-DD')
                fecRecibe = fecha2
              }
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente){
                let fecha3 = moment(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente).format('YYYY-MM-DD')
                fecCliente = fecha3
              }
              fecEnv1 = fecEnvio
              fecRec1 = fecRecibe
              fecCli1 = fecCliente
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente && this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab){
                let fecha1 = new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaEnvioCliente)
                fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
                fecha1=moment(fecha1)
                let fecha2 = new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab)
                fecha2 = (fecha2.getFullYear()) + '-' + ((fecha2.getMonth()+1)<10?'0'+(fecha2.getMonth()+1):(fecha2.getMonth()+1)) + '-' + (fecha2.getUTCDate()<10?'0'+fecha2.getUTCDate():fecha2.getUTCDate())
                fecha2=moment(fecha2)
                let numDias= fecha1.diff(fecha2, 'days')
                diasEnt1 = numDias
              }
              if(this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra && this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab){
                let fecha1 = new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaRecibeLab)
                fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
                fecha1=moment(fecha1)
                let fecha2=new Date(this.props.allInflabRtes4.allInflabRtes[ii].fechaMuestra)
                let numDias= fecha1.diff(fecha2, 'days')
                diasLog1 = numDias
              }
            }
          }
          console.timeEnd(2)
        }

        if(list[iiii].fechaEnvioCliente && list[iiii].fechaRecibeLab){
          let fecha1 = new Date(list[iiii].fechaEnvioCliente)
          fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
          fecha1=moment(fecha1)
          let fecha2 = new Date(list[iiii].fechaRecibeLab)
          fecha2 = (fecha2.getFullYear()) + '-' + ((fecha2.getMonth()+1)<10?'0'+(fecha2.getMonth()+1):(fecha2.getMonth()+1)) + '-' + (fecha2.getUTCDate()<10?'0'+fecha2.getUTCDate():fecha2.getUTCDate())
          fecha2=moment(fecha2)
          let numDias= fecha1.diff(fecha2, 'days')
          diasEnt = numDias
        }
        if(list[iiii].fechaMuestra && list[iiii].fechaRecibeLab){
          let fecha1 = new Date(list[iiii].fechaRecibeLab)
          fecha1 = (fecha1.getFullYear()) + '-' + ((fecha1.getMonth()+1)<10?'0'+(fecha1.getMonth()+1):(fecha1.getMonth()+1)) + '-' + (fecha1.getUTCDate()<10?'0'+fecha1.getUTCDate():fecha1.getUTCDate())
          fecha1=moment(fecha1)
          let fecha2=new Date(list[iiii].fechaMuestra)
          let numDias= fecha1.diff(fecha2, 'days')
          diasLog = numDias
        }

        let updColeccInf = []
        let argsUpd = {}
        argsUpd['_id'] = list[iiii]._id
        argsUpd['mecInflab'] = list[iiii].mecInflab
        argsUpd['tipoAct'] = 'EditarHist'

        argsUpd['inf1'] = inf1
        argsUpd['inf2'] = inf2
        argsUpd['inf3'] = inf3
        argsUpd['est1'] = est1
        argsUpd['est2'] = est2
        argsUpd['est3'] = est3
        argsUpd['fab1'] = fab1
        argsUpd['fab2'] = fab2
        argsUpd['fab3'] = fab3
        argsUpd['lub1'] = lub1
        argsUpd['lub2'] = lub2
        argsUpd['lub3'] = lub3
        argsUpd['gra1'] = gra1
        argsUpd['gra2'] = gra2
        argsUpd['gra3'] = gra3
        argsUpd['mue1'] = mue1
        argsUpd['mue2'] = mue2
        argsUpd['mue3'] = mue3
        argsUpd['ult1'] = ult1
        argsUpd['ult2'] = ult2
        argsUpd['ult3'] = ult3
        argsUpd['rec1'] = rec1.toString()
        argsUpd['rec2'] = rec2.toString()
        argsUpd['rec3'] = rec3.toString()
        argsUpd['fil1'] = fil1
        argsUpd['fil2'] = fil2
        argsUpd['fil3'] = fil3
        argsUpd['aire1'] = aire1
        argsUpd['aire2'] = aire2
        argsUpd['aire3'] = aire3
        argsUpd['rep1'] = rep1.toString()
        argsUpd['rep2'] = rep2.toString()
        argsUpd['rep3'] = rep3.toString()
        argsUpd['tot1'] = tot1.toString()
        argsUpd['tot2'] = tot2.toString()
        argsUpd['tot3'] = tot3.toString()
        argsUpd['fec1'] = fec1
        argsUpd['fec2'] = fec2
        argsUpd['fec3'] = fec3
        argsUpd['fecEnv1'] = fecEnv1
        argsUpd['fecEnv2'] = fecEnv2
        argsUpd['fecEnv3'] = fecEnv3
        argsUpd['fecRec1'] = fecRec1
        argsUpd['fecRec2'] = fecRec2
        argsUpd['fecRec3'] = fecRec3
        argsUpd['fecCli1'] = fecCli1
        argsUpd['fecCli2'] = fecCli2
        argsUpd['fecCli3'] = fecCli3
        argsUpd['diasEnt'] = diasEnt.toString()
        argsUpd['diasLog'] = diasLog.toString()
        argsUpd['diasEnt1'] = diasEnt1.toString()
        argsUpd['diasEnt2'] = diasEnt2.toString()
        argsUpd['diasEnt3'] = diasEnt3.toString()
        argsUpd['diasLog1'] = diasLog1.toString()
        argsUpd['diasLog2'] = diasLog2.toString()
        argsUpd['diasLog3'] = diasLog3.toString()

console.time(3)
        updColeccInf.push(argsUpd)
        argsUpd = {}
        
        let numDocCRUD = 0
        let totDocCRUD = 1
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editInflab)
        }
        argsCrud[numDocCRUD] = updColeccInf[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editInflab
        await this.updColecc(crudColecc, argsCrud, totDocCRUD)
console.timeEnd(3)
        // for (let i=0;i<this.props.allEmpresa.allEmpresa.length;i++){
        //   let empresas=this.props.allEmpresa.allEmpresa[i]
        //   if(empresas.descrEmpresa===list[iiii].descrEmpresa){
        //       contacto=list[iiii].nombreUsuario?list[iiii].nombreUsuario:''
        //       mail=list[iiii].email?list[iiii].email:''
        //     if(empresas.telefono!==null && empresas.telefono!==''){
        //       telefono=list[iiii].telefono?list[iiii].telefono:empresas.telefono
        //     }  
        //     if(empresas.logo!==null && empresas.logo!==''){
        //       logo="https://montserratslcm.com/images/logos/" + empresas.logo
        //     }  
        //   }
        // } 


        contacto=list[iiii].nombreUsuario?list[iiii].nombreUsuario:''
        mail=list[iiii].email?list[iiii].email:''
        let indexEmp = allEmpresa.findIndex( empresa => empresa.descrEmpresa===list[iiii].descrEmpresa.replace(/^\s+|\s+$/g, ''))
        if(indexEmp!==-1){
          telefono=list[iiii].telefono?list[iiii].telefono:allEmpresa[indexEmp].telefono?allEmpresa[indexEmp].telefono:''
          if(allEmpresa[indexEmp].logo!==null && allEmpresa[indexEmp].logo!==''){
            logo="https://montserratslcm.com/images/logos/" + allEmpresa[indexEmp].logo
          }
        }


        let rutaLogo=this.props.rutaLogo
        let macro=this.props.versionMacroUA 

        let argsBuscarPl = {tipoqry: `[
          {$match: {mecInflab: {$ne: ${list[iiii].mecInflab}}, fechaMuestra: {$lt: '${list[iiii].fechaMuestra}'},
            estadoInflab: 'FINALIZADO', descrPlanta: '${list[iiii].descrPlanta}',
            descrSeccion: '${list[iiii].descrSeccion}', descrEquipo: '${list[iiii].descrEquipo}',
            descrComponente: '${list[iiii].descrComponente}', descrMecanismo: '${list[iiii].descrMecanismo}'}},
            {$sort: {fechaMuestra: -1, numeroInflab: -1, mecInflab: -1}}
        ]`}    
        let response = await this.props.allInflabRtes3.refetch(argsBuscarPl)
        .then (async(response)=>{
          let histPru=[]
          if(response.data && response.data.allInflabRtes){
            histPru=response.data.allInflabRtes 
          }
  
          let updColeccEst = []
          let argsUpdEst = {}

          for (let i=0;i<allPrueba.length;i++){
            let prueba=allPrueba[i]
            let existeRef=1
            let regExisteVR = 0
            let VA1 = "", VA2 = "", VA3 = ""
            let VC1 = "", VC2 = "", VC3 = ""

            if(prueba.tipoPrueba!=='Pruebas especiales'){
              if((prueba.campoBD==='codigoPar') && (list[iiii].descrAplicacion==='CADENAS Y RODAMIENTOS') && (list[iiii].descrEmpresa==='GECELCA S.A.S. E.S.P.')){
                VA1 = 24
                VA2 = 23
                VA3 = 21
                VC1 = 25
                VC2 = 24
                VC3 = 22
                regExisteVR = 1
              }else{
                if((prueba.campoBD==='codigoPar') && (list[iiii].descrAplicacion==='ENGRANAJES' || list[iiii].descrAplicacion==='ENGRANAJES AUTOMOTRICES' || list[iiii].descrAplicacion==='HIDRAULICO') && (list[iiii].descrEmpresa==='GECELCA S.A.S. E.S.P.')){
                  VA1 = 23
                  VA2 = 22
                  VA3 = 20
                  VC1 = 24
                  VC2 = 23
                  VC3 = 21
                  regExisteVR = 1
                }else{
                  if((prueba.campoBD==='codigoPar' || prueba.campoBD==='micras4' || prueba.campoBD==='micras6' || prueba.campoBD==='micras14' || prueba.campoBD==='micras21' || prueba.campoBD==='micras25' || prueba.campoBD==='micras38' || prueba.campoBD==='micras70') && (list[iiii].descrAplicacion==='COMPRESORES') && (list[iiii].descrEmpresa==='GECELCA S.A.S. E.S.P.')){
                    switch(prueba.campoBD){
                      case 'codigoPar':
                        VA1 = 18
                        VA2 = 17
                        VA3 = 15
                        VC1 = 19
                        VC2 = 18
                        VC3 = 16
                        regExisteVR = 1
                        break
                      case 'micras4':
                        VA1 = 130000
                        VC1 = 250000
                        regExisteVR = 1
                        console.log(VA1, VC1, regExisteVR)
                        break
                      case 'micras6':
                        VA1 = 64000
                        VC1 = 130000
                        regExisteVR = 1
                        break
                      case 'micras14':
                        VA1 = 16000
                        VC1 = 32000
                        regExisteVR = 1
                        break
                      case 'micras21':
                        VA1 = 8000
                        VC1 = 16000
                        regExisteVR = 1
                        break
                      case 'micras25':
                        VA1 = 4000
                        VC1 = 8000
                        regExisteVR = 1
                        break
                      case 'micras38':
                        VA1 = 2000
                        VC1 = 4000
                        regExisteVR = 1
                        break
                      case 'micras70':
                        VA1 = 1000
                        VC1 = 2000
                        regExisteVR = 1
                        break
                    }
                  }else{
                    if((prueba.campoBD==='codigoPar') && (list[iiii].descrAplicacion==='TURBINAS DE VAPOR') && (list[iiii].descrEmpresa==='GECELCA S.A.S. E.S.P.')){
                      VA1 = 21
                      VA2 = 20
                      VA3 = 18
                      VC1 = 22
                      VC2 = 21
                      VC3 = 19
                      regExisteVR = 1
                    }else{
                      if((prueba.campoBD==='codigoPar') && (list[iiii].descrAplicacion==='HIDRAULICO') && (list[iiii].descrEmpresa==='SCHOTTEL de Colombia S.A.S')){
                        VA1 = 21
                        VA2 = 19
                        VA3 = 14
                        VC1 = 22
                        VC2 = 20
                        VC3 = 15
                        regExisteVR = 1
                      }else{
                        if((prueba.campoBD==='codigoPar') && (list[iiii].descrAplicacion==='ENGRANAJES') && (list[iiii].descrEmpresa==='SCHOTTEL de Colombia S.A.S')){
                          VA1 = 21
                          VA2 = 19
                          VA3 = 16
                          VC1 = 22
                          VC2 = 20
                          VC3 = 17
                          regExisteVR = 1
                        }else{
                          if((prueba.campoBD==='agua' || prueba.campoBD==='fischer') && ((list[iiii].descrAplicacion==='ENGRANAJES') || (list[iiii].descrAplicacion==='HIDRAULICO')) && (list[iiii].descrEmpresa==='SCHOTTEL de Colombia S.A.S')){
                            VA1 = 0.2
                            VC1 = 0.5
                            regExisteVR = 1
                          }else{
                            if((prueba.campoBD==='hierro') && ((list[iiii].descrAplicacion==='ENGRANAJES') || (list[iiii].descrAplicacion==='HIDRAULICO')) && (list[iiii].descrEmpresa==='SCHOTTEL de Colombia S.A.S')){
                              VA1 = 20
                              VC1 = 50
                              regExisteVR = 1
                            }else{
                              if((prueba.campoBD==='cromo') && ((list[iiii].descrAplicacion==='ENGRANAJES') || (list[iiii].descrAplicacion==='HIDRAULICO')) && (list[iiii].descrEmpresa==='SCHOTTEL de Colombia S.A.S')){
                                VA1 = 2
                                VC1 = 5
                                regExisteVR = 1
                              }else{
                                if((prueba.campoBD==='aluminio') && ((list[iiii].descrAplicacion==='ENGRANAJES') || (list[iiii].descrAplicacion==='HIDRAULICO')) && (list[iiii].descrEmpresa==='SCHOTTEL de Colombia S.A.S')){
                                  VA1 = 5
                                  VC1 = 20
                                  regExisteVR = 1
                                }else{
                                  if((prueba.campoBD==='cobre') && ((list[iiii].descrAplicacion==='ENGRANAJES') || (list[iiii].descrAplicacion==='HIDRAULICO')) && (list[iiii].descrEmpresa==='SCHOTTEL de Colombia S.A.S')){
                                    VA1 = 20
                                    VC1 = 50
                                    regExisteVR = 1
                                  }else{
                                    if((prueba.campoBD==='plomo') && ((list[iiii].descrAplicacion==='ENGRANAJES') || (list[iiii].descrAplicacion==='HIDRAULICO')) && (list[iiii].descrEmpresa==='SCHOTTEL de Colombia S.A.S')){
                                      VA1 = 4
                                      VC1 = 10
                                      regExisteVR = 1
                                    }else{
                                      if((prueba.campoBD==='vanadio') && ((list[iiii].descrAplicacion==='ENGRANAJES') || (list[iiii].descrAplicacion==='HIDRAULICO')) && (list[iiii].descrEmpresa==='SCHOTTEL de Colombia S.A.S')){
                                        VA1 = 3
                                        VC1 = 10
                                        regExisteVR = 1
                                      }else{
                                        if((prueba.campoBD==='sodio') && ((list[iiii].descrAplicacion==='ENGRANAJES') || (list[iiii].descrAplicacion==='HIDRAULICO')) && (list[iiii].descrEmpresa==='SCHOTTEL de Colombia S.A.S')){
                                          VA1 = 0.5
                                          VC1 = 5
                                          regExisteVR = 1
                                        }else{
                                          let indexRef = mecvalref.findIndex( mecvalref => mecvalref.descrEmpresa===list[iiii].descrEmpresa && 
                                            mecvalref.descrPlanta===list[iiii].descrPlanta && mecvalref.descrSeccion===list[iiii].descrSeccion && 
                                            mecvalref.descrEquipo===list[iiii].descrEquipo && mecvalref.descrComponente===list[iiii].descrComponente && 
                                            mecvalref.descrMecanismo===list[iiii].descrMecanismo && mecvalref.descrAplicacion===list[iiii].descrAplicacion && mecvalref.descrPrueba===prueba.descrPrueba)
                                          if(indexRef===-1){
                                            existeRef=0
                                          }

                                          if(existeRef===1){
                                            regExisteVR = 1
                                            VA1 = mecvalref[indexRef].valor1Alarma
                                            VA2 = mecvalref[indexRef].valor2Alarma
                                            VA3 = mecvalref[indexRef].valor3Alarma
                                            VC1 = mecvalref[indexRef].valor1Corte
                                            VC2 = mecvalref[indexRef].valor2Corte
                                            VC3 = mecvalref[indexRef].valor3Corte
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            let indexLinea = this.state.lineaPru.findIndex( lineaFind => lineaFind.pru===prueba.campoBD)
            let numLinea=-1
            if (indexLinea!==-1){
              numLinea=this.state.lineaPru[indexLinea].linea
            }   
            let elemento=list[iiii]

            argsUpdEst['mecInflab'] = list[iiii].mecInflab
            argsUpdEst['tipoAct'] = 'EditarEstados'
            let nomPruEst=prueba.campoBD + 'E'
            let nomPruVar=prueba.campoBD + 'V'
            let argsReturn= {}

console.time(4)
            argsReturn= await this.procesarPrueba(elemento, prueba, numLinea, histPru, regExisteVR, VA1, VA2, VA3, VC1,VC2, VC3)
console.timeEnd(4)

            if(argsReturn.argsRte){
              let argsRteIL = {...argsReturn.argsRte}
              if(prueba.tipoPrueba!=='Pruebas especiales'){
                if((argsRteIL.columna8 && argsRteIL.columna8!==null && argsRteIL.columna8!=='')
                  || (argsRteIL.columna11 && argsRteIL.columna11!==null && argsRteIL.columna11!=='')
                  || (argsRteIL.columna10 && argsRteIL.columna10!==null && argsRteIL.columna10!=='')
                  || (argsRteIL.columna9 && argsRteIL.columna9!==null && argsRteIL.columna9!=='')){
                    if(argsRteIL.columna11!==null && argsRteIL.columna11!==''){
                    argsRteIL.columna11 = argsRteIL.columna11.toString()
                  }else{
                    argsRteIL.columna11 = ""
                  }
                  numPruebas+=1
                  reportes.push(argsRteIL)
                }
              }else{
                if(prueba.descrPrueba==='Demulsibilidad Aceite'){
                  if(argsReturn.argsRteDemul){
                    let argsRteILDemul = {...argsReturn.argsRteDemul}
                    reportes.push(argsRteILDemul)
                    
                  }
                }
                if(prueba.campoBD==='separaA54'){
                  if(argsReturn.argsRteSepara54){
                    let argsRteILSepara54 = {...argsReturn.argsRteSepara54}
                    reportes.push(argsRteILSepara54)
                    
                  }
                }
                if(prueba.campoBD==='separaA82'){
                  if(argsReturn.argsRteSepara82){
                    let argsRteILSepara82 = {...argsReturn.argsRteSepara82}
                    reportes.push(argsRteILSepara82)
                    
                  }
                }
                if((argsRteIL.columna13!==null && argsRteIL.columna13!=='')
                  || (argsRteIL.columna12!==null && argsRteIL.columna12!=='')
                  || (argsRteIL.columna11!==null && argsRteIL.columna11!=='')
                  || (argsRteIL.columna10!==null && argsRteIL.columna10!=='')){
                  if(argsRteIL.columna13 && argsRteIL.columna13!==null && argsRteIL.columna13!==''){
                    argsRteIL.columna13 = argsRteIL.columna13.toString()
                  }else{
                    argsRteIL.columna13 = ""
                  }
                  if((prueba.descrPrueba!=='Demulsibilidad Aceite' && prueba.descrPrueba!=='Demulsibilidad Agua' && prueba.descrPrueba!=='Demulsibilidad Emulsión' && prueba.descrPrueba!=='Demulsibilidad Tiempo' 
                    && prueba.campoBD!=='separaA54' && prueba.campoBD!=='separaAg54' && prueba.campoBD!=='separaE54' && prueba.campoBD!=='separaT54' 
                    && prueba.campoBD!=='separaA82' && prueba.campoBD!=='separaAg82' && prueba.campoBD!=='separaE82' && prueba.campoBD!=='separaT82')){
                    numPruebasE+=1
                  }
                  if(!argsRteIL.columna1){

                  }
                  reportes.push(argsRteIL)
                }  
              }
              if(argsRteIL.columna30!==null && argsRteIL.columna30!==''){
                argsUpdEst[nomPruEst] = argsRteIL.columna30
              }else{
                argsUpdEst[nomPruEst] = ''
              }
              if(prueba.campoBD==='separaA54'){

              }
              if(argsRteIL.columna25==='Pruebas especiales'){
                if(argsRteIL.columna14!==null && argsRteIL.columna14!=='' && argsRteIL.columna14!=='N/A' && argsRteIL.columna14!=='NaN'){
                  argsUpdEst[nomPruVar] = argsRteIL.columna14
                }else{
                  argsUpdEst[nomPruVar] = ''
                }
              }else{
                if(argsRteIL.columna12!==null && argsRteIL.columna12!=='' && argsRteIL.columna12!=='N/A' && argsRteIL.columna12!=='NaN'){
                  argsUpdEst[nomPruVar] = argsRteIL.columna12
                }else{
                  argsUpdEst[nomPruVar] = ''
                }
              }
            }else{
              argsUpdEst[nomPruEst] = ''
              argsUpdEst[nomPruVar] = ''
            }
            if(i===allPrueba.length-1){
              let indexPru = reportes.findIndex( estadoFind => estadoFind.columna2==='Partículas > 4 micras')
              if (indexPru!==-1){
                estado4mic=reportes[indexPru].columna30
              }            
              indexPru = reportes.findIndex( estadoFind => estadoFind.columna2==='Partículas > 6 micras')
              if (indexPru!==-1){
                estado6mic=reportes[indexPru].columna30
              }  
              indexPru = reportes.findIndex( estadoFind => estadoFind.columna2==='Partículas > 14 micras')
              
              if (indexPru!==-1){
                estado14mic=reportes[indexPru].columna30
              }  
              if(!estado4mic || !estado6mic || !estado14mic){
                estadoIso=''
              }else{
                if(estado4mic==='CONFIABLE' && estado6mic==='CONFIABLE' && estado14mic==='CONFIABLE'){
                  estadoIso='CONFIABLE'
                }else{
                  if(estado4mic==='PELIGRO' && estado6mic==='PELIGRO' && estado14mic==='PELIGRO'){
                    estadoIso='PELIGRO'
                  }else{
                    estadoIso='ALARMA'
                  }
                }
              }
              argsUpdEst['codigoParE'] = estadoIso
              indexPru = reportes.findIndex( estadoFind => estadoFind.columna2==='Código de partículas')
              
              if (indexPru!==-1){
                reportes[indexPru].columna30=estadoIso
                codPar=reportes[indexPru].columna11
              }  

              let indexEstado = reportes.findIndex( estadoFind => estadoFind.columna30==='PELIGRO'
                  && estadoFind.columna2!=='Partículas > 4 micras'
                  && estadoFind.columna2!=='Partículas > 6 micras'
                  && estadoFind.columna2!=='Partículas > 14 micras'
                  && estadoFind.columna2!=='Partículas > 21 micras'
                  && estadoFind.columna2!=='Partículas > 25 micras'
                  && estadoFind.columna2!=='Partículas > 38 micras'
                  && estadoFind.columna2!=='Partículas > 70 micras')
              if (indexEstado!==-1){
                estadoLub='PELIGRO'
              }     
              if(estadoLub!=='PELIGRO'){
                let indexEstado = reportes.findIndex( estadoFind => estadoFind.columna30==='ALARMA'
                    && estadoFind.columna2!=='Partículas > 4 micras'
                    && estadoFind.columna2!=='Partículas > 6 micras'
                    && estadoFind.columna2!=='Partículas > 14 micras'
                    && estadoFind.columna2!=='Partículas > 21 micras'
                    && estadoFind.columna2!=='Partículas > 25 micras'
                    && estadoFind.columna2!=='Partículas > 38 micras'
                    && estadoFind.columna2!=='Partículas > 70 micras')
                if (indexEstado!==-1){
                  estadoLub='ALARMA'
                }    
                if(estadoLub!=='ALARMA'){
                  let indexEstado = reportes.findIndex( estadoFind => estadoFind.columna30==='PRECAUCION'
                    && estadoFind.columna2!=='Partículas > 4 micras'
                    && estadoFind.columna2!=='Partículas > 6 micras'
                    && estadoFind.columna2!=='Partículas > 14 micras'
                    && estadoFind.columna2!=='Partículas > 21 micras'
                    && estadoFind.columna2!=='Partículas > 25 micras'
                    && estadoFind.columna2!=='Partículas > 38 micras'
                    && estadoFind.columna2!=='Partículas > 70 micras')
                if (indexEstado!==-1){
                  estadoLub='PRECAUCION'
                }    
                if(estadoLub!=='PRECAUCION'){
                  let indexEstado = reportes.findIndex( estadoFind => estadoFind.columna30==='CONFIABLE'
                      && estadoFind.columna2!=='Partículas > 4 micras'
                      && estadoFind.columna2!=='Partículas > 6 micras'
                      && estadoFind.columna2!=='Partículas > 14 micras'
                      && estadoFind.columna2!=='Partículas > 21 micras'
                      && estadoFind.columna2!=='Partículas > 25 micras'
                      && estadoFind.columna2!=='Partículas > 38 micras'
                      && estadoFind.columna2!=='Partículas > 70 micras')
                  if (indexEstado!==-1){
                    estadoLub='CONFIABLE'
                  }    
                  if(estadoLub!=='CONFIABLE'){
                    estadoLub='NO MEDIDO'
                  }        
                  }  
                }        
              }     
              

                let estado1=''
                let estado2=''
                let estado3=''
                let estado4=''
                let estado5=''
                let estado6=''
                let resultado1=0
                let resultado2=0
                let resultado3=0
                let resultado4=0
                let resultado5=0
                let resultado6=0
                let resultadoTemp=0

                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Ruler %')
                if (indexPru!==-1){
                  estado1=reportes[indexPru].columna30
                  resultado1=reportes[indexPru].columna13
                }            
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Ruler Aminas')
                if (indexPru!==-1){
                  estado2=reportes[indexPru].columna30
                  resultado2=reportes[indexPru].columna13
                }            
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Ruler Fenoles')
                if (indexPru!==-1){
                  estado3=reportes[indexPru].columna30
                  resultado3=reportes[indexPru].columna13
                }  
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Ruler ZDDP')
                if (indexPru!==-1){
                  estado4=reportes[indexPru].columna30
                  resultado4=reportes[indexPru].columna13
                }  

                if(!estado1){
                  estado1=''
                }else{
                  if(estado1==='CONFIABLE'){
                    estado1='CONFIABLE'
                  }else{
                    if(estado1==='PELIGRO'){
                      estado1='PELIGRO'
                    }else{
                      if(estado1==='ALARMA'){
                        estado1='ALARMA'
                      }else{
                        estado1='PRECAUCION'
                      }
                    }
                  }
                }
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Ruler %')
                let indexPruR = allPrueba.findIndex( prueba => prueba.descrPrueba==='Ruler %')
                if (indexPru!==-1 && estado1!==''){
                  if(estado1==='CONFIABLE'){
                    reportes[indexPru].columna15=allPrueba[indexPruR].analisisCon
                    reportes[indexPru].columna16=allPrueba[indexPruR].recomenCon
                  }else{
                    if(estado1==='PRECAUCION'){
                      reportes[indexPru].columna15=allPrueba[indexPruR].analisisPre
                      reportes[indexPru].columna16=allPrueba[indexPruR].recomenPre
                    }else{
                      if(estado1==='ALARMA'){
                        reportes[indexPru].columna15=allPrueba[indexPruR].analisisAla
                        reportes[indexPru].columna16=allPrueba[indexPruR].recomenAla
                      }else{
                        reportes[indexPru].columna15=allPrueba[indexPruR].analisisPel
                        reportes[indexPru].columna16=allPrueba[indexPruR].recomenPel
                      }                  
                    }
                  }
                  reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE5', estado1)
                  if(resultado1!==''){
                    resultado1=resultado1.replace(",", ".")
                    resultadoTemp=parseFloat(100 - resultado1).toFixed(2)
                    let resul2=100-resultado1
                    reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE1', resultadoTemp)
                    reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE2', resultado1)
                  }else{
                    reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE1', '')
                    reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE2', '')
                  }
                  if(resultado2!==''){
                    reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE3', resultado2)
                  }else{
                    reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE3', '')
                  }
                  if(resultado3!==''){
                    reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE4', resultado3)
                  }else{
                    reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE4', '')
                  }              
                } 
                
                let estadoDemul=''
                estado1=''
                estado2=''
                estado3=''
                estado4=''
                estado5=''
                estado6=''
                resultado1='X'
                resultado2='X'
                resultado3='X'
                resultado4='X'
                resultado5='X'
                resultado6='X'

                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Demulsibilidad Aceite')
                if (indexPru!==-1){
                  estado1=reportes[indexPru].columna30
                  resultado1=reportes[indexPru].columna13
                }            
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Demulsibilidad Agua')
                if (indexPru!==-1){
                  estado2=reportes[indexPru].columna30
                  resultado2=reportes[indexPru].columna13
                }            
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Demulsibilidad Emulsión')
                if (indexPru!==-1){
                  estado3=reportes[indexPru].columna30
                  resultado3=reportes[indexPru].columna13
                }  
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Demulsibilidad Tiempo')
                if (indexPru!==-1){
                  estado4=reportes[indexPru].columna30
                  resultado4=reportes[indexPru].columna13
                }  

                if(!estado1 && !estado2 && !estado3 && !estado4){
                  estadoDemul=''
                }else{
                  numPruebasE+=1
                  if(estado1==='CONFIABLE' && estado2==='CONFIABLE' && estado3==='CONFIABLE' && estado4==='CONFIABLE'){
                    estadoDemul='CONFIABLE'
                  }else{
                    if(estado1==='PELIGRO' || estado2==='PELIGRO' || estado3==='PELIGRO' || estado4==='PELIGRO'){
                      estadoDemul='PELIGRO'
                    }else{
                      if(estado1==='ALARMA' || estado2==='ALARMA' || estado3==='ALARMA' || estado4==='ALARMA'){
                        estadoDemul='ALARMA'
                      }else{
                        estadoDemul='PRECAUCION'
                      }
                    }
                  }
                }
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Demulsibilidad (Aceite/Agua/Emulsión (Tiempo))')
                let indexPruD = allPrueba.findIndex( prueba => prueba.descrPrueba==='Demulsibilidad Aceite')
                if (indexPru!==-1 && estadoDemul!==''){
                  if(estadoDemul==='CONFIABLE'){
                    reportes[indexPru].columna15=allPrueba[indexPruD].analisisCon
                    reportes[indexPru].columna16=allPrueba[indexPruD].recomenCon
                  }else{
                    if(estadoDemul==='PRECAUCION'){
                      reportes[indexPru].columna15=allPrueba[indexPruD].analisisPre
                      reportes[indexPru].columna16=allPrueba[indexPruD].recomenPre
                    }else{
                      if(estadoDemul==='ALARMA'){
                        reportes[indexPru].columna15=allPrueba[indexPruD].analisisAla
                        reportes[indexPru].columna16=allPrueba[indexPruD].recomenAla
                      }else{
                        reportes[indexPru].columna15=allPrueba[indexPruD].analisisPel
                        reportes[indexPru].columna16=allPrueba[indexPruD].recomenPel
                      }                  
                    }
                  }
                  reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE2', estadoDemul)
                  resultadoTemp=resultado1 + '/' + resultado2 + '/' + resultado3 + ' (' + resultado4 + ')'
                  reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE1', resultadoTemp)
                  reportes[indexPru].columna13=resultadoTemp
                  reportes[indexPru].columna30=estadoDemul
                } 





                let estadoSep54=''
                estado1=''
                estado2=''
                estado3=''
                estado4=''
                estado5=''
                estado6=''
                resultado1='X'
                resultado2='X'
                resultado3='X'
                resultado4='X'
                resultado5='X'
                resultado6='X'

                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Separabilidad Aceite a 54ºC')
                if (indexPru!==-1){
                  estado1=reportes[indexPru].columna30
                  resultado1=reportes[indexPru].columna13
                }            
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Separabilidad Agua a 54ºC')
                if (indexPru!==-1){
                  estado2=reportes[indexPru].columna30
                  resultado2=reportes[indexPru].columna13
                }            
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Separabilidad Emulsión a 54ºC')
                if (indexPru!==-1){
                  estado3=reportes[indexPru].columna30
                  resultado3=reportes[indexPru].columna13
                }  
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Separabilidad Tiempo a 54ºC')
                if (indexPru!==-1){
                  estado4=reportes[indexPru].columna30
                  resultado4=reportes[indexPru].columna13
                }  
                if(!estado1 && !estado2 && !estado3 && !estado4){
                  estadoSep54=''
                }else{
                  numPruebasE+=1
                  if(estado1==='CONFIABLE' && estado2==='CONFIABLE' && estado3==='CONFIABLE' && estado4==='CONFIABLE'){
                    estadoSep54='CONFIABLE'
                  }else{
                    if(estado1==='PELIGRO' || estado2==='PELIGRO' || estado3==='PELIGRO' || estado4==='PELIGRO'){
                      estadoSep54='PELIGRO'
                    }else{
                      if(estado1==='ALARMA' || estado2==='ALARMA' || estado3==='ALARMA' || estado4==='ALARMA'){
                        estadoSep54='ALARMA'
                      }else{
                        estadoSep54='PRECAUCION'
                      }
                    }
                  }
                }
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Separabilidad a 54ºC (Aceite/Agua/Emulsión (Tiempo))')
                let indexPruS54 = allPrueba.findIndex( prueba => prueba.descrPrueba==='Separabilidad Aceite a 54ºC')
                if (indexPruS54!==-1 && estadoSep54!==''){
                  if(estadoSep54==='CONFIABLE'){
                    reportes[indexPru].columna15=allPrueba[indexPruS54].analisisCon
                    reportes[indexPru].columna16=allPrueba[indexPruS54].recomenCon
                  }else{
                    if(estadoSep54==='PRECAUCION'){
                      reportes[indexPru].columna15=allPrueba[indexPruS54].analisisPre
                      reportes[indexPru].columna16=allPrueba[indexPruS54].recomenPre
                    }else{
                      if(estadoSep54==='ALARMA'){
                        reportes[indexPru].columna15=allPrueba[indexPruS54].analisisAla
                        reportes[indexPru].columna16=allPrueba[indexPruS54].recomenAla
                      }else{
                        reportes[indexPru].columna15=allPrueba[indexPruS54].analisisPel
                        reportes[indexPru].columna16=allPrueba[indexPruS54].recomenPel
                      }                  
                    }
                  }
                  reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE2', estadoSep54)
                  resultadoTemp=resultado1 + '/' + resultado2 + '/' + resultado3 + ' (' + resultado4 + ')'
                  reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE1', resultadoTemp)
                  reportes[indexPru].columna13=resultadoTemp
                  reportes[indexPru].columna30=estadoSep54
                } 


                let estadoSep82=''
                estado1=''
                estado2=''
                estado3=''
                estado4=''
                estado5=''
                estado6=''
                resultado1='X'
                resultado2='X'
                resultado3='X'
                resultado4='X'
                resultado5='X'
                resultado6='X'

                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Separabilidad Aceite a 82ºC')
                if (indexPru!==-1){
                  estado1=reportes[indexPru].columna30
                  resultado1=reportes[indexPru].columna13
                }            
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Separabilidad Agua a 82ºC')
                if (indexPru!==-1){
                  estado2=reportes[indexPru].columna30
                  resultado2=reportes[indexPru].columna13
                }            
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Separabilidad Emulsión a 82ºC')
                if (indexPru!==-1){
                  estado3=reportes[indexPru].columna30
                  resultado3=reportes[indexPru].columna13
                }  
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Separabilidad Tiempo a 82ºC')
                if (indexPru!==-1){
                  estado4=reportes[indexPru].columna30
                  resultado4=reportes[indexPru].columna13
                }  

                if(!estado1 && !estado2 && !estado3 && !estado4){
                  estadoSep82=''
                }else{
                  numPruebasE+=1
                  if(estado1==='CONFIABLE' && estado2==='CONFIABLE' && estado3==='CONFIABLE' && estado4==='CONFIABLE'){
                    estadoSep82='CONFIABLE'
                  }else{
                    if(estado1==='PELIGRO' || estado2==='PELIGRO' || estado3==='PELIGRO' || estado4==='PELIGRO'){
                      estadoSep82='PELIGRO'
                    }else{
                      if(estado1==='ALARMA' || estado2==='ALARMA' || estado3==='ALARMA' || estado4==='ALARMA'){
                        estadoSep82='ALARMA'
                      }else{
                        estadoSep82='PRECAUCION'
                      }
                    }
                  }
                }
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Separabilidad a 82ºC (Aceite/Agua/Emulsión (Tiempo))')
                let indexPruS82 = allPrueba.findIndex( prueba => prueba.descrPrueba==='Separabilidad Aceite a 82ºC')
                if (indexPruS82!==-1 && estadoSep82!==''){
                  if(estadoSep82==='CONFIABLE'){
                    reportes[indexPru].columna15=allPrueba[indexPruS82].analisisCon
                    reportes[indexPru].columna16=allPrueba[indexPruS82].recomenCon
                  }else{
                    if(estadoSep82==='PRECAUCION'){
                      reportes[indexPru].columna15=allPrueba[indexPruS82].analisisPre
                      reportes[indexPru].columna16=allPrueba[indexPruS82].recomenPre
                    }else{
                      if(estadoSep82==='ALARMA'){
                        reportes[indexPru].columna15=allPrueba[indexPruS82].analisisAla
                        reportes[indexPru].columna16=allPrueba[indexPruS82].recomenAla
                      }else{
                        reportes[indexPru].columna15=allPrueba[indexPruS82].analisisPel
                        reportes[indexPru].columna16=allPrueba[indexPruS82].recomenPel
                      }                  
                    }
                  }
                  reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE2', estadoSep82)
                  resultadoTemp=resultado1 + '/' + resultado2 + '/' + resultado3 + ' (' + resultado4 + ')'
                  reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE1', resultadoTemp)
                  reportes[indexPru].columna13=resultadoTemp
                  reportes[indexPru].columna30=estadoSep82
                } 


                estado1=''
                estado2=''
                estado3=''
                estado4=''
                estado5=''
                estado6=''
                resultado1='X'
                resultado2='X'
                resultado3='X'
                resultado4='X'
                resultado5='X'
                resultado6='X'

                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Espumas Secuencia I (0.0 min) Tendencia')
                if (indexPru!==-1){
                  estado1=reportes[indexPru].columna30
                  resultado1=reportes[indexPru].columna13
                }            
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Espumas Secuencia I (10 min) Estabilidad')
                if (indexPru!==-1){
                  estado2=reportes[indexPru].columna30
                  resultado2=reportes[indexPru].columna13
                }            
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Espumas Secuencia II (0.0 min) Tendencia')
                if (indexPru!==-1){
                  estado3=reportes[indexPru].columna30
                  resultado3=reportes[indexPru].columna13
                }  
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Espumas Secuencia II (10 min) Estabilidad')
                if (indexPru!==-1){
                  estado4=reportes[indexPru].columna30
                  resultado4=reportes[indexPru].columna13
                }  
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Espumas Secuencia III (0.0 min) Tendencia')
                if (indexPru!==-1){
                  estado5=reportes[indexPru].columna30
                  resultado5=reportes[indexPru].columna13
                }  
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Espumas Secuencia III (10 min) Estabilidad')
                if (indexPru!==-1){
                  estado6=reportes[indexPru].columna30
                  resultado6=reportes[indexPru].columna13
                }  

                if(!estado1 && !estado2 && !estado3 && !estado4 && !estado5 && !estado6){
                  estado1=''
                }else{
                  if(estado1==='CONFIABLE' && estado2==='CONFIABLE' && estado3==='CONFIABLE' && estado4==='CONFIABLE' && estado5==='CONFIABLE' && estado6==='CONFIABLE'){
                    estado1='CONFIABLE'
                  }else{
                    if(estado1==='PELIGRO' || estado2==='PELIGRO' || estado3==='PELIGRO' || estado4==='PELIGRO' || estado5==='PELIGRO' || estado6==='PELIGRO'){
                      estado1='PELIGRO'
                    }else{
                      if(estado1==='ALARMA' || estado2==='ALARMA' || estado3==='ALARMA' || estado4==='ALARMA' || estado5==='ALARMA' || estado6==='ALARMA'){
                        estado1='ALARMA'
                      }else{
                        estado1='PRECAUCION'
                      }
                    }
                  }
                }
                indexPru = reportes.findIndex( estadoFind => estadoFind.columna1==='Espumas Secuencia I (0.0 min) Tendencia')
                let indexPruE = allPrueba.findIndex( prueba => prueba.descrPrueba==='Espumas Secuencia I (0.0 min) Tendencia')

                if (indexPru!==-1 && estado1!==''){
                  if(estado1==='CONFIABLE'){
                    reportes[indexPru].columna15=allPrueba[indexPruE].analisisCon
                    reportes[indexPru].columna16=allPrueba[indexPruE].recomenCon
                  }else{
                    if(estado1==='PRECAUCION'){
                      reportes[indexPru].columna15=allPrueba[indexPruE].analisisPre
                      reportes[indexPru].columna16=allPrueba[indexPruE].recomenPre
                    }else{
                      if(estado1==='ALARMA'){
                        reportes[indexPru].columna15=allPrueba[indexPruE].analisisAla
                        reportes[indexPru].columna16=allPrueba[indexPruE].recomenAla
                      }else{
                        reportes[indexPru].columna15=allPrueba[indexPruE].analisisPel
                        reportes[indexPru].columna16=allPrueba[indexPruE].recomenPel
                      }                  
                    }
                  }
                  reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE2', estado1)
                  resultadoTemp=resultado1 + '/' + resultado2 + '; ' + resultado3 + '/' + resultado4 + '; ' + resultado5 + '/' + resultado6
                  reportes[indexPru].columna15=reportes[indexPru].columna15.replace('VARIABLE1', resultadoTemp)
                } 
              // }
              
              let argsLinea=[]
              if(list[iiii].recorrido==null || list[iiii].recorrido==''){
                reco=''
              }else{
                reco=list[iiii].recorrido.toString()  
              }
              if(list[iiii].cambioFiltroAc==null || list[iiii].cambioFiltroAc==''){
                filtroAc=''
              }else{
                filtroAc=list[iiii].cambioFiltroAc  
              }
              if(list[iiii].cambioFiltroAire==null || list[iiii].cambioFiltroAire==''){
                filtroAire=''
              }else{
                filtroAire=list[iiii].cambioFiltroAire  
              }        
              if(list[iiii].aceiteRep==null || list[iiii].aceiteRep==''){
                aceiteR=''
              }else{
                aceiteR=list[iiii].aceiteRep.toString()  
              }  
              if(rep1==null || rep1==''){
                rep1=''
              }else{
                rep1=rep1.toString()  
              }  
              if(rep2==null || rep2==''){
                rep2=''
              }else{
                rep2=rep2.toString()  
              }  
              if(rep3==null || rep3==''){
                rep3=''
              }else{
                rep3=rep3.toString()  
              }  
              if(list[iiii].aceiteTotal==null || list[iiii].aceiteTotal==''){
                aceiteT=''
              }else{
                aceiteT=list[iiii].aceiteTotal.toString()  
              }  
              if(tot1==null || tot1==''){
                tot1=''
              }else{
                tot1=tot1.toString()  
              }  
              if(tot2==null || tot2==''){
                tot2=''
              }else{
                tot2=tot2.toString()  
              }  
              if(tot3==null || tot3==''){
                tot3=''
              }else{
                tot3=tot3.toString()  
              }
              let numOrden = ''
              if(list[iiii].numeroOrden==null || list[iiii].numeroOrden=='' || list[iiii].numeroOrden==0){
                numOrden=''
              }else{
                numOrden=list[iiii].numeroOrden.toString()   
              }  
              let numOrdenSAP = ''
              if(list[iiii].ordenSAP==null || list[iiii].ordenSAP=='' || list[iiii].ordenSAP==0){
                numOrdenSAP=''
              }else{
                numOrdenSAP=list[iiii].ordenSAP  
              }  
    
              let analisis = '', recomen = ''
              if(list[iiii].observaciones==null || list[iiii].observaciones==''){
              }else{
                analisis=list[iiii].observaciones  
              }  
              if(list[iiii].acciones==null || list[iiii].acciones==''){
              }else{
                recomen=list[iiii].acciones
              }  
              let ficha = ''
              let indexLub = allProducto.findIndex( producto => producto.descrLubricante===list[iiii].descrLubricante)
              if (indexLub!==-1){
                if (allProducto[indexLub].ficha==null || allProducto[indexLub].ficha==''){
                }else{
                  ficha=allProducto[indexLub].ficha
                }
              } 

              let fecEnvio = '', fecRecibe = '', fecCliente = ''
              if(list[iiii].fechaEnvioLab){
                let fecha1 = moment(list[iiii].fechaEnvioLab).format('YYYY-MM-DD')
                fecEnvio = fecha1
              }
              if(list[iiii].fechaRecibeLab){
                let fecha2 = moment(list[iiii].fechaRecibeLab).format('YYYY-MM-DD')
                fecRecibe = fecha2
              }
              if(list[iiii].fechaEnvioCliente){
                let fecha3 = moment(list[iiii].fechaEnvioCliente).format('YYYY-MM-DD')
                fecCliente = fecha3
              }

              let rutaLocal="", rutaRemota="", servidor="", usuario="", clave=""
              if(this.props.getParametro.getParametro){
                rutaLocal = this.props.getParametro.getParametro.rutaLocal
                rutaRemota = this.props.getParametro.getParametro.rutaRemota
                servidor = this.props.getParametro.getParametro.servidor
                usuario = this.props.getParametro.getParametro.usuario
                clave = this.props.getParametro.getParametro.clave
              }

              if(contacto==='Seleccionar Contacto...'){
                contacto=''
              }

              let aplicacion = list[iiii].descrAplicacion.replace('ACEITE PARA ', '')
              aplicacion = aplicacion.replace('ACEITES DE ', '')
              aplicacion = aplicacion.replace('ACEITES ', '')
              aplicacion = aplicacion.replace('ACEITE ', '')
              argsLinea=this.crearLinea('','','','INFORME DE LABORATORIO DE ACEITES','','','','','','','','','','','','',analisis,recomen,rutaLocal,rutaRemota,servidor,usuario,clave,0,numPruebasE.toString(),1, macro.toString(), rutaLogo, logo, numPruebas.toString())
              reportes.push(argsLinea)   
              argsLinea=this.crearLinea('','','','INFORME DE LABORATORIO DE ACEITES - PRUEBAS ESPECIALES','','','','','','','','','','','','','','',rutaLocal,rutaRemota,servidor,usuario,clave,0,numPruebasE.toString(),1, macro.toString(), rutaLogo, logo, numPruebas.toString())
              reportes.push(argsLinea)   
              argsLinea=this.crearLinea('','','','NUMERO DE INFORME:' + list[iiii].numeroInflab + '-' + list[iiii].mecInflab,'','','','','','','','', '','','','','','','','','','','',0,'',2,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('INFORMACION CLIENTE','', 'EMPRESA',list[iiii].descrEmpresa, '', 'INFORMACION DE EQUIPO', 'SECCION', list[iiii].descrSeccion,'','INFORMACION', 'OT', numOrden, '','', '','','','','','','','','',0,'',3,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('','','CONTACTO',contacto,'','','EQUIPO',list[iiii].descrEquipo,'','','OT SAP:', numOrdenSAP,'','','','','','','','','','','',0,'',4,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('','','MAIL',mail,'','','CODIGO EQUIPO',list[iiii].codEquipo,'','', 'FECHA DE ENVIO INFORME', fecCliente, '','','','','','','','','','','',0,'',5,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('','','TELEFONO',telefono,'','','COMPONENTE',list[iiii].descrComponente,'','','QR TOMA DE MUESTRA:', '', '','','','','','','','','','','',0,'',6,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('','','PLANTA',list[iiii].descrPlanta,'','','MECANISMO',list[iiii].descrMecanismo,'','', '', '', '','','','','','','','','','','',0,'',7,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('INFORMACION CLIENTE','EMPRESA',list[iiii].descrEmpresa, '', 'INFORMACION DE EQUIPO', 'SECCION', list[iiii].descrSeccion,'','INFORMACION', '', 'OT', '', numOrden, '', '','','','','','','','','',0,'Pruebas especiales',3,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('','CONTACTO',contacto,'','','EQUIPO',list[iiii].descrEquipo,'','','','OT SAP:', '', numOrdenSAP,'','','','','','','','','','',0,'Pruebas especiales',4,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('','MAIL',mail,'','','CODIGO EQUIPO',list[iiii].codEquipo,'','', '','FECHA DE ENVIO INFORME', '', fecCliente, '','','','','','','','','','',0,'Pruebas especiales',5,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('','TELEFONO',telefono,'','','COMPONENTE',list[iiii].descrComponente,'','','','QR TOMA DE MUESTRA:', '', '', '','','','','','','','','','',0,'Pruebas especiales',6,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('','PLANTA',list[iiii].descrPlanta,'','','MECANISMO',list[iiii].descrMecanismo,'','', '', '', '','','','','','','','','','','','',0,'Pruebas especiales',7,'','','','')
              reportes.push(argsLinea)

              argsLinea=this.crearLinea('RESULTADOS DE LABORATORIO DE ACEITES','','','','','','','','','','','','','','','','','','','','','','',0,'',8,'','','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Descripción','','','Norma','Aceite nuevo','Alarma','Peligro','Resultados','','','','Variación','','','','','','','','','','','',0,'',9,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('No. Informe','','','','','','',list[iiii].inf1,list[iiii].inf2,list[iiii].inf3,list[iiii].numeroInflab.toString() + '-' + list[iiii].mecInflab.toString(),'','','','','','','','','','','','',0,'',10,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Estado','','','','','','',list[iiii].est1,list[iiii].est2,list[iiii].est3,estadoLub,'','','','','','','','','','','','',0,'',11,'','','','')
              reportes.push(argsLinea)
              // argsLinea=this.crearLinea('Fabricante del Aceite','','','','','','','',list[iiii].fab1,list[iiii].fab2,list[iiii].fab3,list[iiii].descrFabricante,'','','','','','','','','','','',0,'',12,'','','','')
              // reportes.push(argsLinea)
              argsLinea=this.crearLinea('Nombre del Aceite','','','','','','',list[iiii].lub1,list[iiii].lub1,list[iiii].lub3,list[iiii].descrLubricante,'','',ficha,'','','','','','','','','',0,'',13,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Grado','','','','','','',list[iiii].gra1,list[iiii].gra2,list[iiii].gra3,list[iiii].tipoGrado + ' ' + list[iiii].descrGrado,'','','','','','','','','','','','',0,'',14,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Fecha de toma de muestra','','','','','','',list[iiii].fec1,list[iiii].fec2,list[iiii].fec3,list[iiii].fechaMuestra,'','','','','','','','','','','','',0,'',15,'','','','')
              reportes.push(argsLinea)          
              // argsLinea=this.crearLinea('Fecha envío muestra a laboratorio','','','','','','','',list[iiii].fecEnv1,list[iiii].fecEnv2,list[iiii].fecEnv3,fecEnvio,'','','','','','','','','','','',0,'',16,'','','','')
              // reportes.push(argsLinea)          
              // argsLinea=this.crearLinea('Fecha recibe muestra laboratorio','','','','','','','',list[iiii].fecRec1,list[iiii].fecRec2,list[iiii].fecRec3,fecRecibe,'','','','','','','','','','','',0,'',17,'','','','')
              // reportes.push(argsLinea)          
              // argsLinea=this.crearLinea('Fecha envío informe a cliente','','','','','','','',list[iiii].fecCli1,list[iiii].fecCli2,list[iiii].fecCli3,fecCliente,'','','','','','','','','','','',0,'',18,'','','','')
              // reportes.push(argsLinea)          
              // argsLinea=this.crearLinea('Tiempo de entrega del informe (Días)','','','','','','','',list[iiii].diasEnt1,list[iiii].diasEnt2,list[iiii].diasEnt3,list[iiii].diasEnt,'','','','','','','','','','','',0,'',19,'','','','')
              // reportes.push(argsLinea)          
              // argsLinea=this.crearLinea('Tiempo logística de la muestra (Días)','','','','','','','',list[iiii].diasLog1,list[iiii].diasLog2,list[iiii].diasLog3,list[iiii].diasLog,'','','','','','','','','','','',0,'',20,'','','','')
              // reportes.push(argsLinea)
              // argsLinea=this.crearLinea('Toma de muestra del Aceite','','',list[iiii].tipoFrecuencia,'','','','',list[iiii].mue1,list[iiii].mue2,list[iiii].mue3,list[iiii].tomaMuestra,'','','','','','','','','','','',0,'',21,'','','','')
              // reportes.push(argsLinea)
              argsLinea=this.crearLinea('Ultimo cambio de Aceite','','','','','','',list[iiii].ult1,list[iiii].ult2,list[iiii].ult3,list[iiii].ultimoCambio,'','','','','','','','','','','','',0,'',22,'','','','')
              reportes.push(argsLinea)              
              argsLinea=this.crearLinea('Recorrido del aceite','','','','','','',list[iiii].rec1,list[iiii].rec2,list[iiii].rec3,reco,'','','','','','','','','','','','',0,'',23,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Cambio del filtro de aceite','','','','','','',list[iiii].fil1,list[iiii].fil2,list[iiii].fil3,list[iiii].cambioFiltroAc,'','','','','','','','','','','','',0,'',24,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Cambio del filtro de aire','','','','','','',list[iiii].aire1,list[iiii].aire2,list[iiii].aire3,list[iiii].cambioFiltroAire,'','','','','','','','','','','','',0,'',25,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Volumen de aceite de reposición','','','','','','',rep1.replace(".", ","),rep2.replace(".", ","),rep3.replace(".", ","),aceiteR.replace(".", ","),'','','','','','','','','','','','',0,'',26,'','','','')
              reportes.push(argsLinea)
              // argsLinea=this.crearLinea('Volumen de cambio de aceite','','',list[iiii].abrevUnidad,'','','','',tot1.replace(".", ","),tot2.replace(".", ","),tot3.replace(".", ","),aceiteT.replace(".", ","),'','','','','','','','','','','',0,'',27,'','','','')
              // reportes.push(argsLinea)
              argsLinea=this.crearLinea('Descripción','','Unidad','Norma','Confiable','Precaución','Alarma','Peligro','Aceite nuevo','Resultados','','','','Variación','','','','','','','','','',0,'Pruebas especiales',9,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('No. Informe','','','','','','','','',list[iiii].inf1,list[iiii].inf2,list[iiii].inf3,list[iiii].numeroInflab.toString() + '-' + list[iiii].mecInflab.toString(),'','','','','','','','','','',0,'Pruebas especiales',10,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Estado','','','','','','','','',list[iiii].est1,list[iiii].est2,list[iiii].est3,estadoLub,'','','','','','','','','','',0,'Pruebas especiales',11,'','','','')
              reportes.push(argsLinea)
              // argsLinea=this.crearLinea('Fabricante del Aceite','','','','','','','','',list[iiii].fab1,list[iiii].fab2,list[iiii].fab3,list[iiii].descrFabricante,'','','','','','','','','','',0,'Pruebas especiales',12,'','','','')
              // reportes.push(argsLinea)
              argsLinea=this.crearLinea('Nombre del Aceite','','','','','','','','',list[iiii].lub1,list[iiii].lub1,list[iiii].lub3,list[iiii].descrLubricante,'',ficha,'','','','','','','','',0,'Pruebas especiales',13,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Grado','','','','','','','','',list[iiii].gra1,list[iiii].gra2,list[iiii].gra3,list[iiii].tipoGrado + ' ' + list[iiii].descrGrado,'','','','','','','','','','',0,'Pruebas especiales',14,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Fecha de toma de muestra','','','','','','','','',list[iiii].fec1,list[iiii].fec2,list[iiii].fec3,list[iiii].fechaMuestra,'','','','','','','','','','',0,'Pruebas especiales',15,'','','','')
              reportes.push(argsLinea)          
              // argsLinea=this.crearLinea('Fecha envío muestra a laboratorio','','','','','','','','',list[iiii].fecEnv1,list[iiii].fecEnv2,list[iiii].fecEnv3,fecEnvio,'','','','','','','','','','',0,'Pruebas especiales',16,'','','','')
              // reportes.push(argsLinea)          
              // argsLinea=this.crearLinea('Fecha recibe muestra laboratorio','','','','','','','','',list[iiii].fecRec1,list[iiii].fecRec2,list[iiii].fecRec3,fecRecibe,'','','','','','','','','','',0,'Pruebas especiales',17,'','','','')
              // reportes.push(argsLinea)          
              // argsLinea=this.crearLinea('Fecha envío informe a cliente','','','','','','','','',list[iiii].fecCli1,list[iiii].fecCli2,list[iiii].fecCli3,fecCliente,'','','','','','','','','','',0,'Pruebas especiales',18,'','','','')
              // reportes.push(argsLinea)  
              // argsLinea=this.crearLinea('Tiempo de entrega del informe (Días)','','','','','','','','',list[iiii].diasEnt1,list[iiii].diasEnt2,list[iiii].diasEnt3,list[iiii].diasEnt,'','','','','','','','','','',0,'Pruebas especiales',19,'','','','')
              // reportes.push(argsLinea)          
              // argsLinea=this.crearLinea('Tiempo logística de la muestra (Días)','','','','','','','','',list[iiii].diasLog1,list[iiii].diasLog2,list[iiii].diasLog3,list[iiii].diasLog,'','','','','','','','','','',0,'Pruebas especiales',20,'','','','')
              // reportes.push(argsLinea)
              // argsLinea=this.crearLinea('Toma de muestra del Aceite','',list[iiii].tipoFrecuencia,'','','','','','',list[iiii].mue1,list[iiii].mue2,list[iiii].mue3,list[iiii].tomaMuestra,'','','','','','','','','','',0,'Pruebas especiales',21,'','','','')
              // reportes.push(argsLinea)
              argsLinea=this.crearLinea('Ultimo cambio de Aceite','',list[iiii].tipoFrecuencia,'','','','','','',list[iiii].ult1,list[iiii].ult2,list[iiii].ult3,list[iiii].ultimoCambio,'','','','','','','','','','',0,'Pruebas especiales',22,'','','','')
              reportes.push(argsLinea)              
              argsLinea=this.crearLinea('Recorrido del aceite','',list[iiii].tipoFrecuencia,'','','','','','',list[iiii].rec1,list[iiii].rec2,list[iiii].rec3,reco,'','','','','','','','','','',0,'Pruebas especiales',23,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Cambio del filtro de aceite','','','','','','','','',list[iiii].fil1,list[iiii].fil2,list[iiii].fil3,list[iiii].cambioFiltroAc,'','','','','','','','','','',0,'Pruebas especiales',24,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Cambio del filtro de aire','','','','','','','','',list[iiii].aire1,list[iiii].aire2,list[iiii].aire3,list[iiii].cambioFiltroAire,'','','','','','','','','','',0,'Pruebas especiales',25,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Volumen de aceite de reposición','',list[iiii].abrevUnidad,'','','','','','',rep1.replace(".", ","),rep2.replace(".", ","),rep3.replace(".", ","),aceiteR.replace(".", ","),'Gráfica','','','','','','','','','',0,'Pruebas especiales',26,'','','','')
              reportes.push(argsLinea)
              // argsLinea=this.crearLinea('Volumen de cambio de aceite','',list[iiii].abrevUnidad,'','','','','','',tot1.replace(".", ","),tot2.replace(".", ","),tot3.replace(".", ","),aceiteT.replace(".", ","),'Gráfica','','','','','','','','','',0,'Pruebas especiales',27,'','','','')
              // reportes.push(argsLinea)

              let notasInf = "* Los valores de alarma y peligro son ajustados de acuerdo a la experiencia del laboratorio."
              notasInf+= "\n" + "* Los valores reportados en el presente informe dependen de la correcta toma de muestra que realizó el cliente."
              notasInf+= "\n" + "* Los valores de alarma y de peligro se encuentran fuera de la acreditación bajo la norma ISO 17025."

              argsLinea=this.crearLinea('Nota','','','','','','','','','','','','','','','','','','','','','','',0,'',68,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea(notasInf,'','','','','','','','','','','','','','','','','','','','','','',0,'',69,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Firma Gerente Laboratorio','','','','','','Firma Lider de Laboratorio','','','','','','','','','','','','','','','','',0,'',70,'','','','')
              reportes.push(argsLinea)

              argsLinea=this.crearLinea('Nota','','','','','','','','','','','','','','','','','','','','','','',0,'Pruebas especiales',68,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea(notasInf,'','','','','','','','','','','','','','','','','','','','','','',0,'Pruebas especiales',69,'','','','')
              reportes.push(argsLinea)
              argsLinea=this.crearLinea('Firma Gerente Laboratorio','','','','','','Firma Lider de Laboratorio','','','','','','','','','','','','','','','','',0,'Pruebas especiales',70,'','','','')
              reportes.push(argsLinea)

              let actinfLab = [], actinfLabMany = [], actinfLabMany1 = []
              let argsUpd = {}
              reportes.forEach((elemento2, ii) => {
                if(elemento2.columna26){
                  argsUpd = {
                    "mecInflab": list[iiii].mecInflab,
                    "columna1": elemento2.columna1,
                    "columna2": elemento2.columna2,
                    "columna3": elemento2.columna3,
                    "columna4": elemento2.columna4,
                    "columna5": elemento2.columna5,
                    "columna6": elemento2.columna6,
                    "columna7": elemento2.columna7,
                    "columna8": elemento2.columna8,
                    "columna9": elemento2.columna9,
                    "columna10": elemento2.columna10,
                    "columna11": elemento2.columna11,
                    "columna12": elemento2.columna12,
                    "columna13": elemento2.columna13,
                    "columna14": elemento2.columna14,
                    "columna15": elemento2.columna15,
                    "columna16": elemento2.columna16,
                    "columna17": elemento2.columna17,
                    "columna18": elemento2.columna18,
                    "columna19": elemento2.columna19,
                    "columna20": elemento2.columna20,
                    "columna21": elemento2.columna21,
                    "columna22": elemento2.columna22,
                    "columna23": elemento2.columna23,
                    "columna24": elemento2.columna24,
                    "columna25": elemento2.columna25,
                    "columna26": elemento2.columna26,
                    "columna27": elemento2.columna27,
                    "columna28": elemento2.columna28,
                    "columna29": elemento2.columna29,
                    "columna30": elemento2.columna30,
                  }
                  actinfLab.push(argsUpd)
                }
              })
              actinfLab.forEach((elementoRep, ii) => {
                actinfLabMany.push(elementoRep)
              })
              actinfLabMany1.push({inflab: actinfLabMany})

              let numDocCRUD = 0
              let totDocCRUD = actinfLabMany1.length
              let argsCrud = []
              let crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.editInflabMany)
              }
              argsCrud[numDocCRUD] = actinfLabMany1[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editInflabMany
              if(totDocCRUD>0){
                await this.updColeccRep(crudColecc, argsCrud, totDocCRUD)
              }
              argsUpdEst['estado'] = estadoLub
              argsUpdEst['codigoPar'] = codPar
              updColeccEst.push(argsUpdEst)
              argsUpdEst = {}
              
              numDocCRUD = 0
              totDocCRUD = 1
              argsCrud = []
              crudColecc = []
              for(let iii=0; iii<totDocCRUD; iii++){
                argsCrud.push({ctrlCampo: 'NO_CRUD'})
              }
              for(let iii=0; iii<totDocCRUD; iii++){
                crudColecc.push(this.props.editInflab)
              }
              argsCrud[numDocCRUD] = updColeccEst[0]
              argsCrud[numDocCRUD]['ctrlCampo'] = 'MANY'
              argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
              crudColecc[numDocCRUD] = this.props.editInflab
              await this.updColecc(crudColecc, argsCrud, totDocCRUD)
              
              if(iiii===list.length-1){
                await this.props.allInflabRtes2.refetch()
                await this.props.allInflabRtes1.refetch()  
                document.body.style.cursor = 'default'

                alert("!! Proceso finalizado !!")
              }
            }
          }  
        })
      }
    }
  }else{
    alert("!! Alguna de las muestras seleccionadas no han sido recibidas en el laboratorio !!")
  }
}

  handleSubmit = async (ev, list, estado)=>{
    let numeroOrden = 0
    let numeroRuta =0
    let descrTarea=''
    let control='S'

    if(list.length>0){
      for (let j=0;j<list.length;j++){
        if(estado==='FINALIZADO' && list[j].estadoInflab==='GENERADO' && (!list[j].estadoEnvio || list[j].estadoEnvio==='Sin enviar')){
          control='N'
        }
      }
    }
    if(list.length>0 && control==='S'){

      await list.forEach(async (elemento, ii) => {
        let movColecc = []
        let argsUpd = {
          "_id": elemento._id,
          "tipoAct": 'EditarInf2',
          "estadoInflab": estado,
          "estadoEnvio": 'Recibida',
        }
        movColecc.push(argsUpd)

        let numDocCRUD = 0
        let totDocCRUD = 1
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editInflab)
        }

        argsCrud[numDocCRUD] = movColecc[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editInflab

        await this.updColecc(crudColecc, argsCrud, totDocCRUD)

        if(estado==='FINALIZADO'){
          let argsUpdEst = {}, updColeccMec = []

          argsUpdEst['descrEmpresa'] = elemento.descrEmpresa
          argsUpdEst['descrPlanta'] = elemento.descrPlanta
          argsUpdEst['descrSeccion'] = elemento.descrSeccion
          argsUpdEst['descrEquipo'] = elemento.descrEquipo
          argsUpdEst['descrComponente'] = elemento.descrComponente
          argsUpdEst['descrMecanismo'] = elemento.descrMecanismo
          argsUpdEst['estado'] = elemento.estado
          argsUpdEst['ultInforme'] = elemento.mecInflab
          argsUpdEst['nomArchivo'] = `${elemento.numeroInflab}-${elemento.mecInflab}.pdf`
          argsUpdEst['tipoAct'] = "EditarEstadoMecanismo"
          updColeccMec.push(argsUpdEst)
          argsUpdEst = {}
          let numDocCRUD = 0
          let totDocCRUD = 1
          let argsCrud = []
          let crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editPlantaUpdSeccion)
          }  

          argsCrud[numDocCRUD] = updColeccMec[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editPlantaUpdSeccion
          await this.updColecc(crudColecc, argsCrud, totDocCRUD)

          let movColecc = []
          let argsUpd = {
            "tipoAct": 'EditarArch',
            "nomArchivo": `${elemento.numeroInflab}-${elemento.mecInflab}.pdf`,
            "mecInflab": elemento.mecInflab
          }
          movColecc.push(argsUpd)
          numDocCRUD = 0
          totDocCRUD = 1
          argsCrud = []
          crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editInflab)
          }

          argsCrud[numDocCRUD] = movColecc[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editInflab

          await this.updColecc(crudColecc, argsCrud, totDocCRUD)

        }

        let argsBuscar=""
        const argsDocum=this.state.argsDocum
        let numeroInflab=argsDocum.numeroInflab

        await this.props.allInflabRtes1.refetch() 
  
        numeroInflab=this.props.allInflabRtes1.allInflabRtes.length>0?this.props.allInflabRtes1.allInflabRtes[0].numeroInflab:0
        argsDocum['numeroInflab'] = numeroInflab
        this.setState({argsDocum, numeroInflab});  
       
        argsBuscar += `'estadoInflab': '${this.props.opcion}', 'numeroInflab': ${numeroInflab}`
        let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
        await this.props.allInflabRtes2.refetch(argsBuscarIl)
        await this.props.allInflabRtes3.refetch()       
      })
    }else{
      alert("!! Alguna de las muestras seleccionadas no han sido recibidas en laboratorio o entregadas al cliente !!")
    }
    this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, open: false, confirmaAct: false})
  }

  handleEliminar = async(ev, list1)=>{
    
    let list = await list1.filter(elemento => elemento.checkSeleccInf === true)
    if(list.length>0){
      document.body.style.cursor = 'wait'
    }

    for (let iiii=0;iiii<list.length;iiii++){
        let delColecc = []
        let argsDel = {
          _id: list[iiii]._id
        }
        delColecc.push(argsDel)
  
    //GRABAR EN BD
        let numDocCRUD = 0
        let totDocCRUD = 1
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.deleteInflab)
        }
  
        argsCrud[numDocCRUD] = delColecc[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.deleteInflab

        await this.updColecc(crudColecc, argsCrud, totDocCRUD)
  
    } 
    let argsBuscar=""
    const argsDocum=this.state.argsDocum
    let numeroInflab=argsDocum.numeroInflab
    if(list.length===list1.length){
      await this.props.allInflabRtes1.refetch() 

      numeroInflab=this.props.allInflabRtes1.allInflabRtes.length>0?this.props.allInflabRtes1.allInflabRtes[0].numeroInflab:0
      argsDocum['numeroInflab'] = numeroInflab

      this.setState({argsDocum});  
    }  
    argsBuscar += `'estadoInflab': '${this.props.opcion}', 'numeroInflab': ${numeroInflab}`
    let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
    await this.props.allInflabRtes2.refetch(argsBuscarIl)
    await this.props.allInflabRtes3.refetch() 
    
    document.body.style.cursor = 'default'
    this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true, open: false, confirmaAct: false})
  }

  handleQuestionUpdDel = async (ev, btn) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false, permiteBtn3: btn==="3"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true})
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true, permiteBtn3: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false, permiteBtn3: btn==="3"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  componentDidMount(){
    if(this.props.allInflabRtes1.allInflabRtes){
      if(this.props.allInflabRtes1.allInflabRtes.length>0){
        let numeroInflab = 0
        if(this.state.numeroInflab===0){
          numeroInflab = this.props.allInflabRtes1.allInflabRtes[0].numeroInflab
        }else{
          numeroInflab = this.state.numeroInflab
        }
        let argsBuscar=""
        argsBuscar += `'estadoInflab': '${this.props.opcion}', 'numeroInflab': ${numeroInflab}`
        let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
        this.props.allInflabRtes2.refetch(argsBuscarIl)
       
        const argsDocum = this.state.argsDocum
        argsDocum['numeroInflab'] = numeroInflab
        this.setState({argsDocum, numeroInflab})
      }
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.allInflabRtes2.allInflabRtes&&prevProps.allInflabRtes2.allInflabRtes){
      if((this.props.allInflabRtes2.allInflabRtes!==prevProps.allInflabRtes2.allInflabRtes)||!this.state.list){
        this.setState({list: 
          this.props.allInflabRtes2.allInflabRtes?this.props.allInflabRtes2.allInflabRtes.map((elemento, i) => ({
            ...elemento, checkSeleccInf: true
          })):[]
        })

        this.setState({checkSeleccInfAll: true});
      }
    }

    if(this.props.allInflabRtes1.allInflabRtes){
      if(this.props.allInflabRtes1.allInflabRtes.length>0){
        let numeroInflab = 0
        if(this.state.numeroInflab===0){
          numeroInflab = this.props.allInflabRtes1.allInflabRtes[0].numeroInflab
        }else{
          numeroInflab = this.state.numeroInflab
        }
        let argsBuscar=""
        argsBuscar += `'estadoInflab': '${this.props.opcion}', 'numeroInflab': ${numeroInflab}`
        let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
        this.props.allInflabRtes2.refetch(argsBuscarIl)
      }
    }
  }

  render(){
    const {argsDocum, numeroInflab, list, checkSeleccInfAll, permiteBtn1, permiteBtn2, permiteBtn3, confirmaAct, open, errors} = this.state;

    const a102005 = this.props.autorizacUA.findIndex( autorizac => autorizac === "102005" );
    const a102010 = this.props.autorizacUA.findIndex( autorizac => autorizac === "102010" );
    const a102015 = this.props.autorizacUA.findIndex( autorizac => autorizac === "102015" );
    const a102020 = this.props.autorizacUA.findIndex( autorizac => autorizac === "102020" );
    const a102025 = this.props.autorizacUA.findIndex( autorizac => autorizac === "102025" );

    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})

    let mensaje1 = "FINALIZAR INFORME"
    let mensaje2 = "ELIMINAR REPORTES"
    let mensaje3 = "REVERSAR FINALIZADO"

    let imgIcon1 = "images/archivo_32.png"
    let imgIcon2 = "images/marca-de-verificacion_32.png"
    let imgIcon3 = "images/archivo_32.png"
    let archMacro = "PERSONAL.xlsb"
    let list2 = []
    let numInflab = numeroInflab

    if(this.props.allInflabRtes1.allInflabRtes){list2 = this.props.allInflabRtes1.allInflabRtes}
    if(numInflab===0 && list2.length>0){
      numInflab=list2[0].numeroInflab
    }
    return (
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={confirmaAct
            ?permiteBtn1
              ?(ev)=>this.handleSubmit(ev, list, 'FINALIZADO')
              :
              permiteBtn2
                ?(ev)=>this.handleEliminar(ev, list)
                :
                  permiteBtn3
                  ?(ev)=>this.handleSubmit(ev, list, 'GENERADO')
                  :()=>{}                
            :()=>{}}
          >         
          {this.props.opcion==='GENERADO' &&
            <div className="ui five column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '10%'}}>
                  <Form.Field>
                    <ListaNuminf styles={this.props.styles} list={list2} numeroInflab={numInflab} handleChange={this.handleChange} />
                  </Form.Field>
                </div>
                {a102005!==-1 &&
                  <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                    <Button id="procesar" name="procesar" style={this.props.styles.confirmar} onClick={(ev)=>this.handleProcRes(ev, list)} fluid>
                      Procesar resultados
                    </Button>
                  </div>
                }
                {a102010!==-1 &&
                  <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                    <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleGenRte(ev, list)} fluid>
                      Generar reporte
                    </Button>
                  </div>
                }
                {(a102015!==-1 && permiteBtn1) &&
                  <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                    <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} 
                      open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
                  </div>
                }
                {(a102020!==-1 && permiteBtn2) &&
                  <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                    <EstaSeg7Btn mensaje2={mensaje2} imgIcon2={imgIcon2} 
                      open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "2")}/>
                  </div>
                }   
                {a102010!==-1 &&
                  <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                      <a href='images/documentos/PERSONAL.xlsb' target="_blank">
                        Descargar macro
                      </a>
                      <hr></hr>
                      <a href='images/logos/LCMSAS.png' target="_blank">
                        Descargar logo de LCM
                      </a>
                  </div>
                }        
                {/* {a102010!==-1 &&
                  <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                      <a href='images/logos/LCMSAS.png' target="_blank">
                        Descargar logo de LCM
                      </a>
                  </div>
                }         */}
              </div>
            </div>
          }
          {this.props.opcion==='FINALIZADO' &&
            <div className="ui four column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '19%'}}>
                  <Form.Field>
                  <ListaNuminf styles={this.props.styles} list={list2} numeroInflab={numInflab} handleChange={this.handleChange} />
                  </Form.Field>
                </div>
                {a102010!==-1 &&
                  <div className="column" style={{width: '18%', paddingTop: '0.3em'}}>
                    <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleGenRte(ev, list)} fluid>
                      Generar reporte
                    </Button>
                  </div>
                }                
                {(a102025!==-1 && permiteBtn3) &&
                  <div className="column" style={{width: '21%', paddingTop: '0.3em'}}>
                    <EstaSeg7Btn mensaje3={mensaje3} imgIcon3={imgIcon3} 
                      open={open}
                      styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "3")}/>
                  </div>
                }              
              </div>
            </div>
          }            
          <hr></hr>
            <div>
              <div style={{height: '16em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Inf</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Prioridad</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ruta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>OT</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>OT SAP</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cód equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Aplicación</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Nombre del aceite</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Tipo de frecuencia</th>
                    </tr>
                  </thead>
                  <ListaPl list={list} handleClickidLista={this.props.handleClickidLista} numeroInflab={numInflab} />
                </table>
                <p></p>
              </div>
            </div>
            <hr></hr>
            <div>
              <div style={{height: '36em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>
                        <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' name="checkSeleccInfAll" checked={checkSeleccInfAll} onChange={this.handleChange}/>
                        {/* Selecc */}
                      </th>

                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Inf</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha muestra</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Toma de muestra del aceite</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ultimo cambio de aceite</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Recorrido del aceite</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cambio del filtro de aceite</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cambio del filtro de aire</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Volumen de aceite de reposición</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Volumen de cambio de aceite</th>
                      {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Color</th> */}
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Viscosidad, cSt a 40ºC</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Viscosidad, cSt a 100ºC</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Indice de Viscosidad IV</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Agua</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Codigo de particulas</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas {">"} 4 micras</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas {">"} 6 micras</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas {">"} 14 micras</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas {">"} 21 micras</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas {">"} 25 micras</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas {">"} 38 micras</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas {">"} 70 micras</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Hollin</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Nitracion</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sulfatacion'</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Dilución por Combustible</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Glicol</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Oxidacion</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>TAN</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>TBN</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Hierro (Fe)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cobre (Cu)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Aluminio (Al)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cromo (Cr)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Plomo (Pb)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estaño (Sn)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Niquel (Ni)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Vanadio (V)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Titanio (Ti)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Silicio (Si)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sodio (Na)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Potasio (K)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Boro (B)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Magnesio (Mg)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Calcio (Ca)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fosforo (P)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Zinc (Zn)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Molibdeno (Mo)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Bario (Ba)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Manganeso (Mn)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Color</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ruler %</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Aminas %</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fenoles %</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>ZDDP</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>RPVOT</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Barniz MPC</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Dem. aceite</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Dem. agua</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Dem. emulsión</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Dem. tiempo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. aceite a 54</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. agua a 54</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. emulsión a 54</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. tiempo a 54</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. aceite a 82</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. agua a 82</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. emulsión a 82</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. tiempo a 82</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas I 0</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas I 10</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas II 0</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas II 10</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas III 0</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas III 10</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Liberación</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Inflamación</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Corrosión</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ultracentrifuga</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Densidad a 15°C</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Apariencia</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Olor</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Punto de fuego</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Indice PQ</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Agua por Karl Fischer</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>TAN con PTE</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>TBN con PTE</th>
                    </tr>
                  </thead>
                  <ListaPlDet list={list} handleChange={this.handleChange}/>
                </table>
                <p></p>
              </div>
            </div>
            
            {
              errors.length?<Message negative header="Los siguientes errores:"
              list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }

          </Form>
        </div>
      // </div>
    )
  }
};

export default compose( 
  graphql(queries.query.allInflabRtes, {name:'allInflabRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoInflab': '${props.opcion}', 'numeroInflab': 0}}, {$sort: {_id: -1}}]`}}}}),

  graphql(queries.query.allInflabRtes, {name:'allInflabRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoInflab': '${props.opcion}'}},
      {$group: {_id: '$numeroInflab'}}, {$sort: {_id: -1}}, {$project: {'numeroInflab': '$_id'}}]`}}}}),

  graphql(queries.query.allInflabRtes, {name:'allInflabRtes3',
  options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoInflab': 'FINALIZADO', 'numeroInflab': 0}}, {$sort: {_id: -1}}]`}}}}),

  graphql(queries.query.allInflabRtes, {name:'allInflabRtes4',
  options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoInflab': 'FINALIZADO', 'numeroInflab': 0}}, {$sort: {_id: -1}}]`}}}}),

  graphql(queries.query.allMecValRefRtes, {name:'allMecValRefRtes',
  options: (props) => {return {variables: {tipoqry: `[{$match: {'descrEmpresa': 'Seleccionar Empresa...'}}]`}}}}),

  graphql(queries.mutation.editInflab, {name:'editInflab'}),
  graphql(queries.mutation.editInflabMany, {name:'editInflabMany'}),
  graphql(queries.mutation.deleteInflab, {name:'deleteInflab'}),

  graphql(queries.query.allPrueba, {name:'allPrueba', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allPruebaRtes, {name:'allPruebaRtes', 
  options: (props) => {return {variables: {tipoqry: `[{$match: {'tipoPrueba': {$ne: 'Pruebas especiales'}}}]`}}}}),
  graphql(queries.query.allPruebaRtes, {name:'allPruebaRtesE',
  options: (props) => {return {variables: {tipoqry: `[{$match: {'tipoPrueba': 'Pruebas especiales'}}]`}}}}),
  
  graphql(queries.query.allLubricante, {name:'allLubricante'}),
  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  graphql(queries.query.allProducto, {name:'allProducto'}),
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.mutation.createOrden, {name:'createOrden'}),
  graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),  
  graphql(queries.mutation.editPlantaUpdSeccion, {name:'editPlantaUpdSeccion'}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
  graphql(queries.query.getParametro, {name:'getParametro', options: (props) => {return {variables: {}}}}),
  

)(LabGenrte2)
